import $ from 'jquery';
import {Alert, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Toast, Tooltip} from 'bootstrap';
import Sortable from 'sortablejs';
import Swal from 'sweetalert2';
import Dropzone from 'dropzone';
import 'cleave.js';
import 'cleave.js/src/addons/phone-type-formatter.us.js';
import 'lightbox2';
import 'masonry-layout';
import Bloodhound from 'corejs-typeahead';
import SignaturePad from 'signature_pad';
import './jquery.flexdatalist.min.js';

window.$ = $;
window.jQuery = $;

Dropzone.autoDiscover = false;

var timeout_t = 0;
var interval_t = 0;
var interval_counter_initial = 0;
var interval_counter = 0;
var signaturePad = null;

if (typeof tinymce !== 'undefined') {
    tinymce.overrideDefaults({
        theme: 'modern',
        plugins: 'advlist autolink lists link image charmap print preview hr anchor pagebreak searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking save table directionality emoticons paste textpattern noneditable moxiemanager fontawesome bootstrapmedia textcolor',
        menubar: 'edit insert view format table tools help',
        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media youtube | styleselect fontselect fontsizeselect | forecolor backcolor emoticons | preview print | help',
        relative_urls : false,
        remove_script_host : true,
        document_base_url : serverUrl,
        image_advtab: true,
        browser_spellcheck : true,
        contextmenu: false,
        force_hex_style_colors : false,
        element_format : 'html',
        schema: 'html5',
        font_formats: 'Default=inherit;Lato=Lato;',
        fontsize_formats: '10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 28px 32px 36px',
        link_class_list: [
            {title: 'None', value: ''},
        ],
        body_class: 'tinymce',
        content_css : [serverUrl + '/build/css/app.css', 'https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap'],
        valid_elements: '+*[*]',
        noneditable_noneditable_class: 'fa',
        convert_urls: false
    });
}

global.App = {
    allow_non_items: false,
    allowItems: function(value) {
        App.allow_non_items = value;
    },
    init: function (target) {
        if (!target) {
            target = 'body';
        }

        App.syncLabels('.form-label', target);
        App.wysiwyg('textarea.wysiwyg', target);
        App.sortable('.sortable', target);
        App.datalist('.flexdatalist', target);
        App.headlineModal('#page-headline', target);
        App.labelModal('.form-label', target);
        App.formatPhone('input[type="tel"]', target);
        // App.formatDate('input[type="date"]', target);
        App.openPopup('.open-popup', target);

        $('[data-bs-toggle="tooltip"]', target).each(function() {
            new Tooltip($(this));
        });

        $('[data-bs-toggle="popover"]', target).each(function() {
            new Popover($(this));

            $(this).on('click', function() {
                $('[data-bs-toggle="popover"]', target).not(this).popover('hide');
            });
        });

        $('.modal.open', target).each(function() {
            let modal = new Modal($(this));
            modal.show();
        });

        if ($('input.sluggable', target).length) {
            $('input.sluggable', target).on('blur', function() {
                App.slug([this], $(this).data('slug'));
            });
        }

        if (window.location.hash.length) {
            let elements = document.querySelectorAll('[data-bs-toggle="tab"][data-bs-target="' + window.location.hash + '"]');

            if (elements.length) {
                for (const element of elements) {
                    Tab.getOrCreateInstance(element).show();
                }
            }
        }

        App.autoFormDropzone();

        if ($('input.auto-validate-item', target).length) {
            $('input.auto-validate-item', target).each(function() {
                App.autocompleteItem(this);
            })
        }

        App.hideEmptyElement('.hide-if-empty');
    },
    confirm: function (message) {
        if (!message) {
            message = "Are you sure?\nOnce deleted, you will not be able to recover this record!";
        }

        return confirm(message);
    },
    dateRangeBegin: function(selector, target) {
        if ($(selector).val().length) {
            $(target).attr('min', $(selector).val());
        } else {
            $(target).removeAttr('min');
        }
    },
    dateRangeEnd: function(selector, target) {
        if ($(selector).val().length) {
            $(target).attr('max', $(selector).val());
        } else {
            $(target).removeAttr('max');
        }
    },
    slug: function (inputs, target) {
        if ($.trim($(target).val()) === '') {
            let str = '';

            if (typeof inputs === 'string') {
                inputs = [ inputs ];
            }

            $.each(inputs, function(i, v) {
                if ($(v).is('select')) {
                    str = str + ' ' + $(v).children('option:selected').text();
                } else {
                    str = str + ' ' + $(v).val();
                }
            });

            $.getJSON(serverUrl + '/xhr/slug', {
                q: str
            }, function(response) {
                if (response.slug) {
                    $(target).val(response.slug);
                }
            });
        }
    },
    toggleClass: function(selector, what) {
        if (!Array.isArray(selector)) {
            selector = [selector];
        }

        $.each(selector, function() {
            $(this).toggleClass(what);
        });
    },
    sortable: function (selector, target) {
        if (!target) {
            target = 'body';
        }

        if (($(selector, target).length) && ($(selector, target).children().length)) {
            $(selector, target).each(function() {
                new Sortable(this, {
                    handle: '.drag-handle',
                    draggable: '.drag-item'
                });
            });
        }
    },
    datalist: function(selector, target) {
        if (!target) {
            target = 'body';
        }

        if ($(selector, target).length > 0) {
            $(selector, target).flexdatalist({
                minLength: 0,
                valueProperty: '*',
                noResultsText: '',
                searchContain: true
            });
        }
    },
    wysiwyg: function (selector, target) {
        if (!target) {
            target = 'body';
        }

        if ((typeof tinymce !== 'undefined') && $(selector, target).length) {
            $(selector, target).each(function() {
                if ($('#' + $(this).attr('id') + '_plain').length === 1) {
                    // $(this).parent().prepend($('<div/>', {
                    //     class: 'form-check form-switch mb-2'
                    // }).append($('<input/>', {
                    //     type: 'hidden',
                    //     value: '0',
                    //     checked: 'checked',
                    //     name: $(this).attr('name') + '[plain]',
                    // })).append($('<input/>', {
                    //     type: 'checkbox',
                    //     class: 'form-check-input',
                    //     value: '1',
                    //     id: $(this).attr('id') + '_plain',
                    //     name: $(this).attr('name') + '[plain]',
                    //     onclick: 'App.toggleWysiwyg(this, \'' + $(this).attr('id') + '\', false)'
                    // })).append($('<label/>', {
                    //     clas: 'form-check-label',
                    //     for: $(this).attr('id') + '_plain',
                    //     text: ' Rich Text (HTML)',
                    // })));
                    //
                    // if (!$('#' + $(this).attr('id')).hasClass('plaintext')) {
                    //     $('#' + $(this).attr('id') + '_plain').prop('checked', true);
                    //     tinymce.EditorManager.execCommand('mceToggleEditor', true, $(this).attr('id'));
                    // }
                    if (!$('#' + $(this).attr('id') + '_plain').prop('checked')) {
                        tinymce.EditorManager.execCommand('mceToggleEditor', true, $(this).attr('id'));
                    }
                } else {
                    tinymce.EditorManager.execCommand('mceToggleEditor', true, $(this).attr('id'));
                }
            });
        }
    },
    toggleWysiwyg: function (selector, target, rows) {
        if (typeof tinymce !== 'undefined') {
            if ($(selector).prop('checked')) {
                if (rows !== false) {
                    $('#' + target).attr('rows', 20);
                }

                tinymce.EditorManager.execCommand('mceToggleEditor', true, target);
            } else {
                if (rows !== false) {
                    $('#' + target).attr('rows', 1);
                }

                tinymce.EditorManager.execCommand('mceToggleEditor', false, target);
            }
        }
    },
    formatPhone: function(selector, target) {
        if (!target) {
            target = 'body';
        }

        if ($(selector, target).length > 0) {
            $(selector, target).each(function() {
                new Cleave(
                    $(this),
                    {
                        phone: true,
                        phoneRegionCode: ($(this).data('country') ? $(this).data('country') : 'US')
                    }
                );
            });
        }
    },
    formatPhoneNumber: function(value) {
        if (value.length) {
            const number = value.replace(/[^\d]/g, "");
            const length = number.length;

            if (length < 4) {
                return number;
            } else if (length < 7) {
                return '(' + number.slice(0, 3) + ') ' + number.slice(3);
            } else {
                return '(' + number.slice(0, 3) + ') ' + number.slice(3, 6) + '-' + number.slice(6, 10);
            }
        }

        return value;
    },
    formatDate: function(selector, target) {
        if (!target) {
            target = 'body';
        }

        if ($(selector, target).length > 0) {
            $(selector, target).each(function() {
                new Cleave(
                    $(this),
                    {
                        date: true,
                        delimiter: '/',
                        datePattern: ['m', 'd', 'Y']
                    }
                );
            });
        }
    },
    formatNumber: function(element) {
        const value = element.value;

        if (value.length) {
            element.value = value.replace(/[^\d]/g, "");
        }
    },
    quickDelete: function (selector, message) {
        if (App.confirm(message)) {
            $.post(
                serverUrl + $(selector).attr('href'),
                {
                    'format': 'json'
                },
                function(response) {
                    if (response.success) {
                        $(selector).parents('.template-parent').eq(0).remove();
                    }

                    if (response.error) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }
                },
                'json'
            );
        }

        return false;
    },
    handleSidebar: function(offcanvasId, toggleId) {
        let offcanvas = document.getElementById(offcanvasId);

        offcanvas.addEventListener('hide.bs.offcanvas', function () {
            $('#' + toggleId).removeClass('d-none');
        });
        offcanvas.addEventListener('show.bs.offcanvas', function () {
            $('#' + toggleId).addClass('d-none');
        });
    },
    headlineModal(selector, target) {
        if ($(selector, target).length && $('body').hasClass('has-token-permission')) {
            $(selector, target).before($('<a/>', {
                role: 'button',
                class: 'text-secondary fs-5 align-self-center me-2 d-print-none',
                html: '<i class="fas fa-fw fa-pencil-alt"></i>'
            }).on('click', function() {
                if ($('#modal-form').length) {
                    $('#modal-form').remove();
                }

                $('body').append($('<div/>', {
                    'id': 'modal-form',
                    'class': 'modal fade',
                    'tabindex': '-1',
                    'role': 'dialog',
                    'aria-hidden': 'true',
                    'html': '<div class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title" id="formModalLabel">Change Headline</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"><form method="post" action="#" onsubmit="return App.headlineUpdate(this, \'' + selector + '\')"><div class="input-group input-group-lg"><input type="text" name="headline" class="form-control" value="' + $.trim($(selector).text()).replace(/"/g, '\\x22') + '"><button class="btn btn-outline-primary" type="submit">Save</button></div><input type="hidden" name="url" value="' + window.location.pathname.replace(/"/g, '\\x22') + '"></form></div></div></div>'
                }));

                let modal = Modal.getOrCreateInstance(document.querySelector('#modal-form'));
                modal.show();
            }));
        }
    },
    headlineUpdate: function(form, selector) {
        let btn = $('button[type="submit"]', form).eq(0);

        form = $(form);

        $.post(
            serverUrl + '/xhr/token',
            form.serialize(),
            function(response) {
                if (response) {
                    if (response.error !== undefined) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: (response.button !== undefined ? response.button : 'Close'),
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else {
                        if (response.headline) {
                            $(selector).text(response.headline);
                        } else {
                            window.location.reload();
                        }

                        let modal = Modal.getOrCreateInstance(document.querySelector('#modal-form'));
                        modal.hide();
                    }
                }
            },
            'json'
        );

        return false;
    },
    addMenuItem: function(selector, target) {
        let form = $(selector).eq(0),
            label = $('#menu_item-name', form).eq(0),
            url = $('#menu_item-url', form).eq(0),
            external = $('#menu_item-external', form).eq(0),
            template = $(target).data('template'),
            id = new Date().getTime();

        if ((template !== undefined) && (template !== null)) {
            template = template.replace(/\$INDEX/g, id);
            $(target).append(template);

            $('#menu-caption-' + id).eq(0).html(label.val());
            $('#menu-name-' + id).eq(0).val(label.val());
            $('#menu-url-' + id).eq(0).val(url.val());
            $('#menu-external-' + id).eq(0).prop('checked', external.prop('checked'));
            $('#menu-new-' + id).eq(0).val(1);

            form[0].reset();

            App.sortMenuItems('.menu-sortable');
            App.collapseMenuItemChildren(target + ' .menu-item');
        }

        return false;
    },
    updateMenuItem: function(selector_name, selector_icon) {
        let element = $(selector_name).parents('.card').eq(0),
            caption = $('.card-header > .caption', element).eq(0),
            name = $.trim($(selector_name).val()),
            icon = $.trim($(selector_icon).val());

        caption.html((icon.length ? ('<i class="me-2 ' + icon + '"></i>') : '') + name);
    },
    removeMenuItem: function(selector) {
        $(selector).parents('.menu-item').eq(0).remove().detach();
    },
    moveMenuItemUp: function(selector) {
        let element = $(selector).parents('.menu-item').eq(0),
            parent = element.parent(),
            children = parent.children('.menu-item'),
            index = children.index(element);

        if (index > 0) {
            children.eq(index - 1).before(element);
        }

        return false;
    },
    moveMenuItemDown: function(selector) {
        let element = $(selector).parents('.menu-item').eq(0),
            parent = element.parent(),
            children = parent.children('.menu-item'),
            index = children.index(element);

        if (index < (children.length - 1)) {
            children.eq(index + 1).after(element);
        }

        return false;
    },
    moveMenuItemLeft: function(selector) {
        let element = $(selector).parents('.menu-item').eq(0),
            parent = element.parents('.menu-item').eq(0);

        if (parent && parent.hasClass('menu-item')) {
            let children = parent.parents('.children').eq(0);

            if (children.length) {
                $('.card-body .parent', element).eq(0).val(children.data('id'));
            } else {
                $('.card-body .parent', element).eq(0).val('');
            }

            parent.after(element);
        }

        return false;
    },
    moveMenuItemRight: function(selector) {
        let element = $(selector).parents('.menu-item').eq(0),
            parent = element.prev();

        if (parent && parent.hasClass('menu-item')) {
            let children = parent.children('.children').eq(0);

            $('.card-body .parent', element).eq(0).val(children.data('id'));

            children.append(element);
        }

        return false;
    },
    toggleMenuItem: function(selector) {
        let element = $(selector).parents('.card').eq(0),
            icon = $('.card-header > a > .fas', element).eq(0);

        if (icon.hasClass('fa-angle-double-down')) {
            icon.removeClass('fa-angle-double-down').addClass('fa-angle-double-up');
        } else {
            icon.removeClass('fa-angle-double-up').addClass('fa-angle-double-down');
        }
    },
    toggleMenuItemChildren: function(selector) {
        let icon = $('.fas', $(selector)).eq(0);

        if (icon.hasClass('fa-plus')) {
            icon.removeClass('fa-plus').addClass('fa-minus');
            $(selector).siblings('.children').show();
        } else {
            icon.removeClass('fa-minus').addClass('fa-plus');
            $(selector).siblings('.children').hide();
        }
    },
    collapseMenuItemChildren: function(selector) {
        $(selector).each(function() {
            let icon = $('.fas', $(this).children('.expand').eq(0)).eq(0);

            icon.removeClass('fa-minus').addClass('fa-plus');
            $(this).children('.children').hide();
        });
    },
    expandMenuItemChildren: function(selector) {
        $(selector).each(function() {
            let icon = $('.fas', $(this).children('.expand').eq(0)).eq(0);

            icon.removeClass('fa-plus').addClass('fa-minus');
            $(this).children('.children').show();
        });
    },
    sortMenuItems: function(selector) {
        $(selector).each(function() {
            new Sortable(
                $(this)[0],
                {
                    group: 'nested',
                    handle: '.drag-handle',
                    draggable: '.menu-item',
                    fallbackOnBody: true,
                    onEnd: function (/**Event*/e) {
                        let parent = $(e.item).parents('.children').eq(0);

                        if (parent.length) {
                            $('.card-body .parent', $(e.item)).eq(0).val(parent.data('id'));
                        }
                    }
                }
            );
        });
    },
    checkSameAs: function(target, selector) {
        let element = $(selector);

        element.removeClass('is-valid').removeClass('is-invalid');

        if (element.val().length || $(target).val().length) {
            if (element.val() == $(target).val()) {
                element.addClass('is-valid');
            } else {
                element.addClass('is-invalid');
            }
        }
    },
    storeByMarket: function(target, selector, preserve, checkboxes) {
        let market = $(selector).val(),
            store = $(target),
            value = false;

        if (preserve === true) {
            value = store.val();
        }

        $('option', store).filter(function() {
            return ($(this).attr('value') != '');
        }).remove();

        if (checkboxes) {
            for (let index = 0; index < checkboxes.length; index++) {
                $(checkboxes[index].container + ' .form-check').remove();
            }
        }

        $.getJSON(
            serverUrl + '/xhr/store_by_market',
            {
                'market': market
            },
            function(response) {
                if (response.stores) {
                    $.each(response.stores, function(i, v) {
                        store.append($('<option/>', {
                            value: i,
                            text: v
                        }));
                    });

                    if (checkboxes) {
                        for (let index = 0; index < checkboxes.length; index++) {
                            $.each(response.stores, function(i, v) {
                                $(checkboxes[index].container + ' .form-input').append($('<div/>', {
                                    class: 'form-check'
                                }).append($('<input/>', {
                                    type: 'checkbox',
                                    class: 'form-check-input',
                                    id: checkboxes[index].container.substring(1) + '-' + i,
                                    name: checkboxes[index].field,
                                    value: i
                                }).prop('checked', checkboxes[index].value && (checkboxes[index].value.indexOf(parseInt(i)) !== -1))).append($('<label/>', {
                                    for: checkboxes[index].container.substring(1) + '-' + i,
                                    text: v
                                })));
                            });
                        }
                    }

                    if (value !== false) {
                        store.val(value);
                    }
                }
            }
        );
    },
    vehicleWizard: function(type, make, model, year, qualifier1, qualifier2, qualifier3, qualifier4, submit) {
        let myMake = $(make),
            myModel = $(model),
            myYear = $(year),
            myQualifier1 = $(qualifier1),
            myQualifier2 = $(qualifier2),
            myQualifier3 = $(qualifier3),
            myQualifier4 = $(qualifier4),
            mySubmit = $(submit),
            myChildren = [],
            params = {
                'action': 'wizard'
            },
            current = false;

        if (type == 'year') {
            current = myYear;
            myChildren.push(myMake, myModel, myQualifier1, myQualifier2, myQualifier3, myQualifier4);
            params = {
                'action': 'wizard',
                'year': myYear.val()
            };
        } else if (type == 'make') {
            current = myMake;
            myChildren.push(myModel, myQualifier1, myQualifier2, myQualifier3, myQualifier4);
            params = {
                'action': 'wizard',
                'year': myYear.val(),
                'make': myMake.val()
            };
        } else if (type == 'model') {
            current = myModel;
            myChildren.push(myQualifier1, myQualifier2, myQualifier3, myQualifier4);
            params = {
                'action': 'wizard',
                'year': myYear.val(),
                'make': myMake.val(),
                'model': myModel.val()
            };
        } else if (type == 'qualifier1') {
            current = myQualifier1;
            myChildren.push(myQualifier2, myQualifier3, myQualifier4);
            params = {
                'action': 'wizard',
                'make': myMake.val(),
                'model': myModel.val(),
                'year': myYear.val(),
                'qualifier1': myQualifier1.val()
            };
        } else if (type == 'qualifier2') {
            current = myQualifier2;
            myChildren.push(myQualifier3, myQualifier4);
            params = {
                'action': 'wizard',
                'make': myMake.val(),
                'model': myModel.val(),
                'year': myYear.val(),
                'qualifier1': myQualifier1.val(),
                'qualifier2': myQualifier2.val()
            };
        } else if (type == 'qualifier3') {
            current = myQualifier3;
            myChildren.push(myQualifier4);
            params = {
                'action': 'wizard',
                'make': myMake.val(),
                'model': myModel.val(),
                'year': myYear.val(),
                'qualifier1': myQualifier1.val(),
                'qualifier2': myQualifier2.val(),
                'qualifier3': myQualifier3.val()
            };
        } else if (type == 'qualifier4') {
            current = myQualifier4;
            params = {
                'action': 'wizard',
                'make': myMake.val(),
                'model': myModel.val(),
                'year': myYear.val(),
                'qualifier1': myQualifier1.val(),
                'qualifier2': myQualifier2.val(),
                'qualifier3': myQualifier3.val(),
                'qualifier4': myQualifier4.val()
            };
        }

        for (let i = 0; i < myChildren.length; i++) {
            myChildren[i].children('option[value!=""]').remove();
            myChildren[i].parents('.form-group').addClass('d-none');
        }

        mySubmit.addClass('d-none');

        if (current.val()) {
            if (myChildren.length) {
                $.getJSON(
                    '/xhr/fitguide/',
                    params,
                    function (response) {
                        let found = false;

                        if (response.makes) {
                            $.each(response.makes, function (i, value) {
                                myMake.append($('<option/>', {
                                    'value': value,
                                    'html': value
                                }));
                            });

                            myMake.parents('.form-group').removeClass('d-none');
                            found = true;
                        }

                        if (response.models) {
                            $.each(response.models, function (i, value) {
                                myModel.append($('<option/>', {
                                    'value': value,
                                    'html': value
                                }));
                            });

                            myModel.parents('.form-group').removeClass('d-none');
                            found = true;
                        }

                        if (response.qualifiers1) {
                            $.each(response.qualifiers1, function (i, value) {
                                myQualifier1.append($('<option/>', {
                                    'value': value,
                                    'html': value
                                }));
                            });

                            myQualifier1.parents('.form-group').removeClass('d-none');
                            found = true;
                        }

                        if (response.qualifiers2) {
                            $.each(response.qualifiers2, function (i, value) {
                                myQualifier2.append($('<option/>', {
                                    'value': value,
                                    'html': value
                                }));
                            });

                            myQualifier2.parents('.form-group').removeClass('d-none');
                            found = true;
                        }

                        if (response.qualifiers3) {
                            $.each(response.qualifiers3, function (i, value) {
                                myQualifier3.append($('<option/>', {
                                    'value': value,
                                    'html': value
                                }));
                            });

                            myQualifier3.parents('.form-group').removeClass('d-none');
                            found = true;
                        }

                        if (response.qualifiers4) {
                            $.each(response.qualifiers4, function (i, value) {
                                myQualifier4.append($('<option/>', {
                                    'value': value,
                                    'html': value
                                }));
                            });

                            myQualifier4.parents('.form-group').removeClass('d-none');
                            found = true;
                        }

                        if (!found) {
                            mySubmit.removeClass('d-none');
                        }
                    }
                );
            } else {
                mySubmit.removeClass('d-none');
            }
        }
    },
    resetVehicle: function(make, model, year, qualifier1, qualifier2, qualifier3, qualifier4, submit) {
        let myYear = $(year),
            myChildren = [$(make), $(model), $(qualifier1), $(qualifier2), $(qualifier3), $(qualifier4)],
            mySubmit = $(submit);

        myYear.val('');

        for (let i = 0; i < myChildren.length; i++) {
            myChildren[i].children('option[value!=""]').remove();
            myChildren[i].parents('.form-group').eq(0).addClass('d-none');
        }

        mySubmit.addClass('d-none');
    },
    addOption: function(selector, alternate, pattern, editable) {
        if ($(selector).length) {
            if ($(selector).data('max')) {
                if ($(selector).children().length >= parseInt($(selector).data('max'))) {
                    return false;
                }
            }

            let template = $(selector).data('template');

            if (alternate === true) {
                template = $(selector).data('template-alt');
            }

            if ((template !== undefined) && (template !== null)) {
                let id = new Date().getTime() + '_' + (Math.floor(Math.random() * 1000));

                if ((typeof pattern == 'undefined') || !pattern) {
                    pattern = /\$INDEX/g;
                }

                template = template.replace(pattern, id);

                $(selector).append(template);

                let textareas = $(template).find('.wysiwyg');

                if (textareas.length && (tinymce !== undefined)) {
                    $.each(textareas, function(i, textarea) {
                        tinymce.EditorManager.execCommand('mceToggleEditor', true, $(textarea).attr('id'));
                    });
                }

                if ((typeof editable === 'string') || (editable instanceof String)) {
                    App.prepareEditLabel('.form-label.editable', selector);

                    let children = $(selector).children();
                    let child = $(selector).children().eq(children.length - 1);
                    let first = $(editable).children().eq(0);
                    let labels = first.find('.form-label.editable');

                    if (labels.length >= children.length) {
                        $('.form-label.editable', child).text(labels.eq(children.length - 1).text());
                    }
                }

                return id;
            }
        }

        return false;
    },
    setupVehicleOption: function(selector) {
        let labels = $(selector).parents('.accordion-body').eq(0).find('.vehicle-option-label'),
            type = $(selector).val(),
            map = {
                top_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                crit_note_stereo: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                stereo_installation_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                dash_kit: {
                    0: 'Item',
                    1: 'Additional item',
                    2: 'Single Or Double Din',
                    3: 'Note',
                    4: 'Show / Hide',
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                basic_harness_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                basic_harness: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: 'Show / Hide',
                    5: 'SWC',
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                specialty_harness_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                specialty_harness: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: 'Show / Hide',
                    5: 'SWC',
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                maestro_adapter_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                maestro_adapter: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                swc_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                swc: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: 'Show / Hide',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                antenna_adapter_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                antenna_adapter_aftermarket: {
                    0: 'Antenna Adapter to Aftermarket Stereo',
                    1: 'Show / Hide',
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                antenna_adapter_factory: {
                    0: 'Antenna Adapter to Factory Stereo',
                    1: 'Show / Hide',
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                usb_port_retention_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                usb_port_retention: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: 'Show / Hide',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                sat_ant: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: 'Show / Hide',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                backup_cam_retention_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                backup_cam_retention: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: 'Show / Hide',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                rear_video_retention_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                rear_video_retention: {
                    0: 'Item',
                    1: 'Note',
                    2: 'Show / Hide',
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                add_nav_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                add_nav: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                bluetooth_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                bluetooth: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                ipod_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                ipod: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                aux_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                aux: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                sat_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                sat: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                backup_cam_integration_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                backup_cam_integration: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: 'Item Caption',
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                backup_cam_factory_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                backup_cam_factory: {
                    0: 'Item',
                    1: 'Note',
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                cam_package_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                cam_package: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                speaker_install_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                front_speaker: {
                    0: 'Size',
                    1: 'Adapter',
                    2: 'Adapter Note',
                    3: 'Adapter Show / Hide',
                    4: 'Optional Adapter #1',
                    5: 'Optional Adapter #1 Note',
                    6: 'Optional Adapter #1 Show / Hide',
                    7: 'Optional Adapter #2',
                    8: 'Optional Adapter #2 Note',
                    9: 'Optional Adapter #2 Show / Hide',
                    10: 'Optional Adapter #3',
                    11: 'Optional Adapter #3 Note',
                    12: 'Optional Adapter #3 Show / Hide',
                    13: 'Speaker Harness',
                    14: 'Speaker Harness Note',
                    15: 'Speaker Harness Show / Hide',
                    16: 'Speaker Plug #1',
                    17: 'Speaker Plug #1 Note',
                    18: 'Speaker Plug #1 Show / Hide',
                    19: 'Speaker Plug #2',
                    20: 'Speaker Plug #2 Note',
                    21: 'Speaker Plug #2 SHow / Hide'
                },
                rear_speaker: {
                    0: 'Size',
                    1: 'Adapter',
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                center_speaker: {
                    0: 'Size',
                    1: 'Adapter',
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                sub_speaker: {
                    0: 'Size',
                    1: 'Adapter',
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                sub_box: {
                    0: 'Item',
                    1: 'Note',
                    2: 'Show / Hide',
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                stealthbox_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                stealthbox: {
                    0: 'Item',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                amp_int_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                rec_loc: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                anc: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                addl_amp: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                vsp_amp: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: 'More additional items',
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                sub_amp: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                mch_amp: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                srs_int_note: {
                    0: 'Text',
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                srs_int: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'More additional items',
                    3: 'Note',
                    4: 'Show / Hide',
                    5: 'Factory Style Connector',
                    6: '# Of Keys Needed For Installation',
                    7: '# Of Keys That Need To Be Permanently Installed',
                    8: 'Allows RS Using OEM Key Fob Without Adding Separate RS Module',
                    9: 'Allows RS From OEM Key Fob',
                    10: 'Key Fob Operational When Remote Started',
                    11: 'Allows OEM Key Fob To Control Aftermarket Alarm',
                    12: 'Allows User To Get In And Drive Without RS Shutting Down',
                    13: 'RSDL',
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                },
                t_harness: {
                    0: 'Item',
                    1: 'Additional items',
                    2: 'Note',
                    3: false,
                    4: false,
                    5: false,
                    6: false,
                    7: false,
                    8: false,
                    9: false,
                    10: false,
                    11: false,
                    12: false,
                    13: false,
                    14: false,
                    15: false,
                    16: false,
                    17: false,
                    18: false,
                    19: false,
                    20: false,
                    21: false
                }
            };

        labels.each(function(i, label) {
            $(label).html('Value ' + (i + 1) + ':');
            $(label).parents('.form-group').eq(0).removeClass('d-none');
        });

        $.each(map, function(key, fields) {
            if (key == type) {
                $.each(fields, function(i, value) {
                    if (value === false) {
                        labels.eq(i).parents('.form-group').eq(0).addClass('d-none');
                    } else {
                        labels.eq(i).parents('.form-group').eq(0).removeClass('d-none');
                        labels.eq(i).html(value ? (value + ':') : '');
                    }
                });
            }
        });
    },
    sortOptions: function(id) {
        new Sortable(
            document.getElementById(id),
            {
                group: 'nested',
                handle: '.option-handle',
                draggable: '.option-item',
                fallbackOnBody: true
            }
        );
    },
    setCookie: function(name, value) {
        document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=31536000; SameSite=None; Secure';
    },
    removeCookie: function(name) {
        document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure';
    },
    formatLength: function(number, length) {
        let buffer = "" + number;

        while (buffer.length < length) {
            buffer = "0" + buffer;
        }

        return buffer;
    },
    formatSeconds: function(seconds) {
        let divisor = seconds % (60 * 60);
        let hours = Math.floor(seconds / (60 * 60));
        let minutes = Math.floor(divisor / 60);

        divisor = divisor % 60;
        seconds = Math.ceil(divisor);

        return App.formatLength(hours, 2) + ":" + App.formatLength(minutes, 2) + ":" + App.formatLength(seconds, 2);
    },
    testTimer: function(selector, value) {
        setInterval(function() {
            $(selector).text(App.formatSeconds(value++));
        }, 1000);
    },
    submitParentForm: function(selector) {
        $(selector).parents('form').eq(0).submit();
    },
    galleryDropzone: function(selector, submit, token) {
        $(selector).dropzone({
            url: "https://www.customsounds.com/xhr/csr_gallery",
            maxFiles: 100,
            paramName: 'file',
            acceptedFiles: 'image/*',
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop files here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            params: {
                token: token
            },
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);

                    if (response.success) {
                        $(selector).find('.dz-filename').each(function() {
                            if ($(this).children('span').eq(0).text() == file.name) {
                                $(this).append($('<input/>', {
                                    type: 'hidden',
                                    name: 'images[]',
                                    value: response.success
                                }));
                            }
                        });

                        if ($('input[name="images[]"]').length >= 2) {
                            $(submit).prop('disabled', false);
                        } else {
                            $(submit).prop('disabled', true);
                        }
                    }

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }
                });

                myDropzone.on('removedfile', function(file) {
                    if ($('input[name="images[]"]').length >= 2) {
                        $(submit).prop('disabled', false);
                    } else {
                        $(submit).prop('disabled', true);
                    }
                });
            }
        });
    },
    formTriggers: function(selector) {
        let elem = $(selector),
            form = elem.parents('form').eq(0),
            triggerable = form.find(':input').filter(function() {
                let my_triggers = $(this).data('triggers'),
                    is_source = false;

                if ((my_triggers !== undefined) && (my_triggers !== '')) {
                    $.each(my_triggers, function(i, trigger) {
                        if (trigger.field == $(selector).data('slug')) {
                            is_source = true;
                        }
                    });
                }

                return $(this).hasClass('trigger-input') && ($(this).attr('id') != elem.attr('id')) && !is_source;
            }),
            triggers = elem.data('triggers');

        if (triggerable.length) {
            $.each(triggerable, function(i, input) {
                $(input).parents('.form-group').eq(0)
                    .val('')
                    .addClass('hidden')
                    .find('.triggered')
                        .remove();
            });
        }

        elem.parents('.form-group').eq(0).find('.triggered').remove();

        if ((triggers !== undefined) && (triggers !== '')) {
            $.each(triggers, function(i, trigger) {
                if (elem.val() == trigger.option) {
                    if (trigger.url.length) {
                        elem.parents('.form-group').eq(0).append($('<p/>', {
                            class: 'text-center mt-2 triggered',
                        }).append($('<a/>', {
                            href: trigger.url,
                            class: 'btn btn-primary w-100',
                            text: 'Proceed'
                        })));
                    }

                    if (trigger.field.length) {
                        $.each(triggerable, function(i, input) {
                            if ($(input).data('slug') == trigger.field) {
                                $(input).parents('.form-group').eq(0).removeClass('hidden');
                            }
                        });
                    }
                }
            });
        }
    },
    sendForm: function (selector, id) {
        let form = $(selector);

        $.post(serverUrl + '/xhr/formid', 'id=' + id + '&' + form.serialize(), function (response) {
            if (response) {
                $('input, select, textarea', form).removeClass('is-invalid');
                $('.valid-feedback, .invalid-feedback', form).remove();

                if (response.fields !== undefined) {
                    $.each(response.fields, function (field, error) {
                        $('#' + field).addClass('is-invalid').parent().append($('<div/>', {
                            'class': 'invalid-feedback',
                            'html': error
                        }));
                    });
                }

                if (response.error !== undefined) {
                    Swal.fire({
                        title: 'Error',
                        text: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                } else if (response.warning !== undefined) {
                    Swal.fire({
                        title: 'Warning',
                        text: response.warning,
                        icon: 'warning',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                } else if (response.success !== undefined) {
                    $('input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="date"], select, textarea', form).val('');

                    Swal.fire({
                        title: 'Success',
                        text: response.success,
                        icon: 'success',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                }
            }
        }, 'json');

        return false;
    },
    laborQty: function(clear) {
        let subtotal = 0,
            parts = 0,
            shop = 0,
            transfered = 0,
            total = 0,
            labor_list = [],
            labor_total = 0,
            taxes = 0,
            skip_labor = {};

        if (clear === true) {
            $('.labor-qty').val(0);
            $('.labor-price').val(0);
            $('#labor-products > .widget-products > .product').remove();

            if ($('#labor-products > .widget-products > .product').length) {
                $('#labor-products').removeClass('d-none');
            } else {
                $('#labor-products').addClass('d-none');
            }
        }

        $('.labor-product').each(function(i, qty) {
            let parent = $(qty).parents('.product').eq(0);

            if (parent && (parseInt($(qty).val()) > 0)) {
                let field14 = parent.data('field_14');

                if ((field14 !== undefined) && (field14 !== '')) {
                    if ((parent.data('parts') !== undefined) || (parent.data('shop') !== undefined)) {
                        if (!(field14.toLowerCase() in skip_labor)) {
                            skip_labor[field14.toLowerCase()] = parseInt($(qty).val());
                        } else {
                            skip_labor[field14.toLowerCase()] += parseInt(qty.value);
                        }
                    }

                    if (parent.data('parts') !== undefined) {
                        parts += parseFloat(parent.data('parts')) * parseInt($(qty).val());
                    }

                    if (parent.data('shop') !== undefined) {
                        shop += parseFloat(parent.data('shop')) * parseInt($(qty).val());
                    }
                }
            }
        });

        if (skip_labor) {
            for (const field14 of Object.keys(skip_labor)) {
                $('.labor-qty').each(function(i, qty) {
                    let type = $(qty).data('type');

                    if ((type.toLowerCase() == field14.toLowerCase()) && ($(qty).val() == 0)) {
                        $(qty).val(skip_labor[field14.toLowerCase()]);
                    }
                });
            }
        }

        $('.labor-qty').each(function(i, qty) {
            let parent = $(qty).parents('tr').eq(0);

            if ($(qty).val() > 0) {
                let type = $(qty).data('type');
                let price = $(qty).data('price');
                let buffer = 0;

                if (type !== undefined) {
                    type = type.toLowerCase();
                }

                if (price.toString().slice(0, 1) == '#') {
                    if (parseInt($(price).val()) > 0) {
                        parent.addClass('fw-bold');
                        buffer = parseInt($(qty).val()) * parseFloat($(price).val());
                        labor_total += buffer;

                        if ((type === undefined) || !(type in skip_labor)) {
                            parts += parseFloat((buffer * 0.25).toFixed(2));
                            shop += parseFloat((buffer * 0.065).toFixed(2));
                        }

                        labor_list.push({
                            task: $(this).data('description'),
                            price: buffer
                        });
                    } else {
                        parent.removeClass('fw-bold');
                    }
                } else {
                    parent.addClass('fw-bold');
                    buffer = parseInt($(qty).val()) * $(qty).data('price');
                    if ($(qty).data('gear') === true) {
                        buffer = buffer + (buffer * 0.2);
                    }
                    labor_total += buffer;

                    if ((type === undefined) || !(type in skip_labor)) {
                        parts += parseFloat((buffer * 0.15).toFixed(2));
                        shop += parseFloat((buffer * 0.065).toFixed(2));
                    }

                    labor_list.push({
                        task: $(this).data('description'),
                        price: buffer
                    });
                }
            } else if (parent.hasClass('fw-bold')) {
                parent.removeClass('fw-bold');
            }
        });

        $('#labor-list').empty();

        if (labor_list.length) {
            let list = '';
            let list_total = 0;

            for (let i = 0; i < labor_list.length; i++) {
                list += '<tr><td>' + labor_list[i].task + '</td><td class="text-end">$' + labor_list[i].price.toFixed(2) + '</td></tr>';
                list_total += labor_list[i].price;
            }

            $('#labor-list').html('<table class="table table-bordered">' + list + '<tr><td class="text-end">Total:</td><td class="text-end fw-bold text-primary">$' + list_total.toFixed(2) + '</td></tr></table>')
        }

        $('.transfered-product').each(function(i, qty) {
            transfered += parseInt($(qty).val()) * $(qty).data('price');
        });

        $('.labor-product').each(function(i, qty) {
            subtotal += parseInt($(qty).val()) * $(qty).data('price');
        });

        if (tax_rate > 0) {
            taxes = (subtotal + parts + shop) * tax_rate * 0.01;

            if (tax_labor === true) {
                taxes += labor_total * tax_rate * 0.01;
            }
        }

        total = subtotal + labor_total + parts + shop + taxes;

        $('#labor-subtotal').text(labor_total.toFixed(2));
        $('#labor-parts').text(parts.toFixed(2));
        $('#labor-shop').text(shop.toFixed(2));
        $('#labor-transfer').text(transfered.toFixed(2));
        $('#labor-total').text(total.toFixed(2));

        if (tax_rate > 0) {
            $('#labor-tax').text(taxes.toFixed(2));
            $('#labor-tax').parent().removeClass('d-none');
            $('#labor-tax-unknown').addClass('d-none');
        } else {
            $('#labor-tax').parent().addClass('d-none');
            $('#labor-tax-unknown').removeClass('d-none');
        }

        $('.labor-alternative').each(function() {
            let qty = 1;
            let model = $(this).parents('a').eq(0).data('model');

            $('#labor-products .product').each(function() {
                if ($(this).data('model') === model) {
                    qty = $('input[type="number"]', $(this)).val();
                }
            });

            $(this).text((total.toFixed(2) - ($(this).data('price') * qty)).toFixed(2));
        });

        if (subtotal > 0) {
            $('#labor-gear').removeClass('d-none').addClass('d-inline-block');
            App.laborGear();
        } else {
            $('#labor-gear').removeClass('d-inline-block').addClass('d-none');
            $('#gear-wrapper').empty();
        }
    },
    laborQtyUp: function(selector) {
        let input = $(selector).siblings('input');

        if (input.length) {
            input = input.eq(0);

            if (input.val() > 0) {
                input.val(parseInt(input.val()) + 1);
            } else {
                input.val(1);
            }
            App.laborQty();
        }
    },
    laborQtyDown: function(selector) {
        let input = $(selector).siblings('input');

        if (input.length) {
            input = input.eq(0);

            if (input.val() > 0) {
                input.val(parseInt(input.val()) - 1);
                App.laborQty();
            }
        }
    },
    laborGear: function() {
        $('#gear-wrapper').empty();

        $('.labor-qty-gear').each(function(i, qty) {
            if ($(qty).val() > 0) {
                $('#gear-wrapper').append(
                    $('<div/>', {
                        class: 'form-check'
                    }).append($('<input/>', {
                        type: 'checkbox',
                        id: 'gear-' + i,
                        name: 'gear[]',
                        class: 'form-check-input',
                        value: 1
                    }).prop('checked', ($(qty).data('gear') === true)).data('job', $(qty).attr('id'))).append($('<label/>', {
                        class: 'form-check-label',
                        for: 'gear-' + i,
                        text: $(qty).data('description')
                    }))
                );
            }
        });
    },
    laborUpdate: function() {
        $('#gear-wrapper input[type="checkbox"]').each(function(i, gear) {
            $('#' + $(gear).data('job')).data('gear', ($(gear).prop('checked') ? true : false));
        });

        App.laborQty();

        let modal = Modal.getOrCreateInstance(document.getElementById('gearModal'));
        modal.hide();
    },
    cancelInstall: function(selector, id, question, confirm) {
        Swal.fire({
            title: question,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            denyButtonColor: '#dc3545',
            cancelButtonColor: '#adb5bd',
            confirmButtonText: confirm
        }).then((result) => {
            if (result.isConfirmed) {
                $.post(serverUrl + '/xhr/install_cancel', {'id': id}, function (response) {
                    if (response) {
                        if (response.error !== undefined) {
                            Swal.fire({
                                title: 'Error',
                                text: response.error,
                                icon: 'error',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else if (response.warning !== undefined) {
                            Swal.fire({
                                title: 'Warning',
                                text: response.warning,
                                icon: 'warning',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else if (response.success !== undefined) {
                            Swal.fire({
                                title: 'Success',
                                text: response.success,
                                icon: 'success',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd',
                                willClose: () => {
                                    window.location.reload();
                                }
                            });
                        }
                    }
                }, 'json');
            }
        });

        return false;
    },
    callInstall: function(selector, id, question, confirm) {
        Swal.fire({
            title: question,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            denyButtonColor: '#dc3545',
            cancelButtonColor: '#adb5bd',
            confirmButtonText: confirm
        }).then((result) => {
            if (result.isConfirmed) {
                $.post(serverUrl + '/xhr/install_call', {'id': id}, function (response) {
                    if (response) {
                        if (response.error !== undefined) {
                            Swal.fire({
                                title: 'Error',
                                text: response.error,
                                icon: 'error',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else if (response.warning !== undefined) {
                            Swal.fire({
                                title: 'Warning',
                                text: response.warning,
                                icon: 'warning',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else if (response.success !== undefined) {
                            Swal.fire({
                                title: 'Success',
                                text: response.success,
                                icon: 'success',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd',
                                willClose: () => {
                                    window.location.reload();
                                }
                            });
                        }
                    }
                }, 'json');
            }
        });

        return false;
    },
    completeInstall: function(selector, id, question, confirm) {
        Swal.fire({
            title: question,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            denyButtonColor: '#dc3545',
            cancelButtonColor: '#adb5bd',
            confirmButtonText: confirm
        }).then((result) => {
            if (result.isConfirmed) {
                $.post(serverUrl + '/xhr/install_complete', {'id': id}, function (response) {
                    if (response) {
                        if (response.error !== undefined) {
                            Swal.fire({
                                title: 'Error',
                                text: response.error,
                                icon: 'error',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else if (response.warning !== undefined) {
                            Swal.fire({
                                title: 'Warning',
                                text: response.warning,
                                icon: 'warning',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else if (response.success !== undefined) {
                            Swal.fire({
                                title: 'Success',
                                text: response.success,
                                icon: 'success',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd',
                                willClose: () => {
                                    window.location.reload();
                                }
                            });
                        }
                    }
                }, 'json');
            }
        });

        return false;
    },
    assignInstall: function(selector, id, question, confirm) {
        if ($(selector).val().length) {
            Swal.fire({
                title: question,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#0d6efd',
                denyButtonColor: '#dc3545',
                cancelButtonColor: '#adb5bd',
                confirmButtonText: confirm
            }).then((result) => {
                if (result.isConfirmed) {
                    $.post(serverUrl + '/xhr/install_activate', {
                        'id': id,
                        'tech': $(selector).val()
                    }, function (response) {
                        if (response) {
                            if (response.error !== undefined) {
                                Swal.fire({
                                    title: 'Error',
                                    text: response.error,
                                    icon: 'error',
                                    confirmButtonText: 'Close',
                                    confirmButtonColor: '#0d6efd',
                                    denyButtonColor: '#dc3545',
                                    cancelButtonColor: '#adb5bd'
                                });
                            } else if (response.warning !== undefined) {
                                Swal.fire({
                                    title: 'Warning',
                                    text: response.warning,
                                    icon: 'warning',
                                    confirmButtonText: 'Close',
                                    confirmButtonColor: '#0d6efd',
                                    denyButtonColor: '#dc3545',
                                    cancelButtonColor: '#adb5bd'
                                });
                            } else if (response.success !== undefined) {
                                Swal.fire({
                                    title: 'Success',
                                    text: response.success,
                                    icon: 'success',
                                    confirmButtonText: 'Close',
                                    confirmButtonColor: '#0d6efd',
                                    denyButtonColor: '#dc3545',
                                    cancelButtonColor: '#adb5bd',
                                    willClose: () => {
                                        window.location.reload();
                                    }
                                });
                            }
                        }
                    }, 'json');
                }
            });
        }

        return false;
    },
    cancelTint: function(selector, id, question, confirm) {
        Swal.fire({
            title: question,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            denyButtonColor: '#dc3545',
            cancelButtonColor: '#adb5bd',
            confirmButtonText: confirm
        }).then((result) => {
            if (result.isConfirmed) {
                $.post(serverUrl + '/xhr/tint_cancel', {'id': id}, function (response) {
                    if (response) {
                        if (response.error !== undefined) {
                            Swal.fire({
                                title: 'Error',
                                text: response.error,
                                icon: 'error',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else if (response.warning !== undefined) {
                            Swal.fire({
                                title: 'Warning',
                                text: response.warning,
                                icon: 'warning',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else if (response.success !== undefined) {
                            Swal.fire({
                                title: 'Success',
                                text: response.success,
                                icon: 'success',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd',
                                willClose: () => {
                                    window.location.reload();
                                }
                            });
                        }
                    }
                }, 'json');
            }
        });

        return false;
    },
    vehicleSearch: function(type, make, model, year, reverse = false) {
        let myMake = $(make),
            myModel = $(model),
            myYear = $(year),
            myChildren = [],
            params = {},
            current = false;

        if (reverse === true) {
            if (type == 'year') {
                current = myYear;
                myChildren.push(myMake, myModel);
                params = {
                    'year': myYear.val()
                };
            } else if (type == 'make') {
                current = myMake;
                myChildren.push(myModel);
                params = {
                    'year': myYear.val(),
                    'make': myMake.val(),
                };
            }
        } else {
            if (type == 'make') {
                current = myMake;
                myChildren.push(myModel, myYear);
                params = {
                    'make': myMake.val()
                };
            } else if (type == 'model') {
                current = myModel;
                myChildren.push(myYear);
                params = {
                    'make': myMake.val(),
                    'model': myModel.val()
                };
            }
        }

        for (let i = 0; i < myChildren.length; i++) {
            myChildren[i].children('option[value!=""]').remove();
        }

        if (current && current.val()) {
            if (myChildren.length) {
                $.getJSON(
                    '/xhr/vehiclesearch/',
                    params,
                    function (response) {
                        let found = false;

                        if (response.makes) {
                            $.each(response.makes, function (i, value) {
                                myMake.append($('<option/>', {
                                    'value': value,
                                    'html': value
                                }));
                            });
                        }

                        if (response.models) {
                            $.each(response.models, function (i, value) {
                                myModel.append($('<option/>', {
                                    'value': value,
                                    'html': value
                                }));
                            });
                        }

                        if (response.years) {
                            $.each(response.years, function (i, value) {
                                myYear.append($('<option/>', {
                                    'value': value,
                                    'html': value
                                }));
                            });
                        }
                    }
                );
            }
        }
    },
    installScheduleType: function(selector, match, wrap, custom, plain) {
        if ($(selector).prop('checked')) {
            $(wrap).removeClass('d-none');
        } else {
            $(wrap).addClass('d-none');
        }

        if ($(selector).val() == match) {
            $.each(custom, function() {
                $(this).parents('.form-group').eq(0).removeClass('d-none');
                $(this).prop('required', true);
            });

            $.each(plain, function() {
                $(this).parents('.form-group').eq(0).addClass('d-none');
                $(this).val('').prop('required', false);
            });
        } else {
            $.each(custom, function() {
                $(this).parents('.form-group').eq(0).addClass('d-none');
                $(this).val('').prop('required', false);
            });

            $.each(plain, function() {
                $(this).parents('.form-group').eq(0).removeClass('d-none');
                $(this).prop('required', true);
            });
        }
    },
    installScheduleItems: function(selector) {
        let button = $(selector).parents('form').eq(0).find('button[type="submit"]');

        if ($(selector).prop('checked')) {
            if ($(selector).val() == 0) {
                button.prop('disabled', false);
            } else if ($(selector).val() == 1) {
                button.prop('disabled', true);
                let modal = Modal.getOrCreateInstance(document.querySelector('#scheduleModal'));
                modal.show();

                App.installScheduleItemsUpdate('#template-install-item', '.install-schedule-item');
            }
        } else {
            button.prop('disabled', true);
        }
    },
    installScheduleItemsUpdate: function(selector, items) {
        let button = $(selector).parents('form').eq(0).find('button[type="submit"]');
        let found = false;

        $(items).each(function() {
            if ($.trim($(this).val()).length) {
                found = true;
            }
        });

        if (found) {
            button.prop('disabled', false);
        } else {
            button.prop('disabled', true);
        }
    },
    installScheduleItemsAdd: function(selector, target) {
        let element = $(target).clone();
        element.find(':input').val('');
        $(selector).parent().before(element);
    },
    installDropPick: function(selector, dropoff, pickup, date) {
        $(dropoff).children('option[value!=""]').remove();
        $(pickup).children('option[value!=""]').remove();

        if ($(selector).val().length) {
            $.getJSON(serverUrl + '/xhr/install_droppick', {
                'store': $(selector).val(),
                'date': date
            }, function (response) {
                if (response) {
                    if (response.dropoff) {
                        $.each(response.dropoff, function (i, value) {
                            $(dropoff).append($('<option/>', {
                                'value': value,
                                'html': value
                            }));
                        });
                    }

                    if (response.pickup) {
                        $.each(response.pickup, function (i, value) {
                            $(pickup).append($('<option/>', {
                                'value': value,
                                'html': 'till ' + value
                            }));
                        });
                    }
                }
            });
        }
    },
    editInstall: function(id) {
        if ($('#modal-edit-install').length) {
            $('#modal-edit-install').remove();
        }

        $.getJSON(serverUrl + '/xhr/install_edit', {
            'id': id
        }, function (response) {
            if (response) {
                if (response.error !== undefined) {
                    Swal.fire({
                        title: 'Error',
                        text: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                } else if (response.warning !== undefined) {
                    Swal.fire({
                        title: 'Warning',
                        text: response.warning,
                        icon: 'warning',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                } else if (response.success !== undefined) {
                    Swal.fire({
                        title: 'Success',
                        text: response.success,
                        icon: 'success',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd',
                        willClose: () => {
                            window.location.reload();
                        }
                    });
                } else if (response.html !== undefined) {
                    $('body').append($('<div/>', {
                        'id': 'modal-edit-install',
                        'class': 'modal fade',
                        'tabindex': '-1',
                        'role': 'dialog',
                        'aria-hidden': 'true',
                        'html': response.html
                    }));

                    let modal = Modal.getOrCreateInstance(document.querySelector('#modal-edit-install'));
                    modal.show();

                    App.init('#modal-edit-install');
                }
            }
        });
    },
    editTint: function(id) {
        if ($('#modal-edit-tint').length) {
            $('#modal-edit-tint').remove();
        }

        $.getJSON(serverUrl + '/xhr/tint_edit', {
            'id': id
        }, function (response) {
            if (response) {
                if (response.error !== undefined) {
                    Swal.fire({
                        title: 'Error',
                        text: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                } else if (response.warning !== undefined) {
                    Swal.fire({
                        title: 'Warning',
                        text: response.warning,
                        icon: 'warning',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                } else if (response.success !== undefined) {
                    Swal.fire({
                        title: 'Success',
                        text: response.success,
                        icon: 'success',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd',
                        willClose: () => {
                            window.location.reload();
                        }
                    });
                } else if (response.html !== undefined) {
                    $('body').append($('<div/>', {
                        'id': 'modal-edit-tint',
                        'class': 'modal fade',
                        'tabindex': '-1',
                        'role': 'dialog',
                        'aria-hidden': 'true',
                        'html': response.html
                    }));

                    let modal = Modal.getOrCreateInstance(document.querySelector('#modal-edit-tint'));
                    modal.show();

                    App.init('#modal-edit-tint');
                }
            }
        });
    },
    submitEditInstall: function(form, id) {
        $.post(
            serverUrl + '/xhr/install_edit?id=' + id,
            $(form).serialize(),
            function (response) {
                if (response) {
                    if (response.error !== undefined) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else if (response.warning !== undefined) {
                        Swal.fire({
                            title: 'Warning',
                            text: response.warning,
                            icon: 'warning',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else if (response.success !== undefined) {
                        Swal.fire({
                            title: 'Success',
                            text: response.success,
                            icon: 'success',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd',
                            willClose: () => {
                                window.location.reload();
                            }
                        });
                    } else if (response.html !== undefined) {
                        $(form).parent().html(response.html);

                        App.init('#modal-edit-install');
                    }
                }
            },
            'json'
        );

        return false;
    },
    submitEditTint: function(form, id) {
        $.post(
            serverUrl + '/xhr/tint_edit?id=' + id,
            $(form).serialize(),
            function (response) {
                if (response) {
                    if (response.error !== undefined) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else if (response.warning !== undefined) {
                        Swal.fire({
                            title: 'Warning',
                            text: response.warning,
                            icon: 'warning',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else if (response.success !== undefined) {
                        Swal.fire({
                            title: 'Success',
                            text: response.success,
                            icon: 'success',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd',
                            willClose: () => {
                                window.location.reload();
                            }
                        });
                    } else if (response.html !== undefined) {
                        $(form).parent().html(response.html);

                        App.init('#modal-edit-tint');
                    }
                }
            },
            'json'
        );

        return false;
    },
    documentDropzone: function(selector, fileName, fileSize, fileUrl) {
        $(selector).dropzone({
            url: serverUrl + "/xhr/document",
            maxFiles: 1,
            paramName: 'file',
            acceptedFiles: 'application/pdf',
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop file here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);

                    if (response.success) {
                        $(selector).find('.dz-filename').each(function() {
                            if ($(this).children('span').eq(0).text() == file.name) {
                                $(this).append($('<input/>', {
                                    type: 'hidden',
                                    name: 'file',
                                    value: response.success
                                }));
                            }
                        });
                    }

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }
                });

                if (fileName) {
                    myDropzone.displayExistingFile({name: fileName, size: fileSize}, fileUrl);

                    $(selector).find('.dz-filename').each(function() {
                        if ($(this).children('span').eq(0).text() == fileName) {
                            $(this).append($('<input/>', {
                                type: 'hidden',
                                name: 'file',
                                value: fileName
                            }));

                            if (fileUrl) {
                                $(this).parents('.dz-preview').eq(0).append($('<a/>', {
                                    href: fileUrl,
                                    target: '_blank',
                                    class: 'd-block mt-1 text-center link-success',
                                    style: 'cursor: pointer !important;',
                                    text: 'Open'
                                }));
                            }
                        }
                    });
                }
            }
        });
    },
    filterDocuments: function(selector, target) {
        let input = $(selector).eq(0),
            q = $.trim(input.val().toLowerCase()),
            files = $(target).find('.list-group-item');

        if (q.length) {
            $(target).show();
        } else {
            $(target).hide();
        }

        files.hide().filter(function() {
            let text = $.trim($(this).text().toLowerCase());
            let tags = $.trim($(this).data('tags').toLowerCase());

            return ((text.search(q) === -1) && (tags.search(q) === -1) ? false : true);
        }).show();
    },
    cloneWithoutCurrent: function(source, target) {
        $(target).children('option').not('[value=""]').remove();
        $(source).children('option').not('[value=""]').each(function() {
            if (!$(this).prop('selected')) {
                $(target).append($('<option/>', {
                    value: $(this).attr('value'),
                    text: $(this).text()
                }))
            }
        });
    },
    candidatePosition: function(selector) {
        $('#candidate-pay_type option[value="Hourly Rate"]').remove();
        $('#candidate-pay_type').removeAttr('disabled').append($('<option/>', {
            value: 'Hourly Rate',
            text: 'Hourly Rate'
        }));
        $('#candidate-pay_type-backup').remove();
        $('#pay_rate_type').text('Commission');

        if (($(selector).val() == 'stock') || ($(selector).val() == 'stockmgr')|| ($(selector).val() == 'visual_manager')|| ($(selector).val() == 'visual_associate')) {
            $('#wrap-monthly_amount').addClass('d-none');
            $('#candidate-monthly_amount').val('');
            $('#candidate-pay_type').val('Hourly Rate').prop('disabled', 'disabled');
            $('#candidate-pay_type').parent().append($('<input/>', {
                type: 'hidden',
                id: 'candidate-pay_type-backup',
                name: $('#candidate-pay_type').attr('name'),
                value: 'Hourly Rate'
            }));
            $('#pay_rate_addon').removeClass('fa-percent').addClass('fa-dollar-sign');
            $('#pay_rate_type').text('Hourly');
        } else if (($(selector).val() == 'sales')) {
            $('#wrap-monthly_amount').removeClass('d-none');
            $('#pay_rate_addon').removeClass('fa-dollar-sign').addClass('fa-percent');
            $('#pay_rate_type').text('Commission');

            if ($('#candidate-pay_type').val() == 'Hourly Rate') {
                $('#pay_rate_type').text('Hourly');
            }
        } else {
            $('#wrap-monthly_amount').removeClass('d-none');
            $('#pay_rate_addon').removeClass('fa-dollar-sign').addClass('fa-percent');

            if ($(selector).val().length) {
                $('#candidate-pay_type option[value="Hourly Rate"]').remove();
            }
        }

        if (($(selector).val() == 'sales') || ($(selector).val() == 'install')) {
            $('#wrap_trainee').removeClass('d-none');
        } else {
            $('#wrap_trainee').addClass('d-none');
        }

        if ($(selector).val() == 'multiple') {
            $('#more-positions').removeClass('d-none');
        } else {
            $('#more-positions').addClass('d-none');
        }
    },
    candidateMultiPosition: function() {
        let isSalesOrTech = false;

        $('[name="candidate[positions][]"]').each(function() {
            if ($(this).prop('checked') && (($(this).val() == 'sales') || ($(this).val() == 'install'))) {
                isSalesOrTech = true;
            }
        });

        if (isSalesOrTech) {
            $('#wrap_trainee').removeClass('d-none');
        } else {
            $('#wrap_trainee').addClass('d-none');
        }
    },
    candidateTrainee: function(selector) {
        if ($(selector).prop('checked')) {
            $('#wrap-monthly_amount').addClass('d-none');
            $('#candidate-monthly_amount').val('');
            $('#candidate-pay_type').val('Hourly Rate').prop('disabled', 'disabled');
            $('#candidate-pay_type').parent().append($('<input/>', {
                type: 'hidden',
                id: 'candidate-pay_type-backup',
                name: $('#candidate-pay_type').attr('name'),
                value: 'Hourly Rate'
            }));
            $('#pay_rate_addon').removeClass('fa-percent').addClass('fa-dollar-sign');
            $('#pay_rate_type').text('Hourly');
        } else {
            $('#wrap-monthly_amount').removeClass('d-none');
            $('#pay_rate_addon').removeClass('fa-dollar-sign').addClass('fa-percent');
            $('#pay_rate_type').text('Commission');

            $('#candidate-pay_type option[value="Hourly Rate"]').remove();
            $('#candidate-pay_type').removeAttr('disabled').append($('<option/>', {
                value: 'Hourly Rate',
                text: 'Hourly Rate'
            }));
            $('#candidate-pay_type-backup').remove();
        }
    },
    candidatePayType: function(selector) {
        $('#pay_rate_type').text('Commission');

        if ($(selector).val() == 'Hourly Rate') {
            $('#wrap-monthly_amount').addClass('d-none');
            $('#wrap-monthly_amount').find('input').val('');
            $('#pay_rate_addon').removeClass('fa-percent').addClass('fa-dollar-sign');

            if ($('#candidate-position').val() == 'sales') {
                $('#pay_rate_type').text('Hourly');
            }
        } else {
            $('#wrap-monthly_amount').removeClass('d-none');
            $('#pay_rate_addon').removeClass('fa-dollar-sign').addClass('fa-percent');
        }
    },
    candidateNotifyTimeoff: function(selector) {
        if ($(selector).val() == 'Yes') {
            $('#wrap-timeoff_dates').removeClass('d-none').find('textarea').attr('required', 'required');
            $('#wrap-timeoff_dates').focus();
        } else if ($(selector).val() == 'No') {
            $('#wrap-timeoff_dates').addClass('d-none').find('textarea').removeAttr('required');
        }
    },
    candidateValidate: function(selector) {
        const position = $('#candidate-position').val();

        if (position == 'multiple') {
            let found = 0;

            $('input[name=\'candidate[positions][]\']', '#more-positions').each(function() {
                if ($(this).prop('checked')) {
                    found++;
                }
            });

            if (found < 2) {
                Swal.fire({
                    title: 'Error',
                    text: 'Please select 2 or more positions',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            } else {
                let primary = false;

                $('input[name=\'candidate[primary]\']', '#more-positions').each(function () {
                    if ($(this).prop('checked')) {
                        primary = true;
                    }
                });

                if (!primary) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Please mark one position as primary',
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });

                    return false;
                }
            }
        }

        return true;
    },
    employeeDepartment: function(selector) {
        if (($(selector).val() == 'sales') || ($(selector).val() == 'visual_manager') || ($(selector).val() == 'visual_associate')) {
            $('#user-pay_type-label').text('Draw, Salary or Hourly');

            if ($('#user-pay_type-Hourly').length == 0) {
                $('#user-pay_type-Draw').parents('.form-input').eq(0).append('<div class="form-check"><input type="radio" name="user[pay_type]" id="user-pay_type-Hourly" value="Hourly" class="form-check-input"><label for="user-pay_type-Hourly">Hourly</label></div>');
            }
        } else {
            $('#user-pay_type-label').text('Draw or Salary');
            $('#user-pay_type-Hourly').parent().remove();
        }
    },
    handleAccessLevel: function(selector, target) {
        let level = $(selector).val(),
            permissions = $('input[name="user[permissions][]"]'),
            access = ['fitguide', 'labor', 'jobs', '4amonth', 'staff', 'salesstat', 'techstat', 'gallery', 'contacts', 'signage'];

        if (level == 'admin') {
            access = ['fitguide', 'labor', 'jobs', '4amonth', 'staff', 'salesstat', 'techstat', 'gallery', 'contacts', 'signage', 'repair', 'test', 'document', 'corporate', 'whitelist', 'calendar'];
        } else if (level == 'hr') {
            access = ['fitguide', 'labor', 'jobs', '4amonth', 'staff', 'salesstat', 'techstat', 'gallery', 'contacts', 'signage', 'repair', 'test', 'document', 'corporate', 'whitelist', 'pay', 'hr', 'user', 'calendar'];
        } else if (level == 'super') {
            access = ['fitguide', 'labor', 'jobs', '4amonth', 'staff', 'salesstat', 'techstat', 'gallery', 'contacts', 'signage', 'store', 'test', 'repair', 'user', 'setting', 'form', 'node', 'menu', 'document', 'statistics', 'goals', 'pay', 'hr', 'corporate', 'whitelist', 'hint', 'sidebar', 'upload', 'verification', 'article', 'counts', 'switcher', 'remote', 'calendar', 'payment', 'can_onboard', 'can_relocate', 'supply', 'loop', 'mdb', 'ad', 'support', 'soundroom', 'email', 'planogram', 'access', 'resparker', 'addon', 'movesheet', 'complaint'];
        }

        for (let i = 0; i < permissions.length; i++) {
            if ($.inArray($(permissions[i]).val(), access) >= 0) {
                $(permissions[i]).prop('checked', true);
            } else {
                $(permissions[i]).prop('checked', false);
            }
        }
    },
    checkStoreManager: function(selector, store, userid) {
        if ($(selector).prop('checked')) {
            if ($(store).val() == '') {
                $(selector).prop('checked', false);
                return false;
            }

            $.getJSON(serverUrl + '/xhr/check_store_manager', {
                'user': userid,
                'store': $(store).val()
            }, function (response) {
                if (response && (response.error !== undefined)) {
                    $(selector).prop('checked', false);

                    Swal.fire({
                        title: 'Error',
                        html: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                }
            });
        }
    },
    checkDistrictManager: function(selector, market, store_wrap) {
        if ($(selector).prop('checked')) {
            if ($(market).val() == '') {
                $(selector).prop('checked', false);
                return false;
            } else {
                $(store_wrap).removeClass('d-none');
            }
        } else {
            $(store_wrap).addClass('d-none');
            $(store_wrap + ' .form-check-input').prop('checked', false);
        }
    },
    checkRegionalManager: function(selector, market, userid) {
        if ($(selector).prop('checked')) {
            if ($(market).val() == '') {
                $(selector).prop('checked', false);
                return false;
            }

            $.getJSON(serverUrl + '/xhr/check_regional_manager', {
                'user': userid,
                'market': $(market).val()
            }, function (response) {
                if (response && (response.error !== undefined)) {
                    $(selector).prop('checked', false);

                    Swal.fire({
                        title: 'Error',
                        html: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                }
            });
        }
    },
    checkScheduleAccess: function(selector, store, extra, userid) {
        if ($(selector).prop('checked')) {
            if ($(store).val() == '') {
                $(selector).prop('checked', false);
                return false;
            }

            let stores = [];
            stores.push($(store).val());

            $('input[name="user[district_manager][]"]', extra).each(function() {
                if ($(this).prop('checked')) {
                    stores.push($(this).val());
                }
            });

            $.getJSON(serverUrl + '/xhr/check_schedule_access', {
                'user': userid,
                'stores': stores.join(','),
            }, function (response) {
                if (response && (response.error !== undefined)) {
                    $(selector).prop('checked', false);

                    Swal.fire({
                        title: 'Error',
                        html: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                }
            });
        }
    },
    labelModal(selector, target) {
        if ($(selector, target).length && $('body').hasClass('has-token-permission')) {
            $(selector, target).each(function(i, label) {
                if (!$(label).hasClass('no-edit')) {
                    $(label).before($('<a/>', {
                        role: 'button',
                        class: 'text-secondary fs-6 align-self-center me-2',
                        html: '<i class="fas fa-fw fa-pencil-alt"></i>'
                    }).on('click', function () {
                        if ($('#modal-form').length) {
                            $('#modal-form').remove();
                        }

                        $('body').append($('<div/>', {
                            'id': 'modal-form',
                            'class': 'modal fade',
                            'tabindex': '-1',
                            'role': 'dialog',
                            'aria-hidden': 'true',
                            'html': '<div class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title" id="formModalLabel">Change Label</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"><form method="post" action="#" onsubmit="return App.labelUpdate(this, \'' + selector + '\', ' + i + ')"><div class="input-group input-group-lg"><input type="text" name="label" class="form-control" value="' + $.trim($(label).html()).replace(/"/g, '\\x22') + '"><button class="btn btn-outline-primary" type="submit">Save</button></div><input type="hidden" name="url" value="' + window.location.pathname.replace(/"/g, '\\x22') + '"><input type="hidden" name="input" value="' + i + '"></form></div></div></div>'
                        }));

                        let modal = Modal.getOrCreateInstance(document.querySelector('#modal-form'));
                        modal.show();
                    }));
                }
            });
        }
    },
    labelUpdate: function(form, selector, index) {
        let btn = $('button[type="submit"]', form).eq(0);

        form = $(form);

        $.post(
            serverUrl + '/xhr/label',
            form.serialize(),
            function(response) {
                if (response) {
                    if (response.error !== undefined) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: (response.button !== undefined ? response.button : 'Close'),
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else {
                        if (response.label) {
                            $(selector).eq(index).html(response.label.replace(/\\x22/g, '"'));
                        } else {
                            window.location.reload();
                        }

                        let modal = Modal.getOrCreateInstance(document.querySelector('#modal-form'));
                        modal.hide();
                    }
                }
            },
            'json'
        );

        return false;
    },
    syncLabels: function(selector, target) {
        let elements = $(selector, target).not('.no-edit');

        if (elements.length) {
            $.getJSON(
                serverUrl + '/xhr/labels',
                {
                    url: window.location.pathname.replace(/"/g, '\\x22')
                },
                function(response) {
                    if (response && response.labels) {
                        elements.each(function(i, label) {
                            if (i in response.labels) {
                                $(label).html(response.labels[i].replace(/\\x22/g, '"'));
                            }
                        });
                    }
                }
            );
        }
    },
    prepareEditLabel: function(selector, target) {
        let elements = $(selector, target);

        if (elements.length) {
            $(elements).each(function(i, element) {
                if (!$(element).hasClass('processed')) {
                    $(element).addClass('processed');

                    $(element).on('blur', function () {
                        if ($(this).siblings('.save_editable').length) {
                            $(this).siblings('.save_editable').eq(0).val($.trim($(this).text()));
                        }
                    });

                    $(element).on('keydown', function (e) {
                        if ((e.keyCode === 13) && !e.shiftKey) {
                            if ($(this).siblings('.save_editable').length) {
                                $(this).siblings('.save_editable').eq(0).val($.trim($(this).text()));
                            }

                            return false;
                        }
                    });
                }
            });
        }
    },
    openPopup: function(selector, target) {
        if ($(selector, target).length) {
            $(selector, target).on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const title = window.atob($(this).data('title'));
                const text = window.atob($(this).data('text'));

                if ($('#modal-hint').length) {
                    $('#modal-hint').remove();
                }

                $('body').append($('<div/>', {
                    'id': 'modal-hint',
                    'class': 'modal fade',
                    'tabindex': '-1',
                    'role': 'dialog',
                    'aria-hidden': 'true',
                    'html': '<div class="modal-dialog modal-lg modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title">' + title + '</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body">' + text + '</div></div></div>'
                }));

                let modal = Modal.getOrCreateInstance(document.querySelector('#modal-hint'));
                modal.show();
            });
        }
    },
    switchTheme: function(selector) {
        if ($('body').hasClass('theme-light')) {
            $('body').removeClass('theme-light').addClass('theme-dark');
            $(selector).children('.fas').removeClass('fa-toggle-off').addClass('fa-toggle-on');
            App.setCookie('theme', 'dark');
        } else {
            $('body').removeClass('theme-dark').addClass('theme-light');
            $(selector).children('.fas').removeClass('fa-toggle-on').addClass('fa-toggle-off');
            App.removeCookie('theme');
        }

        return false;
    },
    checkInstallSchedule: function(selector) {
        let order = $('#install-order').val();

        if ((order.length > 0) && ((order.length < 6) || (order.length > 7))) {
            Swal.fire({
                title: 'Error',
                text: 'The order number must have 6 or 7 digits',
                icon: 'error',
                confirmButtonText: 'Close',
                confirmButtonColor: '#0d6efd',
                denyButtonColor: '#dc3545',
                cancelButtonColor: '#adb5bd'
            });

            return false;
        }

        if (order.length == 6) {
            let number = parseInt(order),
                digit = number % 10,
                same = true;

            while (number != 0) {
                let current_digit = number % 10;
                number = parseInt(number / 10);

                if (current_digit != digit) {
                    same = false;
                    break;
                }
            }

            if (same) {
                return confirm('Any rep can take this sale because you are using a fake order number. Book the job anyway?');
            }
        }

        return true;
    },
    installScheduleTimespan: function(selector, wrap, multiple, dropoff, pickup) {
        if ($(selector).prop('checked')) {
            $(wrap).removeClass('d-none');
        } else {
            $(wrap).addClass('d-none');
        }

        if ($(selector).val() == 'multiple') {
            $(multiple).removeClass('d-none');

            $(dropoff).children('[value!=""]').first().attr('selected', 'selected');
            $(pickup).children('[value!=""]').last().attr('selected', 'selected');
        } else {
            $(multiple).addClass('d-none');
        }
    },
    installScheduleOptions: function(selector, other, comments) {
        if ($(selector).val() == other) {
            if ($(selector).prop('checked')) {
                $(comments).prop('required', true).focus();
            } else {
                $(comments).prop('required', false);
            }
        }
    },
    affix: function(selector) {
        $(window).on('scroll resize orientationchange', function(e) {
            let distance = $(window).scrollTop(),
                offset = 0;

            $('.affix-excluded').each(function() {
                offset += $(this).height();
            });

            distance = Math.round(distance - offset);

            if (distance > $(selector).height()) {
                $(selector).addClass('position-absolute start-0 end-0 animated').css('top', distance + 'px');
            } else {
                $(selector).removeClass('position-absolute').removeClass('start-0').removeClass('end-0').removeClass('animated').css('top', null);
            }
        });
    },
    sticky: function(selector) {
        $(window).on('scroll resize orientationchange', function(e) {
            let distance = Math.round($(window).scrollTop());

            if (distance > $(selector).height()) {
                $(selector).addClass('sticky-top animated');
            } else {
                $(selector).removeClass('sticky-top').removeClass('animated');
            }
        });
    },
    infractionDropzone: function(selector) {
        let params = $(selector).data('params');

        if ((params === undefined) || (params === null)) {
            params = {};
        }

        $(selector).dropzone({
            url: serverUrl + "/xhr/infraction",
            paramName: 'file',
            acceptedFiles: '.jpg,.jpeg,.png,.gif,.webp,.avif,.pdf,.doc,.docx,.odt,.xls,.xlsx,.ods',
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop file here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            params: params,
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);
                    myDropzone.removeFile(file);

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }

                    if (response.success) {
                        if ((params.preview !== undefined) && (response.content !== undefined)) {
                            $(params.preview).prepend(response.content);
                        }
                    }
                });
            }
        });
    },
    removeParent: function (selector, target) {
        if (App.confirm("Are you sure?\nOnce deleted, you will not be able to recover this file!")) {
            $(selector).parents(target).eq(0).remove();
        }
    },
    submitVerification: function (selector) {
        let form = $(selector);

        $.post(serverUrl + '/xhr/verification', form.serialize(), function (response) {
            if (response) {
                $('input, select, textarea', form).removeClass('is-invalid');
                $('.valid-feedback, .invalid-feedback', form).remove();

                if (response.fields !== undefined) {
                    $.each(response.fields, function (field, error) {
                        $('#' + field).addClass('is-invalid').parent().append($('<div/>', {
                            'class': 'invalid-feedback',
                            'html': error
                        }));
                    });
                }

                if (response.error !== undefined) {
                    Swal.fire({
                        title: 'Error',
                        text: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                } else if (response.warning !== undefined) {
                    Swal.fire({
                        title: 'Warning',
                        text: response.warning,
                        icon: 'warning',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                } else if (response.success !== undefined) {
                    $('input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="date"], select, textarea', form).val('');

                    Swal.fire({
                        title: 'Success',
                        text: response.success,
                        icon: 'success',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd',
                        willClose: () => {
                            window.location.reload();
                        }
                    });
                }
            }
        }, 'json');

        return false;
    },
    vehicleDropzone: function(selector) {
        $(selector).dropzone({
            url: "/xhr/vehicle_picture",
            maxFiles: 100,
            paramName: 'file',
            acceptedFiles: 'image/*',
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop files here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            renameFile: function(file) {
                let filename = $.trim($('#vehicle-product').val());

                if (filename.length) {
                    $('#vehicle-product').val('');
                    return filename.replace(' ', '_') + '.' + file.name.split('.').pop();
                }

                return file.name;
            },
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }
                });
            }
        });
    },
    fitguideToLabor: function(selector, vehicle, mini, groupped) {
        $(selector).on('click', function() {
            let isSelected = false;

            $(selector).each(function() {
                if ($(this).prop('checked')) {
                    isSelected = true;
                }
            });

            if (isSelected) {
                $('.transfer-fitguide').removeClass('d-none');
            } else {
                $('.transfer-fitguide').addClass('d-none');
            }
        });

        $(selector).each(function() {
            $(this).on('click', function() {
                if ((typeof groupped === 'string') || (groupped instanceof String)) {
                    if ($(this).hasClass(groupped + '-parent')) {
                        $('.' + groupped + '-children').prop('checked', $(this).prop('checked'));
                    }

                    if ($(this).hasClass(groupped + '-children')) {
                        $('.' + groupped + '-parent').prop('checked', $(this).prop('checked'));
                    }
                }
            });
        });

        $('.transfer-fitguide').on('click', function() {
            window.location.assign('/' + (mini === true ? 'touchscreen-' : '') + 'labor-calculator?vehicle=' + vehicle + '&' + $('.vehicle-product').filter(function() {
                return ((parseInt($(this).val()) > 0) ? true : false);
            }).serialize() + '&' + $('.labor-product').filter(function() {
                return ((parseInt($(this).val()) > 0) ? true : false);
            }).serialize() + '&' + $('.labor-qty').filter(function() {
                return ((parseInt($(this).val()) > 0) ? true : false);
            }).serialize() + '&' + $('.labor-price').filter(function() {
                return ((parseInt($(this).val()) > 0) ? true : false);
            }).serialize());
        });
    },
    articleDropzone: function(selector) {
        let params = $(selector).data('params');

        if ((params === undefined) || (params === null)) {
            params = {};
        }

        $(selector).dropzone({
            url: serverUrl + "/xhr/article",
            maxFiles: 100,
            paramName: 'file',
            acceptedFiles: '.jpg,.jpeg,.png,.gif,.webp,.avif,.pdf,.doc,.docx,.odt,.xls,.xlsx,.ods',
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop file here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            params: params,
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);
                    myDropzone.removeFile(file);

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }

                    if (response.success) {
                        if ((params.preview !== undefined) && (response.content !== undefined)) {
                            $(params.preview).prepend(response.content);
                        }
                    }
                });
            }
        });
    },
    autocompleteLabor: function(selector, matrix, store) {
        $(selector).typeahead(
            {
                highlight: true,
                minLength: 2,
                classNames: {
                    input: 'form-control',
                    hint: 'text-muted',
                    menu: 'dropdown-menu mt-1',
                    dataset: '',
                    suggestion: 'dropdown-item',
                    empty: 'text-muted',
                    open: 'show',
                    cursor: 'text-primary',
                    highlight: 'text-danger',
                }
            },
            {
                name: 'autocomplete',
                limit: 30,
                source: new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: '/xhr/autocomplete?matrix=' + matrix + '&store=' + store + '&q=%QUERY',
                        wildcard: '%QUERY',
                        transform: function(response) {
                            if (response.response !== undefined) {
                                return response.response;
                            } else {
                                return response;
                            }
                        }
                    }
                }),
                templates: {
                    suggestion: function(obj) {
                        return $('<div/>', {
                            class: 'widget-typeahead-result',
                            html: obj.suggestion
                        });
                    }
                },
                display: function(obj) {
                    return obj.value;
                }
            }
        ).on('typeahead:select', function(e, suggestion) {
            $.getJSON(serverUrl + '/xhr/matrix', {
                model: suggestion.value.toUpperCase(),
                matrix: matrix,
                store: store
            }, function (response) {
                let price = suggestion.price;
                let selected = suggestion.select;
                let found = false;

                if (response.matrix) {
                    price = response.matrix;
                    selected = selected.replace(/\<span class=\"price\"\>\$(.)*\<\/span\>/, '<span class="price">' + price +'</span>');
                }

                $('#labor-products > .widget-products .product').each(function() {
                    if ($(this).data('model') == suggestion.value.toUpperCase()) {
                        found = $(this);
                    }
                });

                if (found === false) {
                    found = $('<div/>', {
                        class: 'product',
                        html: selected
                    }).data('model', suggestion.value.toUpperCase())
                        .data('price', price)
                        .append($('<div/>', {
                            class: 'row',
                            html: '<div class="col-6 text-start"><input type="number" min="1" step="1" value="1" class="form-control labor-product" name="product[' + suggestion.value + '][]" data-price="' + price + '" onfocus="this.oldValue = this.value" onchange="App.updateLaborProduct(this);"></div><div class="col-6 text-end"><button type="button" class="btn btn-danger" onclick="App.removeLaborProduct(this);"><span class="fas fa-fw fa-trash"></span></button></div>'
                        }));
                    $('#labor-products > .widget-products').append(found);
                } else {
                    let qty = $('.labor-product', found);
                    qty.val(parseInt(qty.val()) + 1);
                }

                $('#labor-products').removeClass('d-none');
                $(selector).typeahead('val', '');
                App.laborQty();
                App.laborAlternative(suggestion.value, price, matrix, store);

                if (suggestion.field_12) {
                    $.getJSON(serverUrl + '/xhr/addons', {
                        field_12: suggestion.field_12,
                        matrix: matrix,
                        store: store
                    }, function (response) {
                        let value_parts = '';
                        let value_shop = '';

                        if (response.parts) {
                            value_parts = response.parts;
                            found.data('parts', response.parts);
                        }

                        if (response.shop) {
                            value_shop = response.shop;
                            found.data('shop', response.shop);
                        }

                        if (response.products) {
                            let addons = [];

                            for (const product of response.products) {
                                let existing = false;

                                addons.push(product.value.toUpperCase() + '::' + product.qty);

                                $('#labor-products > .widget-products .product').each(function() {
                                    if ($(this).data('model') == product.value.toUpperCase()) {
                                        existing = $(this);
                                    }
                                });

                                if (existing === false) {
                                    existing = $('<div/>', {
                                        class: 'product',
                                        html: product.select
                                    }).data('model', product.value.toUpperCase())
                                    .data('price', product.price)
                                    .append($('<div/>', {
                                        class: 'row',
                                        html: '<div class="col-6 text-start"><input type="number" min="1" step="1" value="' + product.qty + '" class="form-control labor-product" name="product[' + product.value + '][]" data-price="' + product.price + '" onchange="App.laborQty()"></div><div class="col-6 text-end"><button type="button" class="btn btn-danger" onclick="App.removeLaborProduct(this);"><span class="fas fa-fw fa-trash"></span></button></div>'
                                    }));

                                    $('#labor-products > .widget-products').append(existing);
                                } else {
                                    let qty = $('.labor-product', existing);
                                    qty.val(parseInt(qty.val()) + parseInt(product.qty));
                                }
                            }

                            found.data('field_12', addons.join(','));

                            $('#labor-products').removeClass('d-none');
                            $(selector).typeahead('val', '');
                            App.laborQty();
                        }
                    });
                }

                if (suggestion.field_14) {
                    found.data('field_14', suggestion.field_14.toLowerCase());
                    $('.labor-qty').each(function() {
                        if ($(this).data('type').toLowerCase() == suggestion.field_14.toLowerCase()) {
                            $(this).val(parseInt($(this).val()) + 1);
                            App.laborQty();
                        }
                    });
                }
            });
        });
    },
    laborAlternatives: function(matrix, store) {
        $('#labor-products .product').each(function() {
            App.laborAlternative($(this).data('model'), $(this).data('price'), matrix, store);
        });
    },
    laborAlternative: function(model, max, matrix, store) {
        $.getJSON(serverUrl + '/xhr/alternative', {
            model: model,
            max: max,
            matrix: matrix,
            store: store
        }, function (response) {
            if (response.alternative) {
                $('#labor-alternatives').append(
                    $('<a/>', {
                        class: 'd-block mt-3 fs-5',
                        html: (window.location.pathname.indexOf('touchscreen') !== -1 ? '<i class="fas fa-cart-arrow-down text-danger me-3"></i>Explore lower priced option:' : 'Respark the sale? Drop quote to') + ' <strong class="text-primary">$<span class="labor-alternative" data-price="' + response.alternative.diff + '">0.00</span> + tax</strong> by replacing <strong class="text-danger">' + model + '</strong> with <strong class="text-success">' + response.alternative.value + '</strong>'
                    })
                    .data('model', model.toUpperCase())
                    .on('click', function() {
                        let qty = 1;

                        $('#labor-products .product').each(function() {
                            if ($(this).data('model') === model.toUpperCase()) {
                                qty = $('input[type="number"]', $(this)).val();
                                App.removeLaborProduct($(this), true);
                            }
                        });

                        $(this).remove();

                        let found = $('<div/>', {
                            class: 'product',
                            html: response.alternative.select
                        })
                            .data('model', response.alternative.value.toUpperCase())
                            .data('price', response.alternative.price)
                            .append($('<div/>', {
                                class: 'row',
                                html: '<div class="col-6 text-start"><input type="number" min="1" step="1" value="' + qty + '" class="form-control labor-product" name="product[' + response.alternative.value + '][]" data-price="' + response.alternative.price + '" onfocus="this.oldValue = this.value" onchange="App.updateLaborProduct(this);"></div><div class="col-6 text-end"><button type="button" class="btn btn-danger" onclick="App.removeLaborProduct(this);"><span class="fas fa-fw fa-trash"></span></button></div>'
                            }));

                        $('#labor-products > .widget-products').append(found);

                        if (response.alternative.field_12) {
                            $.getJSON(serverUrl + '/xhr/addons', {
                                field_12: response.alternative.field_12,
                                matrix: matrix,
                                store: store
                            }, function (responseNested) {
                                let value_parts = '';
                                let value_shop = '';

                                if (responseNested.parts) {
                                    value_parts = responseNested.parts;
                                    found.data('parts', responseNested.parts);
                                }

                                if (responseNested.shop) {
                                    value_shop = responseNested.shop;
                                    found.data('shop', responseNested.shop);
                                }

                                if (responseNested.products) {
                                    let addons = [];

                                    for (const product of responseNested.products) {
                                        let existing = false;

                                        addons.push(product.value.toUpperCase() + '::' + product.qty);

                                        $('#labor-products > .widget-products .product').each(function() {
                                            if ($(this).data('model') == product.value.toUpperCase()) {
                                                existing = $(this);
                                            }
                                        });

                                        if (existing === false) {
                                            existing = $('<div/>', {
                                                class: 'product',
                                                html: product.select
                                            }).data('model', product.value.toUpperCase())
                                                .data('price', product.price)
                                                .append($('<div/>', {
                                                    class: 'row',
                                                    html: '<div class="col-6 text-start"><input type="number" min="1" step="1" value="' + product.qty + '" class="form-control labor-product" name="product[' + product.value + '][]" data-price="' + product.price + '" onchange="App.laborQty()"></div><div class="col-6 text-end"><button type="button" class="btn btn-danger" onclick="App.removeLaborProduct(this);"><span class="fas fa-fw fa-trash"></span></button></div>'
                                                }));

                                            $('#labor-products > .widget-products').append(existing);
                                        } else {
                                            let qty = $('.labor-product', existing);
                                            qty.val(parseInt(qty.val()) + parseInt(product.qty));
                                        }
                                    }

                                    found.data('field_12', addons.join(','));

                                    $('#labor-products').removeClass('d-none');
                                    App.laborQty();
                                }
                            });
                        }

                        if (response.alternative.field_14) {
                            found.data('field_14', response.alternative.field_14.toLowerCase());
                            $('.labor-qty').each(function() {
                                if ($(this).data('type').toLowerCase() == response.alternative.field_14.toLowerCase()) {
                                    $(this).val(parseInt($(this).val()) + 1);
                                    App.laborQty();
                                }
                            });
                        }

                        $('#labor-products').removeClass('d-none');
                        App.laborQty();
                        App.laborAlternative(response.alternative.value, response.alternative.price, matrix, store);
                    })
                );
            }
        });
    },
    removeLaborProduct: function(selector, direct) {
        let parent = false;
        let models = [];

        if (direct === true) {
            parent = $(selector);
        } else {
            parent = $(selector).parents('.product').eq(0);
        }

        let qty = parseInt(parent.val());

        let field_12 = parent.data('field_12');
        let field_14 = parent.data('field_14');

        if (field_12) {
            let fields = field_12.split(',');

            for (let i = 0; i < fields.length; i++) {
                let tokens = fields[i].split('::');

                $('#labor-products > .widget-products .product').each(function() {
                    if ($(this).data('model') == tokens[0]) {
                        if (parseInt($(this).val()) > (qty * parseInt(tokens[1]))) {
                            $('.labor-product', this).val(parseInt($('.labor-product', this).val()) - (qty * parseInt(tokens[1])));
                        } else {
                            $(this).remove();
                        }
                    }
                });
            }
        }

        if (field_14) {
            $('.labor-qty').each(function() {
                if ($(this).data('type').toLowerCase() == field_14) {
                    if (parseInt($(this).val()) > qty) {
                        $(this).val(parseInt($(this).val()) - qty);
                    } else {
                        $(this).val(0);
                    }
                }
            });
        }

        let model = parent.data('model');
        models.push(model);
        parent.remove();

        if ($('#labor-products > .widget-products > .product').length) {
            $('#labor-products').removeClass('d-none');
        } else {
            $('#labor-products').addClass('d-none');
        }

        $('#labor-alternatives a').each(function() {
            if ($(this).data('model') === model) {
                $(this).remove();
            }
        });

        App.laborQty();
        let link = new URL(window.location);
        link.search = '';

        if (window.history && window.history.pushState) {
            window.history.pushState({}, document.title, link);
        } else {
            window.location.href = link;
        }

        $.post(serverUrl + '/xhr/remove_transfer', {
            models: models.join(',')
        }, function() {
            window.location.reload();
        });
    },
    updateLaborProduct: function(selector) {
        let parent = $(selector).parents('.product').eq(0);
        let qty = parseInt($(selector).val());
        let oldQty = $(selector)[0].oldValue ? parseInt($(selector)[0].oldValue) : 1;
        let delta = qty - oldQty;

        if (qty === 0) {
            App.removeLaborProduct(selector);
            return true;
        }

        let field_12 = parent.data('field_12');
        let field_14 = parent.data('field_14');

        if (field_12) {
            let fields = field_12.split(',');

            for (let i = 0; i < fields.length; i++) {
                let tokens = fields[i].split('::');

                $('#labor-products > .widget-products .product').each(function() {
                    if ($(this).data('model') == tokens[0]) {
                        $('.labor-product', this).val(parseInt($('.labor-product', this).val()) + (delta * parseInt(tokens[1])));
                    }
                });
            }
        }

        if (field_14) {
            $('.labor-qty').each(function() {
                if ($(this).data('type').toLowerCase() == field_14) {
                    $(this).val(parseInt($(this).val()) + delta);
                }
            });
        }

        $(selector)[0].oldValue = qty;

        App.laborQty();
    },
    editFitguideLabor: function(vehicle) {
        let qs = $('.transfered-product').filter(function() {
            return ((parseInt($(this).val()) > 0) ? true : false);
        }).serialize() + '&' + $('.labor-product').filter(function() {
            return ((parseInt($(this).val()) > 0) ? true : false);
        }).serialize() + '&' + $('.labor-qty').filter(function() {
            return ((parseInt($(this).val()) > 0) ? true : false);
        }).serialize() + '&' + $('.labor-price').filter(function() {
            return ((parseInt($(this).val()) > 0) ? true : false);
        }).serialize() + '&' + $('.transfered-position').serialize();

        window.location.assign('/vehicle/read/id/' + vehicle + '?' + qs);
    },
    printLabor: function(vehicle) {
        let subtotal = $('#labor-subtotal').text();
        let parts = $('#labor-parts').text();
        let shop = $('#labor-shop').text();

        window.open('/print-labor-calculator?vehicle=' + vehicle + '&' + $('.labor-product').filter(function() {
            return ((parseInt($(this).val()) > 0) ? true : false);
        }).serialize() + '&subtotal=' + subtotal + '&parts=' + parts + '&shop=' + shop, '_blank');
    },
    checkVerificationMarket: function(selector, target) {
        let market = $(selector);

        if (market.prop('checked')) {
            $.getJSON(serverUrl + '/xhr/verification_market', {
                market: market.val()
            }, function (response) {
                if (response.response !== undefined) {
                    $(target).append(response.response);
                }
            });
        } else {
            $('.market-' + market.val(), target).remove();
        }
    },
    focusElement: function(selector) {
        $(selector).focus();
    },
    scheduleCalendar: function(selector, skip) {
        let days = {};
        let weekdays = {};
        let map = {};
        let errors = [];

        $('.schedule-date', selector).each(function() {
            days[$(this).data('date')] = $(this).data('day');

            const weekday = new Date($(this).data('date'));
            weekdays[$(this).data('date')] = weekday.getDay();
        });

        $('.schedule-types', selector).each(function() {
            if (!($(this).data('store') in map)) {
                map[$(this).data('store')] = {};
            }

            if (!($(this).val() in map[$(this).data('store')])) {
                map[$(this).data('store')][$(this).val()] = {};
            }

            map[$(this).data('store')][$(this).val()][$(this).data('user')] = $(this).data('username');
        });

        let salesMap = {},
            keyMap = {};

        for (let store in map) {
            salesMap[store] = {};
            keyMap[store] = {};

            for (let type in map[store]) {
                for (let user in map[store][type]) {
                    for (let day in days) {
                        let options = $('[name="days[' + store + '][' + user + '][' + day + ']"]', selector);

                        if (options.length) {
                            salesMap[store][day] = 0;
                            keyMap[store][day] = 0;
                        }
                    }
                }
            }
        }

        for (let store in map) {
            let hasKey = false;

            for (let type in map[store]) {
                for (let user in map[store][type]) {
                    let hasChosen = true;
                    let stores = [];
                    // let numWorking = 0;
                    let isKey = ($('#alarm-' + store + '-' + user).val() === '1');

                    if (!hasKey && isKey) {
                        hasKey = true;
                    }

                    for (let day in days) {
                        let options = $('[name="days[' + store + '][' + user + '][' + day + ']"]', selector);

                        if (options.length) {
                            let dayChosen = false;

                            for (let option of options) {
                                if ($(option).val() !== '') {
                                    dayChosen = true;

                                    if ($(option).val() === 'store') {
                                        let my_store = $('#store-' + store + '-' + user + '-' + day).val();
                                        if (my_store.length && (stores.indexOf(my_store) === -1)) {
                                            stores.push(my_store);
                                        }
                                    }

                                    if (($(option).val() !== 'off') && ($(option).val() !== 'sto')) {
                                        // numWorking++;

                                        if (type === 'sales') {
                                            if ($(option).val() === 'store') {
                                                let custom_store = $('#store-' + store + '-' + user + '-' + day).val();

                                                if (custom_store !== '') {
                                                    if (!(custom_store in salesMap) || !(day in salesMap[custom_store])) {
                                                        salesMap[custom_store][day] = 0;
                                                    }

                                                    salesMap[custom_store][day]++;
                                                }
                                            } else {
                                                salesMap[store][day]++;
                                            }
                                        }

                                        if (isKey) {
                                            if ($(option).val() === 'store') {
                                                let custom_store = $('#store-' + store + '-' + user + '-' + day).val();

                                                if (custom_store !== '') {
                                                    if (!(custom_store in keyMap) || !(day in keyMap[custom_store])) {
                                                        keyMap[custom_store][day] = 0;
                                                    }

                                                    keyMap[custom_store][day]++;
                                                }
                                            } else {
                                                keyMap[store][day]++;
                                            }
                                        }
                                    } else if ((type === 'sales') && $(option).children().length === 1) {
                                        salesMap[store][day]++;
                                    }
                                }
                            }

                            if (!dayChosen) {
                                hasChosen = false;
                            }
                        }
                    }

                    if (!hasChosen) {
                        errors.push('Choose an option per day for <em class="fw-bolder">' + map[store][type][user] + '</em>');
                    }

                    if (stores.length > 2) {
                        errors.push('You cannot assign <em class="fw-bolder">' + map[store][type][user] + '</em> to more than 2 stores');
                    }

                    // if (numWorking > 5) {
                    //     errors.push('You cannot schedule <em class="fw-bolder">' + map[store][type][user] + '</em> more than 5 days per week');
                    // }
                }
            }

            if (!hasKey) {
                errors.push('No Key Holder for store <em class="fw-bolder">' + store + '</em>');
            }
        }

        for (let store in salesMap) {
            for (let day in salesMap[store]) {
                if ((salesMap[store][day] === 0) && ($('#availability-' + store + '-' + day).val() == '1')) {
                    if (!skip || !skip[store].length || (skip[store].indexOf(weekdays[day].toString()) == -1)) {
                        errors.push('No sales reps scheduled at store <em class="fw-bolder">' + store + '</em> on <em class="fw-bolder">' + days[day] + '</em>');
                    }
                }
            }
        }

        for (let store in keyMap) {
            for (let day in keyMap[store]) {
                if ((keyMap[store][day] === 0) && ($('#availability-' + store + '-' + day).val() == '1')) {
                    if (!skip || !skip[store].length || (skip[store].indexOf(weekdays[day].toString()) == -1)) {
                        errors.push('No key holder scheduled at store <em class="fw-bolder">' + store + '</em> on <em class="fw-bolder">' + days[day] + '</em>');
                    }
                }
            }
        }

        $('#schedule-errors').remove();

        if (errors.length) {
            $('body').append($('<div/>', {
                'id': 'schedule-errors',
                'class': 'position-fixed p-3',
                'style': 'top:0;right:0;',
                'html': '<div id="errorsToast" class="toast text-white bg-danger" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="false"><div class="toast-header text-white bg-danger"><strong class="me-auto">Schedule Errors</strong><button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="toast-body" style="max-height: 800px; overflow: auto;"><ul class="ps-2 mb-0"><li>' + errors.join('</li><li>') + '</li></ul></div></div></div>'
            }));

            let toast = new Toast(document.getElementById('errorsToast'));
            toast.show();

            $(window).on('scroll resize orientationchange', function(e) {
                let distance = Math.round($(window).scrollTop()),
                    width = $(window).width(),
                    offset = $('#weekdays').height() + 30;

                if ((distance > offset) && (width < 2030)) {
                    $('#schedule-errors').css('top', offset + 'px');
                } else {
                    $('#schedule-errors').css('top', '0px');
                }
            });

            return false;
        }

        if ($('#canproceed', selector).length) {
            $('#canproceed', selector).remove();
        }

        $(selector).append($('<input>', {
            type: 'hidden',
            id: 'canproceed',
            name: 'canproceed',
            value: 'yes'
        }));

        return true;
    },
    scheduleCalendarOption: function(selector) {
        $(selector).siblings().addClass('d-none').prop('required', false);
        $(selector).removeClass('text-white');
        $(selector).removeClass('text-dark');
        $(selector).removeClass('bg-primary');
        $(selector).removeClass('bg-info');
        $(selector).removeClass('bg-success');
        $(selector).removeClass('bg-secondary');
        $(selector).removeClass('bg-danger');

        if ($(selector).val() == 'store') {
            $(selector).addClass('bg-primary text-white');
            $(selector).siblings('.via-store').removeClass('d-none').prop('required', true).eq(0).focus();
        } else if ($(selector).val() == 'custom') {
            $(selector).addClass('bg-info text-dark');
            $(selector).siblings('.via-custom').removeClass('d-none').prop('required', true).eq(0).focus();
        } else if ($(selector).val() == 'on') {
            $(selector).addClass('bg-success text-white');
        } else if ($(selector).val() == 'off') {
            $(selector).addClass('bg-secondary text-white');
        } else if ($(selector).val() == 'sto') {
            $(selector).addClass('bg-danger text-white');
        }
    },
    scheduleCalendarSave: function(selector) {
        let form = $(selector).parents('form').eq(0);

        $.post(
            serverUrl + '/xhr/autosave_schedule',
            form.serialize(),
            null,
            'json'
        );
    },
    employeeByMarket: function(target, selector, preserve) {
        let market = $(selector).val(),
            employee = $(target),
            value = false;

        if (preserve === true) {
            value = employee.val();
        }

        $('option', employee).filter(function() {
            return ($(this).attr('value') != '');
        }).remove();

        $.getJSON(
            serverUrl + '/xhr/employee_by_market',
            {
                'market': market
            },
            function(response) {
                if (response.employees) {
                    $.each(response.employees, function() {
                        employee.append($('<option/>', {
                            value: this.key,
                            text: this.value
                        }).data('caption', this.caption));
                    });

                    if (value !== false) {
                        employee.val(value);
                    }
                }
            }
        );
    },
    calendarOptionsPrepare: function(selector) {
        $('input[type="text"], input[type="date"], input[type="checkbox"], select, textarea', selector).each(function() {
            $(this).parents('.form-group').eq(0).addClass('d-none');
        });
    },
    calendarOptionsClear: function(current, other) {
        if (current !== false) {
            $(current).removeClass('d-none');

            $('input[type="text"], input[type="date"], input[type="time"], input[type="checkbox"], select, textarea', current).first().prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
        }

        $(other).addClass('d-none');
        $('input[type="text"], input[type="date"], input[type="time"], select, textarea', other).val('');
        $('input[type="checkbox"]', other).prop('checked', false);
        $('input[type="date"]', other).removeAttr('min').removeAttr('max');

        $('input[type="text"], input[type="date"], input[type="time"], input[type="checkbox"], select, textarea', other).each(function() {
            $(this).parents('.form-group').eq(0).addClass('d-none');
            $(this).prop('required', false);
        });
    },
    calendarOptions: function(selector, prefix) {
        let form = $(selector).parents('form').eq(0);

        switch ($(prefix + 'type').val()) {
            case 'event':
                App.calendarOptionsClear(prefix + 'fieldset-event', prefix + 'fieldset-sale, ' + prefix + 'fieldset-meeting, ' + prefix + 'fieldset-sto, ' + prefix + 'fieldset-notice');

                switch ($(prefix + 'event_location').val()) {
                    case 'store':
                        $(prefix + 'event_store').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                        $(prefix + 'event_market').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'event_address').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'event_permit').prop('required', false).parents('.form-group').eq(0).addClass('d-none');

                        if ($(prefix + 'event_store').val() != '') {
                            $(prefix + 'event_permit').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                        } else {
                            $(prefix + 'event_permit').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        }
                        break;
                    case 'offsite':
                        $(prefix + 'event_market').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                        $(prefix + 'event_address').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                        $(prefix + 'event_permit').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                        $(prefix + 'event_store').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        break;
                    default:
                        $(prefix + 'event_market').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'event_address').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'event_store').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'event_permit').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'event_address').val('');
                        $(prefix + 'event_store').val('');
                        $(prefix + 'event_permit').val('');
                        break;
                }

                if ($(prefix + 'event_permit').val() != '') {
                    $(prefix + 'event_title').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                    $(prefix + 'event_date-begin').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                    $(prefix + 'event_details').parents('.form-group').eq(0).removeClass('d-none');
                } else {
                    $(prefix + 'event_title').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'event_date-begin').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'event_details').parents('.form-group').eq(0).addClass('d-none');
                }
                break;
            case 'sale':
                App.calendarOptionsClear(prefix + 'fieldset-sale', prefix + 'fieldset-event, ' + prefix + 'fieldset-meeting, ' + prefix + 'fieldset-sto, ' + prefix + 'fieldset-notice');

                switch ($(prefix + 'sale_type').val()) {
                    case 'store':
                        $(prefix + 'sale_store').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                        $(prefix + 'sale_market').prop('required', false).parents('.form-group').eq(0).addClass('d-none');

                        if ($(prefix + 'sale_store').val() != '') {
                            $(prefix + 'sale_title').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                            $(prefix + 'sale_date-begin').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                            $(prefix + 'sale_details').parents('.form-group').eq(0).removeClass('d-none');
                        } else {
                            $(prefix + 'sale_title').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                            $(prefix + 'sale_date-begin').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                            $(prefix + 'sale_details').parents('.form-group').eq(0).addClass('d-none');
                        }
                        break;
                    case 'market':
                        $(prefix + 'sale_market').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                        $(prefix + 'sale_store').prop('required', false).parents('.form-group').eq(0).addClass('d-none');

                        if ($(prefix + 'sale_market').val() != '') {
                            $(prefix + 'sale_title').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                            $(prefix + 'sale_date-begin').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                            $(prefix + 'sale_details').parents('.form-group').eq(0).removeClass('d-none');
                        } else {
                            $(prefix + 'sale_title').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                            $(prefix + 'sale_date-begin').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                            $(prefix + 'sale_details').parents('.form-group').eq(0).addClass('d-none');
                        }
                        break;
                    case 'company':
                        $(prefix + 'sale_market').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'sale_store').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'sale_title').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                        $(prefix + 'sale_date-begin').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                        $(prefix + 'sale_details').parents('.form-group').eq(0).removeClass('d-none');
                        break;
                    default:
                        $(prefix + 'sale_market').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'sale_store').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'sale_title').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'sale_date-begin').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                        $(prefix + 'sale_details').parents('.form-group').eq(0).addClass('d-none');
                        break;
                }
                break;
            case 'meeting':
                App.calendarOptionsClear(prefix + 'fieldset-meeting', prefix + 'fieldset-event, ' + prefix + 'fieldset-sale, ' + prefix + 'fieldset-sto, ' + prefix + 'fieldset-notice');

                if ($(prefix + 'meeting_market').val()) {
                    $(prefix + 'meeting_attendance-Technicians').parents('.form-group').eq(0).removeClass('d-none');
                } else {
                    $(prefix + 'meeting_attendance-Technicians').parents('.form-group').eq(0).addClass('d-none');

                    $(prefix + 'meeting_attendance-SalesReps').prop('checked', false);
                    $(prefix + 'meeting_attendance-Technicians').prop('checked', false);
                    $(prefix + 'meeting_attendance-StockroomPersonnel').prop('checked', false)
                }

                if ($(prefix + 'meeting_attendance-SalesReps').prop('checked') || $(prefix + 'meeting_attendance-Technicians').prop('checked') || $(prefix + 'meeting_attendance-StockroomPersonnel').prop('checked')) {
                    $(prefix + 'meeting_title').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                    $(prefix + 'meeting_date-date').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                    $(prefix + 'meeting_date-time').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                    $(prefix + 'meeting_store').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                    $(prefix + 'meeting_details').parents('.form-group').eq(0).removeClass('d-none');
                } else {
                    $(prefix + 'meeting_title').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'meeting_date-date').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'meeting_date-time').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'meeting_store').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'meeting_details').parents('.form-group').eq(0).addClass('d-none');
                }
                break;
            case 'sto':
                App.calendarOptionsClear(prefix + 'fieldset-sto', prefix + 'fieldset-event, ' + prefix + 'fieldset-sale, ' + prefix + 'fieldset-meeting, ' + prefix + 'fieldset-notice');

                if ($(prefix + 'sto_market').val()) {
                    $(prefix + 'sto_employee').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                } else {
                    $(prefix + 'sto_employee').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'sto_employee').val('');
                }

                if ($(prefix + 'sto_employee').val()) {
                    $(prefix + 'sto_date-begin').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                    $(prefix + 'sto_details').parents('.form-group').eq(0).removeClass('d-none');
                } else {
                    $(prefix + 'sto_date-begin').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'sto_details').parents('.form-group').eq(0).addClass('d-none');
                }
                break;
            case 'notice':
                App.calendarOptionsClear(prefix + 'fieldset-notice', prefix + 'fieldset-event, ' + prefix + 'fieldset-sale, ' + prefix + 'fieldset-meeting, ' + prefix + 'fieldset-sto');

                if ($(prefix + 'notice_market').val()) {
                    $(prefix + 'notice_title').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                    $(prefix + 'notice_date-begin').prop('required', true).parents('.form-group').eq(0).removeClass('d-none');
                    $(prefix + 'notice_details').parents('.form-group').eq(0).removeClass('d-none');
                } else {
                    $(prefix + 'notice_title').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'notice_date-begin').prop('required', false).parents('.form-group').eq(0).addClass('d-none');
                    $(prefix + 'notice_details').parents('.form-group').eq(0).addClass('d-none');
                }
                break;
            default:
                App.calendarOptionsClear(false, prefix + 'fieldset-event, ' + prefix + 'fieldset-sale, ' + prefix + 'fieldset-meeting, ' + prefix + 'fieldset-sto, ' + prefix + 'fieldset-notice');
                break;
        }
    },
    submitForm: function(selector) {
        $(selector).parents('form').eq(0).submit();
    },
    setFormSiblingValue: function(selector, target) {
        $(selector).parents('form').eq(0).find(target).text($(selector).val());
    },
    hidePopovers: function(target) {
        if (!target) {
            target = 'body';
        }

        $('[data-bs-toggle="popover"]', target).popover('hide');
    },
    editCalendar: function(id) {
        if ($('#modal-edit-calendar').length) {
            $('#modal-edit-calendar').remove();
        }

        $.getJSON(serverUrl + '/xhr/calendar_edit', {'id': id}, function (response) {
            if (response) {
                if (response.error !== undefined) {
                    Swal.fire({
                        title: 'Error',
                        text: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                } else if (response.html !== undefined) {
                    $('body').append($('<div/>', {
                        'id': 'modal-edit-calendar',
                        'class': 'modal fade',
                        'tabindex': '-1',
                        'role': 'dialog',
                        'aria-hidden': 'true',
                        'html': response.html
                    }));

                    let modal = Modal.getOrCreateInstance(document.querySelector('#modal-edit-calendar'));
                    modal.show();

                    App.init('#modal-edit-calendar');
                    App.calendarOptions('#calendar_edit-type', '#calendar_edit-');
                }
            }
        });
    },
    submitEditCalendar: function(form, id) {
        $.post(
            serverUrl + '/xhr/calendar_edit?id=' + id,
            $(form).serialize(),
            function (response) {
                if (response) {
                    if (response.error !== undefined) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }  else if (response.success !== undefined) {
                        Swal.fire({
                            title: 'Success',
                            text: response.success,
                            icon: 'success',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd',
                            willClose: () => {
                                window.location.reload();
                            }
                        });
                    } else if (response.html !== undefined) {
                        $(form).parent().html(response.html);

                        App.init('#modal-edit-calendar');
                    }
                }
            },
            'json'
        );

        return false;
    },
    deleteCalendar: function(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this event!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            denyButtonColor: '#dc3545',
            cancelButtonColor: '#adb5bd',
            confirmButtonText: "Yes, delete"
        }).then((result) => {
            if (result.isConfirmed) {
                $.post(serverUrl + '/xhr/calendar_delete', {'id': id}, function (response) {
                    if (response) {
                        if (response.error !== undefined) {
                            Swal.fire({
                                title: 'Error',
                                text: response.error,
                                icon: 'error',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else if (response.success !== undefined) {
                            Swal.fire({
                                title: 'Success',
                                text: response.success,
                                icon: 'success',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd',
                                willClose: () => {
                                    window.location.reload();
                                }
                            });
                        }
                    }
                }, 'json');
            }
        });
    },
    autocompleteTicketCustomer: function(selector, mode, targets) {
        $(selector).typeahead(
            {
                highlight: true,
                minLength: 2,
                classNames: {
                    input: 'form-control',
                    hint: 'text-muted',
                    menu: 'dropdown-menu mt-1',
                    dataset: '',
                    suggestion: 'dropdown-item',
                    empty: 'text-muted',
                    open: 'show',
                    cursor: 'text-primary',
                    highlight: 'text-danger',
                }
            },
            {
                name: 'autocomplete',
                limit: 30,
                source: new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: '/xhr/autocomplete-ticket-customer?mode=' + mode + '&q=%QUERY',
                        wildcard: '%QUERY',
                        transform: function(response) {
                            if (response.response !== undefined) {
                                return response.response;
                            } else {
                                return response;
                            }
                        },
                        prepare: function(query, settings) {
                            if (mode === 'name') {
                                settings.url = settings.url.replace(/%QUERY/g, encodeURIComponent($.trim($(targets.fname).val() + ' ' + query)));
                            } else {
                                settings.url = settings.url.replace(/%QUERY/g, encodeURIComponent($.trim(query)));
                            }

                            return settings;
                        }
                    }
                }),
                templates: {
                    suggestion: function(obj) {
                        return $('<div/>', {
                            class: 'widget-typeahead-result',
                            html: obj.suggestion
                        });
                    }
                },
                display: function(obj) {
                    if (mode === 'name') {
                        return obj.lname;
                    } else if (mode === 'phone') {
                        return obj.phone;
                    } else if (mode === 'email') {
                        return obj.email;
                    }

                    return obj.id;
                }
            }
        ).on('typeahead:select', function(e, suggestion) {
            $(targets.fname).val(suggestion.fname);
            $(targets.lname).val(suggestion.lname);
            $(targets.phone).val(suggestion.phone);
            $(targets.mobile).val(suggestion.mobile);
            $(targets.email).val(suggestion.email);
            $(targets.vehicles).empty();

            if (suggestion.vehicles) {
                let card = $('<div/>', {
                    class: 'card mb-3'
                });
                let header = $('<h6/>', {
                    class: 'card-header',
                    text: 'Existing Vehicles'
                });
                let list = $('<div/>', {
                    class: 'list-group list-group-flush'
                });

                for (const vehicle of suggestion.vehicles) {
                    list.append($('<button/>', {
                        class: 'list-group-item list-group-item-action',
                        text: vehicle.year + ' / ' + vehicle.make + ' / ' + vehicle.model + ' / ' + vehicle.color
                    }).on('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        $(targets.vehicle_year).val(vehicle.year);
                        $(targets.vehicle_color).val(vehicle.color);
                        $(targets.vehicle_make).children('option[value!=""]').remove();
                        $(targets.vehicle_model).children('option[value!=""]').remove();

                        $.getJSON(
                            '/xhr/fitguide/',
                            {
                                'action': 'wizard',
                                'year': vehicle.year
                            },
                            function (response) {
                                if (response.makes) {
                                    for (const make of response.makes) {
                                        $(targets.vehicle_make).append($('<option/>', {
                                            'value': make,
                                            'text': make
                                        }));
                                    }

                                    $(targets.vehicle_make).val(vehicle.make);
                                }
                            }
                        );

                        $.getJSON(
                            '/xhr/fitguide/',
                            {
                                'action': 'wizard',
                                'year': vehicle.year,
                                'make': vehicle.make
                            },
                            function (response) {
                                if (response.models) {
                                    for (const model of response.models) {
                                        $(targets.vehicle_model).append($('<option/>', {
                                            'value': model,
                                            'text': model
                                        }));
                                    };

                                    $(targets.vehicle_model).val(vehicle.model);
                                }
                            }
                        );
                    }));
                }

                card.append(header).append(list);
                $(targets.vehicles).html(card);
            }
        });
    },
    autocompleteTicketAr: function(selector) {
        $(selector).typeahead(
            {
                highlight: true,
                minLength: 2,
                classNames: {
                    input: 'form-control',
                    hint: 'text-muted',
                    menu: 'dropdown-menu mt-1',
                    dataset: '',
                    suggestion: 'dropdown-item',
                    empty: 'text-muted',
                    open: 'show',
                    cursor: 'text-primary',
                    highlight: 'text-danger',
                }
            },
            {
                name: 'autocomplete',
                limit: 30,
                source: new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: '/xhr/autocomplete-ticket-ar?q=%QUERY',
                        wildcard: '%QUERY',
                        transform: function(response) {
                            if (response.response !== undefined) {
                                return response.response;
                            } else {
                                return response;
                            }
                        }
                    }
                }),
                templates: {
                    suggestion: function(obj) {
                        return $('<div/>', {
                            class: 'widget-typeahead-result',
                            html: obj.suggestion
                        });
                    }
                },
                display: function(obj) {
                    return obj.display;
                }
            }
        ).on('typeahead:change', function (e, suggestion) {
            App.checkTicketPaymentMethod('.field-method');
        });
    },
    getElementByData: function(collection, key, value) {
        for (const element of collection) {
            if ($(element).data(key) === value) {
                return element;
            }
        }

        return null;
    },
    addTicketSalesperson: function(selector) {
        let id = App.addOption(selector);

        if (id) {
            App.autocompleteTicketSalesperson('#ticket-sales-user-' + id);
            $('#ticket-sales-user-' + id).focus();
        }
    },
    autocompleteTicketSalesperson: function(selector) {
        let amounts = $('.ticket_salesperson_amount'),
            names = $('.ticket_salesperson_name');

        $(selector).typeahead(
            {
                highlight: true,
                minLength: 2,
                classNames: {
                    input: 'form-control',
                    hint: 'text-muted',
                    menu: 'dropdown-menu mt-1',
                    dataset: '',
                    suggestion: 'dropdown-item',
                    empty: 'text-muted',
                    open: 'show',
                    cursor: 'text-primary',
                    highlight: 'text-danger',
                }
            },
            {
                name: 'autocomplete',
                limit: 30,
                source: new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: '/xhr/autocomplete-ticket-salesperson?q=%QUERY',
                        wildcard: '%QUERY',
                        transform: function (response) {
                            if (response.response !== undefined) {
                                return response.response;
                            } else {
                                return response;
                            }
                        },
                        prepare: function(query, settings) {
                            let users = [];

                            $('.ticket_salesperson_user').each(function(i, user) {
                                if ($(user).val().length && ($.trim(query) != $(user).val())) {
                                    users.push($(user).val());
                                }
                            });

                            settings.url = settings.url.replace(/%QUERY/g, encodeURIComponent($.trim(query)) + '&exclude=' + users.join(','));

                            return settings;
                        }
                    }
                }),
                templates: {
                    suggestion: function (obj) {
                        return $('<div/>', {
                            class: 'widget-typeahead-result',
                            html: obj.suggestion
                        });
                    }
                },
                display: function (obj) {
                    return obj.display;
                }
            }
        ).on('typeahead:select', function (e, suggestion) {
            let name = App.getElementByData(names, 'index', $(selector).data('index'));
            if (name) {
                $(name).text(suggestion.name).data('display', suggestion.display);
            }

            let amount = App.getElementByData(amounts, 'index', $(selector).data('index'));
            if (amount) {
                $(amount).prop('disabled', false).val(App.diffTicketPercent(amounts, $(selector).data('index')));
            }
        }).on('typeahead:change', function (e, suggestion) {
            let name = App.getElementByData(names, 'index', $(selector).data('index'));

            if (name && (suggestion != $(name).data('display'))) {
                $(selector).val('');
                $(name).text('');

                let amount = App.getElementByData(amounts, 'index', $(selector).data('index'));
                if (amount) {
                    $(amount).prop('disabled', true).val('');
                }

                App.amountTicketSalesperson(false);
            }
        });
    },
    amountTicketSalesperson: function(selector) {
        if (selector !== false) {
            if (($.trim($(selector).val()).length === 0) || (parseInt($(selector).val()) < 0) || (parseInt($(selector).val()) > 100)) {
                $(selector).val(0);
            } else {
                let value = parseFloat($(selector).val());
                $(selector).val((value > 0) ? (value === 100 ? 100 : value.toFixed(2)) : 0);
            }
        }

        App.adjustTicketPercent((selector !== false ? $(selector) : false), $('.ticket_salesperson_amount').filter(function(i, amount) {
            return $(amount).prop('disabled') === false;
        }));
    },
    diffTicketPercent: function(amounts, index) {
        let total = 100;

        amounts.each(function(i, amount) {
            if (($(amount).data('index') !== index) && $(amount).val()) {
                total = total - parseFloat($(amount).val());
            }
        });

        return ((total > 0) ? (total == 100 ? 100 : total.toFixed(2)) : 0);
    },
    adjustTicketPercent: function(current, all) {
        let total = 100 - ((current !== false) && $.trim(current.val()).length ? parseFloat(current.val()) : 0),
            amounts = all.filter(function(i, amount) {
                return (current === false) || ($(amount).data('index') !== current.data('index'));
            }),
            zeroes = amounts.filter(function(i, amount) {
                return ($.trim($(amount).val()).length === 0) || (parseFloat($(amount).val()) === 0);
            }),
            other = amounts.filter(function(i, amount) {
                return $(amount).val() && (parseFloat($(amount).val()) !== 0);
            }),
            otherTotal = 0;

        if (other.length) {
            other.each(function (i, amount) {
                otherTotal += parseFloat($(amount).val());
            });
        }

        amounts.each(function (i, amount) {
            if ($.trim($(amount).val()).length && (parseFloat($(amount).val()) > 0)) {
                $(amount).removeClass('is-invalid');
            }
        });

        if (current !== false) {
            if (amounts.length === 0) {
                $(current).val(100);
            } else if (amounts.length > 1) {
                if (((total - otherTotal) !== 0) || !$.trim(current.val()).length || (parseFloat(current.val()) == 0)) {
                    current.addClass('is-invalid');
                }

                return false;
            }
        }

        if (zeroes.length) {
            total -= otherTotal;

            if (total < 0) {
                total = 0;
            }

            zeroes.each(function (i, amount) {
                let value = total / zeroes.length;
                $(amount).val((value > 0) ? (value === 100 ? 100 : value.toFixed(2)) : 0);
            });
        } else {
            other.each(function (i, amount) {
                let value = total / other.length;
                $(amount).val((value > 0) ? (value === 100 ? 100 : value.toFixed(2)) : 0);
            });
        }
    },
    addTicketItem: function(selector) {
        let id = App.addOption(selector);

        if (id) {
            App.autocompleteTicketItem('#ticket-item-model-' + id, 0, 0);
            $('#ticket-item-model-' + id).focus();
        }
    },
    addTicketLabor: function(selector) {
        let id = App.addOption(selector, true);

        if (id) {
            App.addTicketTech('#techs-' + id);
            $('#ticket-item-price-' + id).focus();
        }
    },
    addTicketTech: function(selector) {
        let id = App.addOption(selector, false, /\$NEW/g);

        if (id) {
            App.autocompleteTicketLabor('#ticket-item-tech-' + selector.substring(7) + '-abbrev-' + id);
            $('#ticket-item-tech-' + selector.substring(7) + '-abbrev-' + id).focus();
        }
    },
    autocompleteTicketLabor: function(selector) {
        let parent = $(selector).parents('.tbody').eq(0),
            amounts = $('.ticket_item_tech_amount', parent),
            names = $('.ticket_item_tech_name', parent);

        $(selector).typeahead(
            {
                highlight: true,
                minLength: 2,
                classNames: {
                    input: 'form-control',
                    hint: 'text-muted',
                    menu: 'dropdown-menu mt-1',
                    dataset: '',
                    suggestion: 'dropdown-item',
                    empty: 'text-muted',
                    open: 'show',
                    cursor: 'text-primary',
                    highlight: 'text-danger',
                }
            },
            {
                name: 'autocomplete',
                limit: 30,
                source: new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: '/xhr/autocomplete-ticket-labor?q=%QUERY',
                        wildcard: '%QUERY',
                        transform: function (response) {
                            if (response.response !== undefined) {
                                return response.response;
                            } else {
                                return response;
                            }
                        },
                        prepare: function(query, settings) {
                            let users = [];

                            $('.ticket_item_tech_abbrev', parent).each(function(i, user) {
                                if ($(user).val().length && ($.trim(query) != $(user).val())) {
                                    users.push($(user).val());
                                }
                            });

                            settings.url = settings.url.replace(/%QUERY/g, encodeURIComponent($.trim(query)) + '&exclude=' + users.join(','));

                            return settings;
                        }
                    }
                }),
                templates: {
                    suggestion: function (obj) {
                        return $('<div/>', {
                            class: 'widget-typeahead-result',
                            html: obj.suggestion
                        });
                    }
                },
                display: function (obj) {
                    return obj.display;
                }
            }
        ).on('typeahead:select', function (e, suggestion) {
            let name = App.getElementByData(names, 'index', $(selector).data('index'));
            if (name) {
                $(name).text(suggestion.name).data('display', suggestion.display);
            }

            let amount = App.getElementByData(amounts, 'index', $(selector).data('index'));
            if (amount) {
                $(amount).prop('disabled', false).val(App.diffTicketPercent(amounts, $(selector).data('index')), amounts);
            }
        }).on('typeahead:change', function (e, suggestion) {
            let name = App.getElementByData(names, 'index', $(selector).data('index'));

            if (name && (suggestion != $(name).data('display'))) {
                $(selector).val('');
                $(name).text('');

                let amount = App.getElementByData(amounts, 'index', $(selector).data('index'));
                if (amount) {
                    $(amount).prop('disabled', true).val('');
                }

                App.amountTicketTech(false, $(selector).parents('.techs').eq(0));
            }
        });
    },
    amountTicketTech: function(selector, backup) {
        if (selector !== false) {
            if (($.trim($(selector).val()).length === 0) || (parseInt($(selector).val()) < 0) || (parseInt($(selector).val()) > 100)) {
                $(selector).val(0);
            } else {
                let value = parseFloat($(selector).val());
                $(selector).val((value > 0) ? (value === 100 ? 100 : value.toFixed(2)) : 0);
            }
        }

        App.adjustTicketPercent((selector !== false ? $(selector) : false), $('.ticket_item_tech_amount', (selector !== false ? $(selector).parents('.techs').eq(0) : $(backup))).filter(function(i, amount) {
            return $(amount).prop('disabled') === false;
        }));
    },
    autocompleteTicketItem: function(selector, market, store) {
        $(selector).typeahead(
            {
                highlight: true,
                minLength: 2,
                classNames: {
                    input: 'form-control',
                    hint: 'text-muted',
                    menu: 'dropdown-menu mt-1',
                    dataset: '',
                    suggestion: 'dropdown-item',
                    empty: 'text-muted',
                    open: 'show',
                    cursor: 'text-primary',
                    highlight: 'text-danger',
                }
            },
            {
                name: 'autocomplete_inventory',
                limit: 30,
                source: new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: '/xhr/autocomplete_inventory?q=%QUERY&market=' + market + '&store=' + store,
                        wildcard: '%QUERY',
                        transform: function(response) {
                            if (response.response !== undefined) {
                                return response.response;
                            } else {
                                return response;
                            }
                        }
                    }
                }),
                templates: {
                    suggestion: function(obj) {
                        return $('<div/>', {
                            class: 'widget-typeahead-result',
                            html: obj.suggestion
                        });
                    }
                },
                display: function(obj) {
                    return obj.model;
                }
            }
        ).on('typeahead:select', function(e, suggestion) {
            $(selector).data('display', suggestion.model);
            let parent = $(selector).parents('.tr').eq(0);

            $('.value-qty', parent).text(suggestion.quantity + ' available');
            $('.value-price1', parent).text('$' + suggestion.price1);
            $('.value-price2', parent).text('$' + suggestion.price2);
            $('.value-price3', parent).text('$' + suggestion.price3);
            $('.value-price4', parent).text('$' + suggestion.price4);

            $('.field-qty', parent).val(1).data('max', suggestion.quantity);
            $('.field-price', parent).val(suggestion.price2);
            $('.field-total', parent).val(suggestion.price2);

            $('.wrap-values', parent).removeClass('d-none');

            $('[disabled]', parent).prop('disabled', false);

            App.statsTicketItems();
            App.releasesTicketItems("#items-ticket");
        }).on('typeahead:change', function (e, suggestion) {
            if (suggestion != $(selector).data('display')) {
                $(selector).data('display', '');
                let parent = $(selector).parents('.tr').eq(0);

                $('.value-qty', parent).text('');
                $('.value-price1', parent).text('');
                $('.value-price2', parent).text('');
                $('.value-price3', parent).text('');
                $('.value-price4', parent).text('');

                $('.field-qty', parent).val(0);
                $('.field-price', parent).val('');
                $('.field-total', parent).val('');

                $('.wrap-values', parent).addClass('d-none');

                $('input, select, textarea', parent).not($(selector)).prop('disabled', true);

                App.statsTicketItems();
                App.releasesTicketItems("#items-ticket");
            }
        });
    },
    subtotalTicketItem: function(selector) {
        let parent = $(selector).parents('.tr').eq(0);

        if ($('.field-qty', parent).val() < 1) {
            $('.field-qty', parent).val(1);
        }

        if ($('.field-price', parent).val() < 0.01) {
            $('.field-price', parent).val(0.01);
        }

        if ($('.field-qty', parent).val() > $('.field-qty', parent).data('max')) {
            if (!confirm('Are you sure you are selling the correct item? You are about to sell into a negative quantity!')) {
                $('.field-qty', parent).val($('.field-qty', parent).data('max'));
            }
        }

        $('.field-total', parent).val(($('.field-qty', parent).val() * $('.field-price', parent).val()).toFixed(2));

        if ($('.field-type', parent).val() == 'Incoming') {
            $('.mode', parent).text('-');
        } else {
            $('.mode', parent).text('+');
        }

        App.statsTicketItems();
        App.releasesTicketItems("#items-ticket");
    },
    statsTicketItems: function() {
        let subtotal = 0,
            taxes = 0;

        $('.field-total').each(function() {
            if ($(this).val().length) {
                let value = parseFloat($(this).val()),
                    parent = $(this).parents('.tr').eq(0);

                if ($('.field-type', parent).val() === 'Incoming') {
                    subtotal = subtotal - value;
                } else {
                    subtotal = subtotal + value;

                    if ((typeof taxRates !== 'undefined') && (value > 0)) {
                        let store = parseInt($('.field-store', parent).val());

                        if (taxRates.hasOwnProperty(store)) {
                            taxes = taxes + parseFloat(((taxRates[store] * value) * 0.01).toFixed(2));
                        }
                    }
                }
            }
        });

        $('.ticket-subtotal').text((subtotal < 0 ? '-' : '') + '$' + Math.abs(subtotal).toFixed(2));
        $('.ticket-taxes').text((taxes < 0 ? '-' : '') + '$' + Math.abs(taxes).toFixed(2));
        $('.ticket-total').data('total', subtotal + taxes).text(((subtotal + taxes) < 0 ? '-' : '') + '$' + Math.abs((subtotal + taxes)).toFixed(2));

        App.subtotalTicketPayment();
    },
    checkTicketPaymentMethod: function (selector) {
        if (typeof paymentMethods !== 'undefined') {
            $(selector, '#payments').children().each(function () {
                if (paymentMethods.hasOwnProperty($(this).attr('value')) && (paymentMethods[$(this).attr('value')]['type'] == 'ar')) {
                    $(this).prop('disabled', $.trim($('#ticket-ar').val()).length ? false : true);

                    if (($(this).parent().val() == $(this).attr('value')) && !$.trim($('#ticket-ar').val()).length) {
                        $(this).parent().val('');
                    }
                }
            });
        }
    },
    addTicketPayment: function(selector) {
        let id = App.addOption(selector);

        if (id) {
            App.checkTicketPaymentMethod('#ticket-payment-method-' + id);
            $('#ticket-payment-method-' + id).focus();
        }
    },
    enableTicketPayment: function(selector) {
        let parent = $(selector).parents('.tr').eq(0);

        $('.field-notes', parent).prop('disabled', ($(selector).val() == '')).val('');
        $('.field-amount', parent).prop('disabled', ($(selector).val() == '')).val('');

        if (typeof paymentMethods !== 'undefined') {
            if (paymentMethods.hasOwnProperty($(selector).val()) && (paymentMethods[$(selector).val()]['type'] == 'cash')) {
                $('.field-rendered', parent).prop('disabled', false).val('');
            } else {
                $('.field-rendered', parent).prop('disabled', true).val('');
            }

            if (paymentMethods.hasOwnProperty($(selector).val()) && (paymentMethods[$(selector).val()]['type'] == 'ar')) {
                $('.field-notes', parent).attr('placeholder', 'Enter PO number here');
            } else {
                $('.field-notes', parent).removeAttr('placeholder');
            }
        }

        App.subtotalTicketPayment();
    },
    amountTicketPayment: function(selector) {
        let parent = $(selector).parents('.tr').eq(0);

        if ($(selector).val() < 0) {
            $(selector).val(0);
        }

        if (!$('.field-rendered', parent).prop('disabled') && !$.trim($('.field-rendered', parent).val()).length) {
            $('.field-rendered', parent)
                .attr('min', $(selector).val())
                .val($(selector).val());
        }

        App.subtotalTicketPayment();
    },
    renderedTicketPayment: function(selector) {
        let parent = $(selector).parents('.tr').eq(0);

        if ($(selector).val() < $('.field-amount', parent).val()) {
            $(selector).val($('.field-amount', parent).val());
        }

        App.subtotalTicketPayment();
    },
    subtotalTicketPayment: function() {
        if ($('.field-amount', '#payments').length) {
            let total = $('.ticket-total').data('total'),
                balance = 0;

            $('.field-amount', '#payments').each(function () {
                if ($(this).val().length) {
                    let value = parseFloat($(this).val());

                    balance = balance + value;
                }
            });

            $('.ticket-balance').text(((total - balance < 0) ? '-' : (((total - balance > 0) ? '+' : ''))) + '$' + Math.abs((total - balance)).toFixed(2));
        }

        if ($('.field-rendered', '#payments').length) {
            let change = 0;

            $('.field-rendered', '#payments').each(function () {
                $(this).siblings('.badge').remove();

                if ($(this).val().length) {
                    let parent = $(this).parents('.tr').eq(0);
                    let amount = parseFloat($('.field-amount', parent).val());
                    let rendered = parseFloat($(this).val());

                    if (rendered > amount) {
                        change += rendered - amount;
                    }
                }
            });

            if (change) {
                $('.ticket-change').parents('.tr').eq(0).removeClass('d-none');
                $('.ticket-change').text('$' + change.toFixed(2));
            } else {
                $('.ticket-change').parents('.tr').eq(0).addClass('d-none');
            }
        }
    },
    releasesTicketItems: function(selector) {
        if ($('.releases', '#releases').length) {
            $('.releases', '#releases').empty();

            let wrap = $('.wrap', '#releases');

            wrap.addClass('d-none').after('<p>There are no line items to release.</p>');

            $('.tr', selector).each(function (i) {
                let model = '';

                $('.field-model', this).each(function() {
                    if ($(this).val().length) {
                        model = $(this).val();
                    }
                });

                if (($('.field-qty', this).val() != $('.field-released', this).data('released')) && ($('.field-qty', this).val().length != 0) && ($('.field-qty', this).val() > 0)) {
                    if (wrap.hasClass('d-none')) {
                        wrap.removeClass('d-none').siblings('p').remove();
                    }

                    $('.releases', '#releases').append('<div class="tr">' +
                        '<div class="td td-4" data-title="Warehouse">' + $('.field-store', this).val() + '</div>' +
                        '<div class="td td-4" data-title="Type">' + $('.field-type', this).val() + '</div>' +
                        '<div class="td td-6" data-title="ITEM">' + model + '</div>' +
                        '<div class="td td-3" data-title="Quantity">' + $('.field-qty', this).val() + '</div>' +
                        '<div class="td td-3" data-title="Price">' + $('.field-price', this).val() + '</div>' +
                        '<div class="td td-3" data-title="Extension">' + $('.field-total', this).val() + '</div>' +
                        '<div class="td td-1"><input type="checkbox" class="form-check-input" name="ticket[release][' + i + ']" value="' + $('.field-qty', this).val() + '" onclick="App.releaseTicketItem(this)" data-index="' + i + '"' + ($('.field-qty', this).val() == $('.field-released', this).val() ? ' checked' : '') + '></div>' +
                        '</div>'
                    );
                }
            });
        }
    },
    releaseTicketItems: function(all) {
        if ((all === true) && $('.releases', '#releases').length) {

            $('input[type="checkbox"]', '#releases .releases').each(function () {
                $(this).prop('checked', true);
                App.releaseTicketItem(this);
            });
        }
    },
    releaseTicketItem: function(selector) {
        $('.tr', '#items-ticket').each(function (i) {
            if (i == $(selector).data('index')) {
                let release = $('.field-released', this);

                if (!release.data('released')) {
                    release.data('released', release.val());
                }

                let value = release.data('released');

                if ($(selector).prop('checked')) {
                    value = $(selector).val();
                }

                release.children('option').remove();

                release.append($('<option/>', {
                    value: value,
                    text: value
                }));
            }
        });
    },
    isRefundTicketItem: function(selector, modalSelector) {
        if ($(selector).val() === 'Incoming') {
            let modal = Modal.getOrCreateInstance(modalSelector);
            modal.show();
        } else {
            App.subtotalTicketItem(selector);
        }
    },
    toggleRefundDetails: function(selector, target) {
        if ($(selector).prop('checked') && ($(selector).val() !== '1')) {
            $(target).removeClass('d-none');
        } else {
            $(target).addClass('d-none');
        }
    },
    validateRefundItem: function(selector, modalSelector) {
        let parent = $(selector).parents('.tr').eq(0);
        let content = $(selector).parents('.modal-content').eq(0).find('.modal-body').eq(0);
        let condition = '';
        let isValid = true;

        $('.alert', content).remove();

        $('.refund_condition', parent).each(function() {
            if ($(this).prop('checked')) {
                condition = $(this).val();
            }
        });

        if (condition === '') {
            isValid = false;
        } else if (condition === '0') {
            $('.refund_detail', parent).each(function () {
                if ($.trim($(this).val()).length === 0) {
                    isValid = false;
                }
            });
        }

        if (isValid) {
            App.subtotalTicketItem(selector);

            let modal = Modal.getOrCreateInstance(modalSelector);
            modal.hide();
        } else {
            content.append($('<div/>', {
                class: 'alert alert-danger',
                text: 'Please answer all questions'
            }));
        }
    },
    ticketCurrent: function(current) {
        if ($('#' + current).data('validated') == 1) {
            $('#customer .card-body').addClass('d-none');
            $('#customer .card-footer').addClass('d-none');
            $('#salesperson .card-body').addClass('d-none');
            $('#salesperson .card-footer').addClass('d-none');
            $('#items .card-body').addClass('d-none');
            $('#items .card-footer').addClass('d-none');
            $('#payments .card-body').addClass('d-none');
            $('#payments .card-footer').addClass('d-none');
            $('#releases .card-body').addClass('d-none');
            $('#releases .card-footer').addClass('d-none');

            $('#' + current + ' .card-body').removeClass('d-none');
            $('#' + current + ' .card-footer').removeClass('d-none');
        }
    },
    ticketPrev: function(current) {
        $('#' + current + ' .card-body').addClass('d-none');
        $('#' + current + ' .card-footer').addClass('d-none');
        $('.ticket-buttons', '#' + current).addClass('d-none');

        if (current === 'salesperson') {
            $('#customer .card-body').removeClass('d-none');
            $('#customer .card-footer').removeClass('d-none');
        } else if (current === 'items') {
            $('#salesperson .card-body').removeClass('d-none');
            $('#salesperson .card-footer').removeClass('d-none');
        } else if (current === 'payments') {
            $('#items .card-body').removeClass('d-none');
            $('#items .card-footer').removeClass('d-none');
        } else if (current === 'releases') {
            $('#payments .card-body').removeClass('d-none');
            $('#payments .card-footer').removeClass('d-none');
        }
    },
    ticketNext: function(current) {
        let fields = $('input[required], select[required], textarea[required]', '#' + current),
            hasError = false;

        if (fields.length) {
            fields.each(function(i, field) {
                if (!$.trim($(field).val()).length) {
                    hasError = true;
                }
            });

            if (hasError) {
                $('#' + current).parents('form').eq(0).addClass('was-validated');
                Swal.fire({
                    title: 'Error',
                    text: 'Please fill in all the required fields!',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            }
        }

        if (current === 'salesperson') {
            let total = 0,
                num = 0,
                lacksName = false;

            hasError = false;

            $('.ticket_salesperson_name').each(function(i, name) {
                if (!$(name).text().length) {
                    lacksName = true;
                } else {
                    num++;
                }
            });

            if (!num) {
                Swal.fire({
                    title: 'Error',
                    text: 'Please assign a salesperson!',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            }

            if (lacksName) {
                Swal.fire({
                    title: 'Error',
                    text: 'Please select a salesperson from the list!',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            }

            $('.ticket_salesperson_amount').each(function(i, amount) {
                if ($.trim($(amount).val()).length) {
                    if (parseFloat($(amount).val()) == 0) {
                        hasError = true;
                    } else {
                        total += parseFloat($(amount).val());
                    }
                }
            });

            if (hasError) {
                Swal.fire({
                    title: 'Error',
                    text: 'All salespersons must have a percentage assigned to them!',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            }

            if (total != 100) {
                Swal.fire({
                    title: 'Error',
                    text: 'The salespersons percentages must add up to exactly 100%',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            }
        } else if (current === 'items') {
            let total = 0,
                num = 0,
                lacksName = false,
                techs = [];

            hasError = false;

            $('.field-model', '#items').each(function(i, name) {
                if ($(this).val()) {
                    num++;
                }
            });

            if (!num) {
                Swal.fire({
                    title: 'Error',
                    text: 'Please add an item!',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            }

            $('.ticket_item_tech_name').each(function(i, name) {
                if (!$(name).text().length) {
                    lacksName = true;
                }

                let parent = $(name).parents('.techs').eq(0);

                if (techs.indexOf(parent.attr('id')) === -1) {
                    techs.push(parent.attr('id'));
                }
            });

            if (techs.length) {
                if (lacksName) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Please assign a technician from the list!',
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });

                    return false;
                }

                for (const tech of techs) {
                    total = 0;

                    $('.ticket_item_tech_amount', $('#' + tech)).each(function(i, amount) {
                        if ($.trim($(amount).val()).length) {
                            if (parseFloat($(amount).val()) == 0) {
                                hasError = true;
                            } else {
                                total += parseFloat($(amount).val());
                            }
                        }
                    });

                    if (hasError) {
                        Swal.fire({
                            title: 'Error',
                            text: 'All technicians must have a percentage assigned to them!',
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });

                        return false;
                    }

                    if (total != 100) {
                        Swal.fire({
                            title: 'Error',
                            text: 'The technicians percentages must add up to exactly 100%',
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });

                        return false;
                    }
                }
            }
        } else if (current === 'payments') {
            let total = $('.ticket-total').data('total'),
                num = 0,
                balance = 0;

            $('.field-amount', '#payments').each(function () {
                if ($(this).val().length) {
                    num++;
                    let value = parseFloat($(this).val());

                    balance = balance + value;
                }
            });

            if (!num) {
                Swal.fire({
                    title: 'Error',
                    text: 'Please take a payment!',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            }

            if ((total > 0) && (balance != total)) {
                Swal.fire({
                    title: 'Error',
                    text: 'The total payment amount must equal $' + total,
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            }
        }

        $('#' + current).parents('form').eq(0).removeClass('was-validated');

        $('#' + current).data('validated', 1);
        $('#' + current + ' .card-body').addClass('d-none');
        $('#' + current + ' .card-footer').addClass('d-none');

        if (current === 'customer') {
            $('#salesperson .card-body').removeClass('d-none');
            $('#salesperson .card-footer').removeClass('d-none');
        } else if (current === 'salesperson') {
            $('#items .card-body').removeClass('d-none');
            $('#items .card-footer').removeClass('d-none');
        } else if (current === 'items') {
            if ($('#payments').length) {
                $('#payments .card-body').removeClass('d-none');
                $('#payments .card-footer').removeClass('d-none');
            } else if ($('.ticket-buttons').length) {
                $('.ticket-buttons').removeClass('d-none');
            }
        } else if (current === 'payments') {
            if ($('#releases').length) {
                $('#releases .card-body').removeClass('d-none');
                $('#releases .card-footer').removeClass('d-none');
            } else if ($('.ticket-buttons').length) {
                $('.ticket-buttons').removeClass('d-none');
            }
        } else if (current === 'releases') {
            if ($('.ticket-buttons').length) {
                $('.ticket-buttons').removeClass('d-none');
            }
        }
    },
    payChangeCorporate: function(typeSelector, positionSelector) {
        const type = $(typeSelector).val();
        const position = $(positionSelector).val();
        let positions = [];

        if (position === 'multiple') {
            $('input[name="pay[positions][]"]').each(function() {
                if ($(this).prop('checked')) {
                    positions.push($(this).val());
                }
            });
        } else {
            positions.push(position);
        }

        if (type === 'Salary') {
            $('#draw-or-salary').text('Monthly Salary');
        } else {
            $('#draw-or-salary').text('Monthly Draw');
        }

        $('.field-hourly').removeClass('d-none');

        if (type === 'Hourly') {
            $('.field-amount').addClass('d-none');
            // $('.field-amount input').val('0.00');
            // $('.field-hourly').removeClass('d-none');
        } else {
            $('.field-amount').removeClass('d-none');
            // $('.field-hourly').addClass('d-none');
            // $('.field-hourly input').val('0.00');
        }

        $('.field-rate').each(function() {
            $(this).addClass('d-none');
            // let input = $(this).find('input').eq(0);
            // $(this).data('value', input.val());
            // input.val('0.00');
        });

        for (const pos of positions) {
            if ((pos === 'sales') || (pos === 'mgr') || (pos === 'dmgr') || (pos === 'rgnl')) {
                $('.field-sales').removeClass('d-none');
                $('.field-store').removeClass('d-none');
                $('.field-market').removeClass('d-none');
                // $('.field-sales input').val($('.field-sales').eq(0).data('value'));
            }

            // if (pos === 'mgr') {
            //     $('.field-store').removeClass('d-none');
            //     // $('.field-store input').val($('.field-store').eq(0).data('value'));
            // }

            // if ((pos === 'dmgr') || (pos === 'rgnl')) {
            //     $('.field-store').removeClass('d-none');
            //     // $('.field-store input').val($('.field-store').eq(0).data('value'));
            //     $('.field-market').removeClass('d-none');
            //     // $('.field-market input').val($('.field-market').eq(0).data('value'));
            // }

            if ((pos === 'install') || (pos === 'baymgr')) {
                $('.field-install').removeClass('d-none');
                // $('.field-install input').val($('.field-install').eq(0).data('value'));
            }

            if (pos === 'tint') {
                $('.field-film').removeClass('d-none');
                // $('.field-film input').val($('.field-film').eq(0).data('value'));
            }

            if ((pos == 'stock') || (pos == 'stockmgr') || (pos == 'visual_manager') || (pos == 'visual_associate')) {
                $('#pay-type').val('Hourly');
                $('.field-amount').addClass('d-none');
                // $('.field-amount input').val('0.00');
                $('.field-hourly').removeClass('d-none');
            }

            if ((pos == 'corporate') || (pos == 'visual_director')) {
                $('#draw-or-salary').text('Monthly Salary');
                $('.field-amount').removeClass('d-none');
                $('.field-hourly').addClass('d-none');
                // $('.field-hourly input').val('0.00');
            }
        }
    },
    payChangePosition: function(selector) {
        const position = $(selector).val();

        $('#managed-stores').addClass('d-none');
        $('#more-positions').addClass('d-none');

        if ((position == 'dmgr') || (position == 'rgnl')) {
            $('#managed-stores').removeClass('d-none');
        } else if (position == 'multiple') {
            $('#more-positions').removeClass('d-none');
        }

        App.payChangeCorporate('#pay-type', '#pay-position');
    },
    payChangeValidate: function(selector) {
        const position = $('#pay-position').val();

        if (position == 'dmgr') {
            let selected = false;

            $('input[name=\'pay[manages][]\']', '#managed-stores').each(function() {
                if ($(this).prop('checked')) {
                    selected = true;
                }
            });

            if (!selected) {
                Swal.fire({
                    title: 'Error',
                    text: 'Please select the managed stores',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            }
        } else if (position == 'multiple') {
            let found = 0;

            $('input[name=\'pay[positions][]\']', '#more-positions').each(function() {
                if ($(this).prop('checked')) {
                    found++;
                }
            });

            if (found < 2) {
                Swal.fire({
                    title: 'Error',
                    text: 'Please select 2 or more positions',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });

                return false;
            } else {
                let primary = false;

                $('input[name=\'pay[primary]\']', '#more-positions').each(function () {
                    if ($(this).prop('checked')) {
                        primary = true;
                    }
                });

                if (!primary) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Please mark one position as primary',
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });

                    return false;
                }
            }
        }

        return true;
    },
    relocateEmployee: function(selector) {
        $('#relocate-store option').each(function() {
            $(this).prop('disabled', false);
        });

        if ($(selector).val()) {
            let text = $(selector).children('option[value="' + $(selector).val() + '"]').eq(0).text(),
                tokens = text.split(' - '),
                store = false,
                name = text;

            if (tokens.length > 1) {
                store = tokens.shift().replace('#', '');
                name = tokens.join(' - ');
            }

            $('#relocate-location').removeClass('d-none');
            $('.employee').text(name);
            $('#relocate-store option').each(function() {
                if ($(this).attr('value') == store) {
                    $(this).prop('disabled', true);
                }
            });
        } else {
            $('#relocate-location').addClass('d-none');
            $('.employee').empty();
        }
    },
    confirmRelocate: function(selector) {
        if ($(selector).data('confirmed') == 1) {
            return true;
        }
        let text = $('#relocate-employee').children('option[value="' + $('#relocate-employee').val() + '"]').eq(0).text(),
            tokens = text.split(' - '),
            from = '',
            to = $('#relocate-store').val(),
            name = text;

        if (tokens.length > 1) {
            from = tokens.shift().replace('#', '');
            name = tokens.join(' - ');
        }

        Swal.fire({
            title: 'Are you sure you want to submit a relocation for ' + name + ' from store ' + from + ' to store ' + to + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            denyButtonColor: '#dc3545',
            cancelButtonColor: '#adb5bd',
            confirmButtonText: 'Yes, Submit'
        }).then((result) => {
            if (result.isConfirmed) {
                $(selector).data('confirmed', 1).submit();
            }
        });

        return false;
    },
    redirectOnIdle: function(url, minutes) {
        resetTimer();

        window.addEventListener('load', resetTimer, true);
        window.addEventListener('mousemove', resetTimer, true);
        window.addEventListener('mousedown', resetTimer, true);
        window.addEventListener('touchstart', resetTimer, true);
        window.addEventListener('touchmove', resetTimer, true);
        window.addEventListener('click', resetTimer, true);
        window.addEventListener('keydown', resetTimer, true);
        window.addEventListener('scroll', resetTimer, true);

        function resetTimer() {
            if (timeout_t) {
                clearTimeout(timeout_t);
            }

            timeout_t = setTimeout(function() {
                window.location.href = '/reset-vehicle?goto=' + url;
            }, minutes * 1000 * 60);
        }

        $('.remove-if-empty').each(function() {
            let children = $('.is-result', this);
            if ((children.length === 0)) {
                $(this).remove();
            } else {
                let hasText = false;

                children.each(function() {
                    if ($.trim($(this).text()).length !== 0) {
                        hasText = true;
                    }
                });

                if (hasText === false) {
                    $(this).remove();
                }
            }
        });
    },
    adDropzone: function(selector) {
        let params = $(selector).data('params');

        if ((params === undefined) || (params === null)) {
            params = {};
        }

        $(selector).dropzone({
            url: serverUrl + "/xhr/media",
            maxFiles: 1,
            paramName: 'file',
            acceptedFiles: '.jpg,.jpeg,.png,.gif,.webp,.avif,.mp4,.webm,.ogv,.av1',
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop file here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            params: params,
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);
                    myDropzone.removeFile(file);

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }

                    if (response.success) {
                        if ((params.preview !== undefined) && (response.content !== undefined)) {
                            $(params.preview).prepend(response.content);
                        }
                    }
                });
            }
        });
    },
    adCarousel: function(selector, btn) {
        const element = document.querySelector(selector);

        $(selector).parent().hover(function() {
            $(btn).removeClass('d-none');
        }, function() {
            $(btn).addClass('d-none');
        });

        let t, obj;
        let start = $(selector).find('.active').data('interval');

        t = setTimeout(function() {
            obj = new Carousel(element);
            obj.next();
        }, start);

        element.addEventListener('slid.bs.carousel', function(e) {
            let videos = e.relatedTarget.querySelectorAll('video');
            if (videos.length) {
                for (let i = 0; i < videos.length; i++) {
                    if (videos[i].paused) {
                        videos[i].load();
                        videos[i].play();
                    }
                }
            }

            clearTimeout(t);
            let duration = $(selector).find('.active').data('interval');

            obj.pause();

            t = setTimeout(function() {
                obj.next();

                if (videos.length) {
                    for (let i = 0; i < videos.length; i++) {
                        if (!videos[i].paused) {
                            videos[i].pause();
                        }
                    }
                }
            }, duration - 1000);
        });
    },
    toggleSetting: function(selector, id) {
        if (window.loading !== true) {
            $.post(
                serverUrl + '/xhr/setting',
                {
                    'id': id,
                    'value': $(selector).prop('checked') ? 1 : 0
                },
                function(response) {
                    window.loading = false;

                    if (response.error) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }
                },
                'json'
            );
        }
    },
    rescheduleEmployee: function(selector) {
        $('#reschedule-days_off_1 option').each(function() {
            $(this).prop('disabled', false);
        });

        $('#reschedule-days_off_2 option').each(function() {
            $(this).prop('disabled', false);
        });

        if ($(selector).val()) {
            $('#reschedule-days').removeClass('d-none');
            $.getJSON(
                serverUrl + '/xhr/user_days_off',
                {
                    'id': $(selector).val()
                },
                function(response) {
                    if (response.error) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }

                    if (response.days_off && response.days_off.length) {
                        $('#reschedule-days_off_1 option').each(function() {
                            if ($(this).attr('value') == response.days_off[0]) {
                                $(this).prop('disabled', true);
                            }
                        });

                        if (response.days_off.length > 1) {
                            $('#reschedule-days_off_2 option').each(function () {
                                if ($(this).attr('value') == response.days_off[1]) {
                                    $(this).prop('disabled', true);
                                }
                            });
                        }
                    }
                }
            );
        } else {
            $('#reschedule-days').addClass('d-none');
        }
    },
    confirmReschedule: function(selector) {
        if ($(selector).data('confirmed') == 1) {
            return true;
        }
        let text = $('#reschedule-employee').children('option[value="' + $('#reschedule-employee').val() + '"]').eq(0).text(),
            tokens = text.split(' - '),
            name = text;

        if (tokens.length > 1) {
            tokens.shift();
            name = tokens.join(' - ');
        }

        Swal.fire({
            title: 'Are you sure you want to submit a change of default dates for ' + name + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            denyButtonColor: '#dc3545',
            cancelButtonColor: '#adb5bd',
            confirmButtonText: 'Yes, Submit'
        }).then((result) => {
            if (result.isConfirmed) {
                $(selector).data('confirmed', 1).submit();
            }
        });

        return false;
    },
    avDropzone: function(selector) {
        let params = $(selector).data('params');

        if ((params === undefined) || (params === null)) {
            params = {};
        }

        $(selector).dropzone({
            url: serverUrl + "/xhr/av",
            maxFiles: 1,
            paramName: 'file',
            acceptedFiles: '.mp3',
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop file here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            params: params,
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);
                    myDropzone.removeFile(file);

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }

                    if (response.success) {
                        if ((params.preview !== undefined) && (response.content !== undefined)) {
                            $(params.preview).prepend(response.content);
                        }
                    }
                });
            }
        });
    },
    toggleByMarket: function(selector, target) {
        if ($(selector).val().length) {
            $(target).removeClass('d-none');
        } else {
            $(target).addClass('d-none');
        }
    },
    audioModal(headline, url) {
        if ($('#modal-audio').length) {
            $('#modal-audio').remove();
        }

        $('body').append($('<div/>', {
            'id': 'modal-audio',
            'class': 'modal fade',
            'tabindex': '-1',
            'role': 'dialog',
            'aria-hidden': 'true',
            'html': '<div class="modal-dialog modal-lg modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title">' + headline + '</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"><audio controls><source src="' + url + '" type="audio/mpeg" /><p><a href="' + url + '">Download</a></audio></div></div></div>'
        }).on('hidden.bs.modal', function () {
            $('audio', '#modal-audio')[0].pause();
            $('#modal-audio').remove();
        }));

        let modal = Modal.getOrCreateInstance(document.querySelector('#modal-audio'));
        modal.show();
    },
    videoModal(headline, url) {
        if ($('#modal-video').length) {
            $('#modal-video').remove();
        }

        $('body').append($('<div/>', {
            'id': 'modal-video',
            'class': 'modal fade',
            'tabindex': '-1',
            'role': 'dialog',
            'aria-hidden': 'true',
            'html': '<div class="modal-dialog modal-lg modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title">' + headline + '</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body">' + url + '</div></div></div>'
        }).on('hidden.bs.modal', function () {
            $('#modal-video').remove();
        }));

        let modal = Modal.getOrCreateInstance(document.querySelector('#modal-video'));
        modal.show();
    },
    scheduleCalendarNote: function(selector, date, user, note) {
        let parent = $(selector).parents('.day').eq(0);
        parent.children('.note').remove();

        $.post(
            serverUrl + '/xhr/schedule_note',
            {
                'day': date,
                'user': user,
                'note': note,
            },
            function(response) {
                if (response.success) {
                    parent.append($('<div/>', {
                        class: 'note',
                        text: note
                    }))
                }
            },
            'json'
        );
    },
    autocompleteUsername: function(selector, target, exclude) {
        $(selector).on('blur', function(e) {
            if (!$.trim($(this).val()).length) {
                $(target).val('');
            }
        });

        $(selector).typeahead(
            {
                highlight: true,
                minLength: 2,
                classNames: {
                    input: 'form-control',
                    hint: 'text-muted',
                    menu: 'dropdown-menu mt-1',
                    dataset: '',
                    suggestion: 'dropdown-item',
                    empty: 'text-muted',
                    open: 'show',
                    cursor: 'text-primary',
                    highlight: 'text-danger',
                }
            },
            {
                name: 'autocomplete',
                limit: 30,
                source: new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: '/xhr/autocomplete_username?q=%QUERY',
                        wildcard: '%QUERY',
                        transform: function (response) {
                            if (response.response !== undefined) {
                                return response.response;
                            } else {
                                return response;
                            }
                        },
                        prepare: function(query, settings) {
                            settings.url = settings.url.replace(/%QUERY/g, encodeURIComponent($.trim(query)) + '&exclude=' + exclude);

                            return settings;
                        }
                    }
                }),
                templates: {
                    suggestion: function (obj) {
                        return $('<div/>', {
                            class: 'widget-typeahead-result',
                            html: obj.suggestion
                        });
                    }
                },
                display: function (obj) {
                    return obj.suggestion;
                }
            }
        ).on('typeahead:select', function (e, suggestion) {
            $(target).val(suggestion.id);
        }).on('typeahead:change', function (e, suggestion) {
            $(target).val(suggestion.id);
        });
    },
    filterChat: function(selector, target) {
        let input = $(selector).eq(0),
            q = $.trim(input.val().toLowerCase()),
            interlocutors = $(target).find('.list-group-item');

        interlocutors.hide().filter(function() {
            let name = $(this).data('name').toLowerCase();
            let initials = $(this).data('initials').toLowerCase();

            return !((name.search(q) === -1) && (initials.search(q) === -1));
        }).show();
    },
    prepareChat: function(selector, wrapper, id, parent) {
        let interlocutor = $('#chat-interlocutor-' + id).eq(0);

        $(selector).on('focus', function(e) {
            if ($(this).html() === '<span class="text-secondary">Message</span>') {
                $(this).html('');
            }
        });

        $(selector).on('blur', function(e) {
            if (!$.trim($(this).text()).length) {
                $(this).html('<span class="text-secondary">Message</span>');
            }
        });

        $(selector).on('keydown', function(e) {
            if ((e.keyCode === 13) && !e.shiftKey) {
                App.submitChat(selector, wrapper, id, parent);

                return false;
            }
        });

        $(selector + '-submit').on('click', function() {
            App.submitChat(selector, wrapper, id, parent);

            return false;
        });

        setInterval(function() {
            $.getJSON(
                serverUrl + '/xhr/chat_refresh',
                {
                    'with': id,
                    'parent': parent,
                },
                function(response) {
                    if (response.success) {
                        $('.latest-subject', interlocutor).text(response.success.subject);
                        $('.latest-message', interlocutor).text(response.success.message);
                        $('.latest-status', interlocutor).removeClass('fa-circle').addClass('fa-circle-check');
                        $('#chat-messages').html(response.success.conversations);
                    }
                },
                'json'
            );
        }, 10000);
    },
    submitChat: function(selector, wrapper, id, parent) {
        let interlocutor = $('#chat-interlocutor-' + id).eq(0);
        let message = $.trim($(selector).html());
        $(selector).text('');

        $('#chat-messages').append($('<div/>', {
            class: 'loading text-end mb-3',
            html: '<i class="fas fa-spinner fa-spin"></i>'
        }));

        $.post(
            serverUrl + '/xhr/chat_reply',
            {
                'format': 'json',
                'with': id,
                'parent': parent,
                'body': message
            },
            function(response) {
                $('.loading', '#chat-messages').remove();

                if (response.success) {
                    $('.latest-subject', interlocutor).text(response.success.subject);
                    $('.latest-message', interlocutor).text(response.success.message);
                    $('.latest-status', interlocutor).removeClass('fa-circle-check').addClass('fa-circle');
                    $(wrapper).append(response.success.body);
                }

                if (response.error) {
                    Swal.fire({
                        title: 'Error',
                        text: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                }
            },
            'json'
        );
    },
    autocompleteEmail: function(selector, target) {
        $(selector).typeahead(
            {
                highlight: true,
                minLength: 2,
                classNames: {
                    input: 'form-control',
                    hint: 'text-muted',
                    menu: 'dropdown-menu mt-1',
                    dataset: '',
                    suggestion: 'dropdown-item',
                    empty: 'text-muted',
                    open: 'show',
                    cursor: 'text-primary',
                    highlight: 'text-danger',
                }
            },
            {
                name: 'autocomplete',
                limit: 30,
                source: new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: '/xhr/autocomplete_email?q=%QUERY',
                        wildcard: '%QUERY',
                        transform: function (response) {
                            if (response.response !== undefined) {
                                return response.response;
                            } else {
                                return response;
                            }
                        }
                    }
                }),
                templates: {
                    suggestion: function (obj) {
                        return $('<div/>', {
                            class: 'widget-typeahead-result',
                            html: obj.suggestion
                        });
                    }
                },
                display: function (obj) {
                    return obj.suggestion;
                }
            }
        ).on('typeahead:select', function (e, suggestion) {
            $(target).val(($(target).val() + "\n" + suggestion.email).trim());
            $(selector).typeahead('val', '');
        });
    },
    generateTitle: function(inputs, target) {
        if ($(target).val().trim() === '') {
            let str = '',
                canGenerate = true;

            if (typeof inputs === 'string') {
                inputs = [ inputs ];
            }

            const monthNames = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];

            $.each(inputs, function(i, v) {
                if (!$(v).val().trim().length) {
                    canGenerate = false;
                } else {
                    if ($(v).is('select')) {
                        let child = $(v).children('option:selected').eq(0);

                        if (child) {
                            if (child.data('caption')) {
                                str = str + ' ' + child.data('caption');
                            } else {
                                str = str + ' ' + child.text();
                            }
                        }
                    } else if ($(v).is('input') && ($(v).attr('type') === 'date')) {
                        let dt = new Date($(v).val());
                        str = str + ' ' + monthNames[dt.getMonth()] + ' ' + dt.getDate() + ', ' + dt.getFullYear();
                    } else {
                        str = str + ' ' + $(v).val();
                    }
                }
            });

            if (canGenerate) {
                $(target).val(str);
            }
        }
    },
    templateRowAdd: function(target, selector, validate) {
        let element = document.querySelector(target);
        let template = document.querySelector(selector);

        if (element) {
            let numChildren = element.children.length;
            element.insertAdjacentHTML('beforeend', template.innerHTML.trim().replaceAll('$INDEX', numChildren + 1));

            if (validate === true) {
                App.autocompleteItem('.model');
            }
        }
    },
    templateRowRemove: function(source, selector) {
        let element = source.closest(selector);

        if (element) {
            element.remove();
        }

        return false;
    },
    addPlanogramCategory: function(market, store, room, category, rows, columns, wrapper) {
        if (!$(category).val()) {
            $(category).focus();
            return false;
        }

        if (!$(rows).val()) {
            $(rows).focus();
            return false;
        }

        if (!$(columns).val()) {
            $(columns).focus();
            return false;
        }

        $(wrapper).prepend($('<div/>', {
            class: 'loading text-center mt-3',
            html: '<i class="fas fa-spinner fa-spin"></i>'
        }));

        $.getJSON(
            serverUrl + '/xhr/planogram_category',
            {
                'market': market,
                'store': store,
                'room': room,
                'category': $(category).val(),
                'rows': $(rows).val(),
                'columns': $(columns).val(),
            },
            function (response) {
                if (response.html) {
                    $('.loading', wrapper).remove();
                    $(wrapper).append(response.html);

                    $(category).children('option[value="' + $(category).val() + '"]').remove();
                    $(category).val('');
                    $(rows).val('');
                    $(columns).val('');

                    App.toggleClass(['#category-add-trigger-' + room, '#category-add-form-' + room], 'd-none');
                }
            },
            'json'
        );
    },
    planogramModelPrice: function(selector, matrix) {
        let model = $(selector);
        let price = model.parents('.parent').eq(0).find('.price');
        let button = model.parents('form').eq(0).find('button[type="submit"]');

        if (model.prop('readonly') === false) {
            if (model.val().trim().length) {
                model.prop('readonly', true);
                button.prop('disabled', true);

                model.after($('<span/>', {
                    class: 'loading input-group-text',
                    html: '<i class="fas fa-spinner fa-spin"></i>'
                }));

                $.getJSON(serverUrl + '/xhr/autocomplete', {
                    matrix: matrix,
                    match: model.val().trim()
                }, function (response) {
                    model.prop('readonly', false);
                    button.prop('disabled', false);
                    model.next('.loading').remove();

                    if (response.product) {
                        price.val(response.product.price);
                    } else {
                        Swal.fire({
                            title: 'Error',
                            text: 'Model entered "' + model.val().trim() + '" does not exist, please check model number',
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                        model.val('');
                    }
                });
            } else {
                price.val('');
            }
        }
    },
    toggleSpecificMarker: function(selector) {
        $(selector).each(function() {
            if ($(this).prop('checked')) {
                $('#market-contact-' + $(this).attr('value')).removeClass('d-none');
            } else {
                $('#market-contact-' + $(this).attr('value')).addClass('d-none');
            }
        });
    },
    attachInvoice: function(question, selector, url) {
        Swal.fire({
            title: question,
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            confirmButtonColor: '#0d6efd',
            denyButtonText: 'No',
            denyButtonColor: '#dc3545',
            cancelButtonText: 'Cancel',
            cancelButtonColor: '#adb5bd'
        }).then((result) => {
            if (result.isConfirmed) {
                $(selector).find('form').attr('action', url);
                const myModal = new Modal(selector);
                myModal.show();
            } else if (result.isDenied) {
                window.location.assign(url);
            }
        });

        return false;
    },
    invoiceDropzone: function(selector) {
        $(selector).dropzone({
            url: serverUrl + "/xhr/invoice",
            maxFiles: 100,
            paramName: 'file',
            acceptedFiles: '.jpg,.jpeg,.png,.gif,.webp,.avif,.pdf,.doc,.docx,.odt,.xls,.xlsx,.ods',
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop file here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);

                    if (response.success) {
                        $(selector).find('.dz-filename').each(function() {
                            if ($(this).children('span').eq(0).text() == file.name) {
                                $(this).append($('<input/>', {
                                    type: 'hidden',
                                    name: 'file[]',
                                    value: response.success
                                }));
                            }
                        });
                    }

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }
                });
            }
        });
    },
    checkTotalInvoiceFiles: function(selector) {
        $('.alert', $(selector)).remove();

        if ($('input[name="file[]"]', $(selector)).length === 0) {
            $(selector).append($('<div/>', {
                class: 'alert alert-danger mt-3',
                text: 'You must upload at least 1 invoice'
            }));
            return false;
        }

        return true;
    },
    addItemSpiffOption: function(selector, market) {
        let id = App.addOption(selector, false, false);

        if (id) {
            App.autocompleteItemSpiff('#loop-field-' + id + '-0', market, true);
            App.autocompleteItemSpiff('#loop-field-' + id + '-1', market, false);
        }
    },
    autocompleteItemSpiff: function(selector, market, pricing) {
        $(selector).each(function() {
            let input = $(this);
            let parent = input.parents('.parent').eq(0);

            input.typeahead(
                {
                    highlight: true,
                    minLength: 2,
                    classNames: {
                        input: 'form-control',
                        hint: 'text-muted',
                        menu: 'dropdown-menu mt-1',
                        dataset: '',
                        suggestion: 'dropdown-item',
                        empty: 'text-muted',
                        open: 'show',
                        cursor: 'text-primary',
                        highlight: 'text-danger',
                    }
                },
                {
                    name: 'autocomplete_inventory',
                    limit: 30,
                    source: new Bloodhound({
                        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                        queryTokenizer: Bloodhound.tokenizers.whitespace,
                        remote: {
                            url: '/xhr/autocomplete_item_spiff?q=%QUERY&market=' + market,
                            wildcard: '%QUERY',
                            transform: function(response) {
                                if (response.response !== undefined) {
                                    return response.response;
                                } else {
                                    return response;
                                }
                            }
                        }
                    }),
                    templates: {
                        suggestion: function(obj) {
                            return $('<div/>', {
                                class: 'widget-typeahead-result',
                                html: obj.value
                            });
                        }
                    },
                    display: function(obj) {
                        return obj.value;
                    }
                }
            ).on('typeahead:select', function(e, suggestion) {
                input.data('display', suggestion.value);

                if (pricing) {
                    parent.find('.set-image').val(suggestion.picture);
                    parent.find('.set-spiff-amount').val(suggestion.amount);
                    parent.find('.set-spiff-price').val(suggestion.price);
                    parent.find('.set-total').val(Math.ceil(parseFloat((suggestion.price * 0.07).toFixed(2)) + parseFloat(suggestion.amount)));

                    if (!suggestion.picture.length) {
                        Swal.fire({
                            title: 'Error',
                            text: 'Image does not exist, you must add product information to CustomSounds.com before data can be pulled',
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }
                }
            }).on('typeahead:change', function (e, suggestion) {
                if (pricing && (suggestion != input.data('display'))) {
                    input.data('display', '');
                    input.val('');
                    parent.find('.set-image').val('');
                    parent.find('.set-spiff-amount').val('');
                    parent.find('.set-spiff-price').val('');
                    parent.find('.set-total').val('');
                }
            });
        });
    },
    validateItem: function(selector, autosave, past_month) {
        $(selector).each(function() {
            let input = $(this);
            input.typeahead(
                {
                    highlight: true,
                    minLength: 2,
                    classNames: {
                        input: 'form-control validate',
                        hint: 'text-muted',
                        menu: 'dropdown-menu mt-1',
                        dataset: '',
                        suggestion: 'dropdown-item',
                        empty: 'text-muted',
                        open: 'show',
                        cursor: 'text-primary',
                        highlight: 'text-danger',
                    }
                },
                {
                    name: 'autocomplete_inventory',
                    limit: 30,
                    source: new Bloodhound({
                        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                        queryTokenizer: Bloodhound.tokenizers.whitespace,
                        remote: {
                            url: '/xhr/validate_item?q=%QUERY',
                            wildcard: '%QUERY',
                            transform: function(response) {
                                if (response.response !== undefined) {
                                    return response.response;
                                } else {
                                    return response;
                                }
                            }
                        }
                    }),
                    templates: {
                        suggestion: function(obj) {
                            return $('<div/>', {
                                class: 'widget-typeahead-result',
                                html: obj.value
                            });
                        }
                    },
                    display: function(obj) {
                        return obj.value;
                    }
                }
            ).on('typeahead:select', function(e, suggestion) {
                input.data('display', suggestion.value);
            }).on('typeahead:change', function (e, suggestion) {
                if (!App.allow_non_items) {
                    if (suggestion != input.data('display')) {
                        input.data('display', '');
                        input.typeahead('val', '');
                    }
                }

                if (autosave) {
                    App.autosaveFourAMonth(input.parents('form').eq(0), past_month);
                }
            }).on('blur', function() {
                if (!App.allow_non_items) {
                    if (input.val() != input.data('display')) {
                        input.data('display', '');
                        input.typeahead('val', '');
                    }
                }
            });
        });
    },
    claimFourAMonth: function(selector, row, field, past_month) {
        let modal = Modal.getOrCreateInstance(document.querySelector('#claimModal'));

        $('#which_1, #which_2, #which_3').children().remove();

        let items = $(selector).parents('.td').eq(0).find('.badge');

        if (items.length > 1) {
            $('#which_1, #which_2, #which_3').append($('<option>', {
                value: '',
                text: 'Choose',
            }));
        }

        items.each(function() {
            $('#which_1, #which_2, #which_3').append($('<option>', {
                value: $(this).text(),
                text: $(this).text(),
            }));
        });

        if (items.length > 1) {
            $('#which_1, #which_2, #which_3').parent().removeClass('d-none');
        } else {
            $('#which_1, #which_2, #which_3').parent().addClass('d-none');
        }

        if (field == 'easy_1') {
            $('#claimModalField').text('Easy Item #1');
        } else if (field == 'easy_2') {
            $('#claimModalField').text('Easy Item #2');
        } else if (field == 'hard_1') {
            $('#claimModalField').text('Hard Item #1');
        } else if (field == 'hard_2') {
            $('#claimModalField').text('Hard Item #2');
        } else if (field == 'mini') {
            $('#claimModalField').text('Mini Bullet');
        } else if (field == 'magic') {
            $('#claimModalField').text('Magic Bullet');
        }

        $('#claimMessage').addClass('d-none').empty();
        $('#claimModalFooter').empty();

        $('#claimModalFooter').append($('<button/>', {
            type: 'button',
            class: 'btn btn-primary',
            text: 'Submit'
        }).on('click', function() {
            if (!$('#which_1').val().length) {
                $('#which_1').focus();
            } else if (!$('#order_1').val().length) {
                $('#order_1').focus();
            } else if ((items.length > 1) && $('#order_2').val().length && !$('#which_2').val().length) {
                $('#which_2').focus();
            } else if ((items.length > 1) && $('#order_3').val().length && !$('#which_3').val().length) {
                $('#which_3').focus();
            } else {
                $.post(serverUrl + '/xhr/claim_fouramonth', {
                    row: row,
                    field: field,
                    order_1: $('#order_1').val(),
                    order_2: $('#order_2').val(),
                    order_3: $('#order_3').val(),
                    which_1: $('#which_1').val(),
                    which_2: $('#which_2').val(),
                    which_3: $('#which_3').val(),
                    past_month: (past_month === true ? 1 : 0),
                }, function (response) {
                    if (response.success !== undefined) {
                        let badges = $(selector).parents('.td').eq(0).find('.badge');
                        if (badges.eq(0).hasClass('bg-secondary')) {
                            badges.removeClass('bg-secondary').addClass('bg-danger');
                        } else {
                            badges.removeClass('bg-danger').addClass('bg-secondary');
                        }

                        if (response.message) {
                            modal.hide();
                            $('#claimMessage').removeClass('d-none').html(response.message);
                            $('#order_1, #order_2, #order_3').val('');
                        }
                    } else {
                        Swal.fire({
                            title: 'Error',
                            text: 'You cannot currently claim this product',
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }
                }, 'json');
            }
        }));

        modal.show();
    },
    approveFourAMonth: function(selector, user, row, field, past_month) {
        if ($(selector).prop('checked')) {
            $.post(serverUrl + '/xhr/approve_fouramonth', {
                user: user,
                row: row,
                field: field,
                past_month: (past_month === true ? 1 : 0),
            }, function (response) {
                if (response.success !== undefined) {
                    let parent = $(selector).parents('.td').eq(0);
                    parent.removeClass('bg-danger-subtle').addClass('bg-success-subtle');
                    parent.find('.claim').each(function() {
                        $(this).parents('.form-check').remove();
                    });
                    parent.find('.sold').val('1');
                    App.resetAccessCountdown();

                    Swal.fire({
                        title: 'Success',
                        text: response.success,
                        icon: 'success',
                        toast: true,
                        position: 'top-end',
                        timer: 1000,
                        timerProgressBar: true,
                        width: '30em',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                }

                if (response.error !== undefined) {
                    Swal.fire({
                        title: 'Error',
                        text: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                }
            }, 'json');
        }
    },
    denyFourAMonth: function(selector, user, row, field, past_month) {
        if ($(selector).prop('checked')) {
            $.post(serverUrl + '/xhr/deny_fouramonth', {
                user: user,
                row: row,
                field: field,
                past_month: (past_month === true ? 1 : 0),
            }, function (response) {
                if (response.success !== undefined) {
                    let parent = $(selector).parents('.td').eq(0);
                    parent.removeClass('bg-danger-subtle');
                    parent.find('.claim').each(function() {
                        $(this).parents('.form-check').remove();
                    });
                    App.resetAccessCountdown();

                    Swal.fire({
                        title: 'Success',
                        text: response.success,
                        icon: 'success',
                        toast: true,
                        position: 'top-end',
                        timer: 1000,
                        timerProgressBar: true,
                        width: '30em',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                }

                if (response.error !== undefined) {
                    Swal.fire({
                        title: 'Error',
                        text: response.error,
                        icon: 'error',
                        confirmButtonText: 'Close',
                        confirmButtonColor: '#0d6efd',
                        denyButtonColor: '#dc3545',
                        cancelButtonColor: '#adb5bd'
                    });
                }
            }, 'json');
        }
    },
    sellFourAMonth: function(selector, user, row, field, past_month) {
        $.post(serverUrl + '/xhr/sell_fouramonth', {
            sold: ($(selector).prop('checked') ? 1 : 0),
            user: user,
            row: row,
            field: field,
            past_month: (past_month === true ? 1 : 0),
        }, function (response) {
            if (response.success !== undefined) {
                let parent = $(selector).parents('.td').eq(0);
                if ($(selector).prop('checked')) {
                    parent.addClass('bg-success-subtle');
                } else {
                    parent.removeClass('bg-success-subtle');
                }
                App.resetAccessCountdown();

                Swal.fire({
                    title: 'Success',
                    text: response.success,
                    icon: 'success',
                    toast: true,
                    position: 'top-end',
                    timer: 1000,
                    timerProgressBar: true,
                    width: '30em',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });
            }

            if (response.error !== undefined) {
                Swal.fire({
                    title: 'Error',
                    text: response.error,
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });
            }
        }, 'json');
    },
    autosaveFourAMonth: function(form, past_month) {
        $.post(serverUrl + '/xhr/autosave_fouramonth' + (past_month === true ? '?past_month=1' : ''), form.serialize(), function (response) {
            if (response.success !== undefined) {
                App.resetAccessCountdown();
                Swal.fire({
                    title: 'Success',
                    text: response.success,
                    icon: 'success',
                    toast: true,
                    position: 'top-end',
                    timer: 1000,
                    timerProgressBar: true,
                    width: '30em',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });
            }

            if (response.error !== undefined) {
                Swal.fire({
                    title: 'Error',
                    text: response.error,
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });
            }
        }, 'json');
    },
    placeholderFourAMonth: function(selector) {
        let store_no = $(selector).val();
        if (store_no.length) {
            let modal = Modal.getOrCreateInstance(document.querySelector('#placeholderModal'));
            modal.hide();

            let stores = $('.tr').filter(function() {
                return $(this).data('store') == store_no;
            });
            let first = stores.eq(0);
            let last = stores.eq(stores.length - 1);
            let tba = stores.filter(function() {
                return ($(this).data('store') == store_no) && $(this).hasClass('tba');
            });

            let template = first.data('templateTba');

            if ((template !== undefined) && (template !== null)) {
                let id = new Date().getTime() + '_' + (Math.floor(Math.random() * 1000));
                let row = parseInt(last.data('row')) + 1;
                template = template.replace(/\$ROW/g, row).replace(/\$ID/g, id).replace(/\$INDEX/g, (tba.length + 1));

                last.after(template);

                App.validateItem('#row-' + id + ' .model', true);
            }

            $(selector).val('');
        }
    },
    getParentForm: function(selector) {
        return $(selector).parents('form').eq(0);
    },
    copyFourAMonth: function(selector) {
        let parent = $(selector).parents('.parent').eq(0);
        let wrapper = parent.parents('.parent-wrapper').eq(0);
        let canCopy = false;

        if (!parent.hasClass('has-copy')) {
            canCopy = true;
        }

        wrapper.find('.has-copy').removeClass('has-copy');
        wrapper.find('.has-paste').removeClass('has-paste');

        if (canCopy) {
            parent.addClass('has-copy');

            wrapper.find('.parent').each(function(index, value) {
                if (($(value).data('index') == parent.data('index')) && !$(value).hasClass('has-copy')) {
                    $(value).addClass('has-paste');
                }
            });
        }
    },
    pasteFourAMonth: function(selector) {
        let parent = $(selector).parents('.parent').eq(0);
        let wrapper = parent.parents('.parent-wrapper').eq(0);
        let primary = wrapper.find('.has-copy').eq(0);

        if (primary) {
            let copied = wrapper.find('.has-copy').eq(0);
            let models = copied.find('.model.validate');
            let qtys = copied.find('.qty');
            let copy = {};

            models.each(function(index, input) {
                if ($.trim($(input).val()).length) {
                    copy[$(this).val()] = qtys.eq(index).prop('checked') ? 2 : 1;
                }
            });

            let keys = Object.keys(copy);

            if (keys.length) {
                models = parent.find('.model.validate');
                qtys = parent.find('.qty');

                models.each(function(index, input) {
                    if (index > (keys.length - 1)) {
                        $(input).typeahead('val', '');
                        $(input).data('display', '');
                        qtys.eq(index).prop('checked', false);
                    } else {
                        $(input).typeahead('val', keys[index]);
                        $(input).data('display', keys[index]);
                        qtys.eq(index).prop('checked', copy[keys[index]] > 1 ? true : false);
                    }
                });
            }
        }
    },
    maxChecked: function(selector, max) {
        let checked = 0;
        let siblings = $('input[name="' + $(selector).attr('name') + '"]');

        for (const sibling of siblings) {
            if ($(sibling).prop('checked')) {
                checked++;
            }
        }

        return (checked <= max ? true : false);
    },
    onlyLetters: function(selector) {
        $(selector).on('keydown', function(e) {
            const key = e.keyCode;

            return (((key >= 65) && (key <= 90)) || (key == 8) || (key == 9) || (key == 13) || (key == 32));
        });
    },
    moveFormGroupUp: function(selector) {
        let element = $(selector).parents('.form-group').eq(0),
            parent = element.parent(),
            children = parent.children('.form-group'),
            index = children.index(element);

        if (index > 0) {
            children.eq(index - 1).before(element);
        }
    },
    moveFormGroupDown: function(selector) {
        let element = $(selector).parents('.form-group').eq(0),
            parent = element.parent(),
            children = parent.children('.form-group'),
            index = children.index(element);

        if (index < (children.length - 1)) {
            children.eq(index + 1).after(element);
        }
    },
    removeFormGroup: function(selector) {
        $(selector).parents('.form-group').eq(0).remove().detach();
    },
    disableRightClick: function() {
        document.addEventListener('contextmenu', function(e) {
            e.preventDefault();
            e.stopPropagation();
        });
    },
    addRow: function(selector) {
        let parent = $(selector).parents('.parent').eq(0);

        if (parent) {
            let last = parent;
            let siblings = parent.siblings().filter(function() {
                return $(this).data('user') == parent.data('user');
            });

            if (siblings.length) {
                last = siblings.eq(siblings.length - 1);
            }

            let template = parent.data('template');

            if ((template !== undefined) && (template !== null)) {
                let id = new Date().getTime() + '_' + (Math.floor(Math.random() * 1000));
                let row = parseInt(last.data('row')) + 1;
                template = template.replace(/\$ROW/g, row).replace(/\$ID/g, id);

                last.after(template);

                App.validateItem('#row-' + id + ' .model', true);
            }
        }

        return false;
    },
    removeRow: function(selector) {
        if (App.confirm("Are you sure?\nOnce deleted, you will not be able to recover this record!")) {
            let parent = $(selector).parents('.parent').eq(0);

            if (parent) {
                parent.remove();
            }
        }
    },
    assignTest: function(selector) {
        $('#assign-market-wrap').addClass('d-none');
        $('#assign-users-wrap').addClass('d-none');
        $('#assign-confirm-wrap').addClass('d-none');

        if ($(selector).prop('checked')) {
            if ($(selector).val() === 'market') {
                $('#assign-market-wrap').removeClass('d-none');
            } else {
                $('#assign-users-wrap').removeClass('d-none');
            }

            $('#assign-confirm-wrap').removeClass('d-none');
        }
    },
    assignPlaceholder: function(selector) {
        let parent = $(selector).parents('.tba').eq(0);
        if (parent) {
            let users = {};
            let store = parent.data('store');
            let siblings = parent.siblings().filter(function () {
                return ($(this).data('store') == store) && !$(this).hasClass('tba');
            });

            if (siblings.length) {
                for (let i = 0; i < siblings.length; i++) {
                    let userid = $(siblings[i]).data('user');
                    let username = $('.username', siblings[i]).text();
                    let models = $('.model.validate', siblings[i]);
                    let hasModels = false;

                    for (let j = 0; j < models.length; j++) {
                        if ($(models[j]).val().length) {
                            hasModels = true;
                            break;
                        }
                    }

                    if (!hasModels) {
                        users[userid] = username;
                    }
                }
            }

            if (Object.keys(users).length) {
                if ($('#modal-placeholder').length) {
                    $('#modal-placeholder').remove();
                }

                let checkboxes = '';
                for (const userid of Object.keys(users)) {
                    checkboxes += '<div class="form-check"><input class="form-check-input" type="checkbox" value="' + userid + '" name="assign[]" id="assign' + userid + '"><label class="form-check-label" for="assign' + userid + '">' + users[userid] + '</label></div>';
                }

                $('body').append($('<div/>', {
                    'id': 'modal-placeholder',
                    'class': 'modal fade',
                    'tabindex': '-1',
                    'role': 'dialog',
                    'aria-hidden': 'true',
                    'html': '<div class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title" id="formModalLabel">Assign List</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"><form method="post" action="#" onsubmit="return App.doAssignPlaceholder(this, \'#' + parent.attr('id') + '\')">' + checkboxes + '<button class="btn btn-primary w-100 mt-3" type="submit" data-bs-dismiss="modal">Assign</button></form></div></div></div>'
                }));

                let modal = Modal.getOrCreateInstance(document.querySelector('#modal-placeholder'));
                modal.show();
            } else {
                Swal.fire({
                    title: 'Error',
                    text: 'All users from store #' + store + ' have a list assigned',
                    icon: 'error',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#dc3545',
                    cancelButtonColor: '#adb5bd'
                });
            }
        }
    },
    doAssignPlaceholder: function(selector, placeholder) {
        let models = $('.model.validate', $(placeholder));
        let qtys = $('.qty', $(placeholder));
        let users = $('input', selector).filter(function () {
            return $(this).prop('checked');
        });

        if (users.length && models.length) {
            for (const user of users) {
                let items = $('.model.validate', $('.tr[data-user="' + $(user).val() + '"]'));
                let quantities = $('.qty', $('.tr[data-user="' + $(user).val() + '"]'));

                if (items.length) {
                    for (let i = 0; i < models.length; i++) {
                        if (i < items.length) {
                            $(items[i]).typeahead('val', $(models[i]).val());
                            $(items[i]).data('display', $(models[i]).val());
                            $(quantities[i]).prop('checked', $(qtys[i]).prop('checked') ? true : false);
                        }
                    }
                }
            }
        }

        return false;
    },
    sumQuestionRating: function(selector, abort_on_fail) {
        let ratings = $('.question-rating');
        let max = 100;
        let total = 0;

        $(selector).removeClass('text-danger')
            .removeClass('text-success')
            .text('');

        $.each(ratings, function(index, rating) {
            if ($(rating).val().length) {
                total += parseInt($(rating).val());
            }
        });

        if (total > max) {
            $(selector).removeClass('text-success')
                .addClass('text-danger')
                .text('Remove ' + (total - max) + ' points required to save.');

            if (abort_on_fail === true) {
                return false;
            }
        } else if (total < max) {
            $(selector).removeClass('text-success')
                .addClass('text-danger')
                .text((max - total) + ' more rating points required to save.');

            if (abort_on_fail === true) {
                return false;
            }
        } else {
            $(selector).removeClass('text-danger')
                .addClass('text-success')
                .text(max + ' points reached. You can save.');
        }

        return true;
    },
    mediaType: function(selector, target, category, audio, video) {
        if ($(selector).val()) {
            $(target).removeClass('d-none');

            if ($(selector).val() === 'audio') {
                $(audio).removeClass('d-none');
                $(video).addClass('d-none');
            } else {
                $(video).removeClass('d-none');
                $(audio).addClass('d-none');
            }
        } else {
            $(target).addClass('d-none');
            $(audio).addClass('d-none');
            $(video).addClass('d-none');
            $(category).val('');
        }
    },
    mediaCategory: function(selector, target, type, questions) {
        if ($(selector).val()) {
            $(target).removeClass('d-none');
            $(questions).text('');

            if ($(type).val()) {
                $.getJSON(
                    serverUrl + '/xhr/rating_questions',
                    {
                        'mode': $(type).val(),
                        'category': $(selector).val(),
                    },
                    function (response) {
                        if (response.html) {
                            $(questions).html(response.html);
                        }
                    },
                    'json'
                );
            }
        } else {
            $(target).addClass('d-none');
        }
    },
    sumQuestionPercent: function(selector, abort_on_fail) {
        let ratings = $('.question-rating');
        let max = 100;
        let total = 0;

        $(selector).removeClass('text-danger')
            .removeClass('text-success')
            .text('');

        $.each(ratings, function(index, rating) {
            if ($(rating).val().length) {
                total += parseInt($(rating).val());
            }
        });

        $(selector).text(Math.floor((total * 100) / max));

        if (total < max) {
            $(selector).removeClass('text-success')
                .addClass('text-danger');

            if (abort_on_fail === true) {
                return false;
            }
        } else {
            $(selector).removeClass('text-danger')
                .addClass('text-success');
        }

        return true;
    },
    accessCountdown: function(id, minutes) {
        let toast = new Toast(document.getElementById(id), {
            autohide: false
        });
        toast.show();

        if (interval_t) {
            clearTimeout(interval_t);
        }

        interval_counter_initial = minutes;
        interval_counter = minutes;

        interval_t = setInterval(function() {
            if (interval_counter > 0) {
                $('#access-countdown').text(interval_counter);
                interval_counter--;
            } else {
                window.location.assign('/logout');
            }
        }, 1000 * 60);
    },
    resetAccessCountdown: function() {
        interval_counter = interval_counter_initial;
        let countdown = $('#access-countdown');

        if (countdown.length) {
            countdown.text(interval_counter);
        }
    },
    notifyAccessExit: function(id) {
        const sendNotification = function() {
            let data = new FormData();

            if (document.visibilityState === 'hidden') {
                data.append('access_off', id);
            } else {
                data.append('access_on', id);
            }

            navigator.sendBeacon(serverUrl + '/xhr/access_exit', data);
        };

        document.addEventListener('visibilitychange', sendNotification);
        window.addEventListener('beforeunload', sendNotification);
    },
    usersByStore: function(selector, target, preserve) {
        let store = $(selector).val(),
            employee = $(target),
            value = false;

        if (preserve === true) {
            value = employee.val();
        }

        $('option', employee).filter(function() {
            return ($(this).attr('value') != '');
        }).remove();

        $.getJSON(
            serverUrl + '/xhr/employee_by_store',
            {
                'store': store
            },
            function(response) {
                if (response.users) {
                    $.each(response.users, function(i, v) {
                        employee.append($('<option/>', {
                            value: i,
                            text: v
                        }));
                    });

                    if (value !== false) {
                        employee.val(value);
                    }
                }
            }
        );
    },
    absoluteSticky: function(selector, parent) {
        let element = $(selector);
        let offset = $(parent)[0].offsetTop;

        $(window).on('scroll resize orientationchange', function(e) {
            let distance = Math.round($(window).scrollTop());

            if (distance > offset) {
                element.addClass('sticky');
                element[0].style.top = Math.round(distance - offset + 12) + 'px';
            } else {
                element.removeClass('sticky');
                element[0].style.top = 'auto';
            }
        });
    },
    autocompleteItem: function(selector) {
        $(selector).each(function() {
            let input = $(this);

            if (!input.parent().hasClass('twitter-typeahead')) {
                input.typeahead(
                    {
                        highlight: true,
                        minLength: 2,
                        classNames: {
                            input: 'form-control',
                            hint: 'text-muted',
                            menu: 'dropdown-menu mt-1',
                            dataset: '',
                            suggestion: 'dropdown-item',
                            empty: 'text-muted',
                            open: 'show',
                            cursor: 'text-primary',
                            highlight: 'text-danger',
                        }
                    },
                    {
                        name: 'autocomplete_inventory',
                        limit: 30,
                        source: new Bloodhound({
                            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                            queryTokenizer: Bloodhound.tokenizers.whitespace,
                            remote: {
                                url: '/xhr/validate_item?q=%QUERY',
                                wildcard: '%QUERY',
                                transform: function (response) {
                                    if (response.response !== undefined) {
                                        return response.response;
                                    } else {
                                        return response;
                                    }
                                }
                            }
                        }),
                        templates: {
                            suggestion: function (obj) {
                                return $('<div/>', {
                                    class: 'widget-typeahead-result',
                                    html: obj.value
                                });
                            }
                        },
                        display: function (obj) {
                            return obj.value;
                        }
                    }
                ).on('typeahead:select', function (e, suggestion) {
                    input.data('display', suggestion.value);
                }).on('typeahead:change', function (e, suggestion) {
                    if (suggestion != input.data('display')) {
                        input.data('display', '');
                        input.val('');
                    }
                });
            }
        });
    },
    acceptQuote: function(selector) {
        let modalElement = document.querySelector(selector);
        let modal = Modal.getOrCreateInstance(modalElement, {
            keyboard: false
        });
        modal.show();

        modalElement.addEventListener('shown.bs.modal', event => {
            App.setupSignature();
        });
    },
    setupSignature: function() {
        if (!signaturePad) {
            const canvas = document.querySelector("#signature canvas");
            signaturePad = new SignaturePad(canvas, {
                backgroundColor: 'rgb(255, 255, 255)'
            });

            window.addEventListener('resize', App.resizeSignature);
            App.resizeSignature();
        }
    },
    resizeSignature() {
        const canvas = document.querySelector("#signature canvas");
        const ratio =  Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);
        signaturePad.fromData(signaturePad.toData());
    },
    clearSignature: function() {
        if (signaturePad) {
            signaturePad.clear();
        }
    },
    addToInvoice: function(selector) {
        if (!$.trim($('#fname').val()).length) {
            $('#fname').focus();
        } else if (!$.trim($('#lname').val()).length) {
            $('#lname').focus();
        } else if ($.trim($('#phone').val()).length < 12) {
            $('#phone').focus();
        } else if (signaturePad && signaturePad.isEmpty()) {
            Swal.fire({
                title: 'Error',
                text: 'Please provide a signature',
                icon: 'error',
                confirmButtonText: 'Close',
                confirmButtonColor: '#0d6efd',
                denyButtonColor: '#dc3545',
                cancelButtonColor: '#adb5bd'
            });
        } else {
            $(selector).parent().addClass('d-none');
            $('#print').removeClass('d-none');
        }
    },
    printOrder: function(selector) {
        if (!$.trim($('#fname').val()).length) {
            $('#fname').focus();
        } else if (!$.trim($('#lname').val()).length) {
            $('#lname').focus();
        } else if ($.trim($('#phone').val()).length < 12) {
            $('#phone').focus();
        } else if (!$.trim($('#initials').val()).length) {
            $('#initials').focus();
        } else if (signaturePad && signaturePad.isEmpty()) {
            Swal.fire({
                title: 'Error',
                text: 'Please provide a signature',
                icon: 'error',
                confirmButtonText: 'Close',
                confirmButtonColor: '#0d6efd',
                denyButtonColor: '#dc3545',
                cancelButtonColor: '#adb5bd'
            });
        } else {
            let rep = $('#initials').val().toUpperCase()
            if ((initials !== null) && (typeof initials === 'object') && initials.hasOwnProperty($('#initials').val().toUpperCase())) {
                rep = initials[$('#initials').val().toUpperCase()];
            }

            $('.customer-name').text($('#fname').val() + ' ' + $('#lname').val());
            $('.customer-phone').text(App.formatPhoneNumber($('#phone').val()));
            $('.customer-email').text($('#email').val());
            $('.customer-rep').text(rep);
            $('#signature-placeholder').empty().append($('<img/>', {
                alt: '',
                src: signaturePad.toDataURL(),
                style: 'height:30px;'
            }));

            $.post(
                serverUrl + '/xhr/store_signature',
                {
                    'signature': signaturePad.toDataURL(),
                    'name': $('#fname').val() + ' ' + $('#lname').val(),
                },
                function (response) {
                    if (response.success) {
                        window.location.assign(window.location.href + '&orderno=' + $.trim($('.order-no').eq(0).text()) + '&name=' + $('#fname').val() + ' ' + $('#lname').val() + '&phone=' + App.formatPhoneNumber($('#phone').val()) + '&email=' + $('#email').val() + '&rep=' + rep + '&signature=' + response.success + ($('#attach').prop('checked') ? '&notify=yes' : ''));
                    } else {
                        $('.customer-info').removeClass('d-none');

                        let modalElement = document.querySelector(selector);
                        let modal = Modal.getOrCreateInstance(modalElement, {
                            keyboard: false
                        });
                        modal.hide();

                        setTimeout(function () {
                            window.print();
                        }, 500);
                    }
                },
                'json'
            );

            // if ($('#attach').prop('checked')) {
            //     let newWindow = window.open();
            //
            //     $.post(
            //         serverUrl + '/xhr/store_signature',
            //         {
            //             'signature': signaturePad.toDataURL(),
            //             'name': $('#fname').val() + ' ' + $('#lname').val(),
            //         },
            //         function (response) {
            //             if (response.success) {
            //                 newWindow.location.assign(window.location.href.replace('print-labor-calculator', 'download-labor-calculator') + '&orderno=' + $.trim($('.order-no').eq(0).text()) + '&name=' + $('#fname').val() + ' ' + $('#lname').val() + '&phone=' + App.formatPhoneNumber($('#phone').val()) + '&email=' + $('#email').val() + '&rep=' + rep + '&signature=' + response.success);
            //             }
            //
            //             $('.customer-info').removeClass('d-none');
            //
            //             let modalElement = document.querySelector(selector);
            //             let modal = Modal.getOrCreateInstance(modalElement, {
            //                 keyboard: false
            //             });
            //             modal.hide();
            //
            //             setTimeout(function () {
            //                 window.print();
            //             }, 500);
            //         },
            //         'json'
            //     );
            // } else {
            //     $('.customer-info').removeClass('d-none');
            //
            //     let modalElement = document.querySelector(selector);
            //     let modal = Modal.getOrCreateInstance(modalElement, {
            //         keyboard: false
            //     });
            //     modal.hide();
            //
            //     setTimeout(function () {
            //         window.print();
            //     }, 500);
            // }
        }
    },
    specialOrders: function() {
        let how_pay = $('input[name="special[how_pay]"]:checked');
        let post_payment = $('input[name="special[post_payment]"]:checked');
        let order_no = $('input[name="special[order_no]"]');
        let model = $('input[name="special[model_1]"]');
        let how_many = $('input[name="special[how_many]"]:checked');
        let eta = $('input[name="special[eta]"]');
        let wrapper_post_payment = $('#wrapper-special-post_payment');
        let wrapper_model = $('#wrapper-special-model');
        let wrapper_order_no = $('#wrapper-special-order_no');
        let wrapper_how_many = $('#wrapper-special-how_many');
        let wrapper_eta = $('#wrapper-special-eta');

        if (how_pay.length) {
            if ((how_pay.val() === 'Other') || (post_payment.length && (post_payment.val() === 'Yes'))) {
                if (how_pay.val() === 'Other') {
                    wrapper_post_payment.addClass('d-none');
                    post_payment.prop('checked', false);
                }

                wrapper_order_no.removeClass('d-none');

                if (order_no.val()) {
                    wrapper_model.removeClass('d-none');

                    if (model.val()) {
                        wrapper_how_many.removeClass('d-none');

                        if (how_many.length) {
                            wrapper_eta.removeClass('d-none');
                        } else {
                            wrapper_eta.addClass('d-none');
                            eta.val('');
                        }
                    } else {
                        wrapper_how_many.addClass('d-none');
                        how_many.prop('checked', false);
                        wrapper_eta.addClass('d-none');
                        eta.val('');
                    }
                } else {
                    wrapper_model.addClass('d-none');
                    model.val('');
                    wrapper_how_many.addClass('d-none');
                    how_many.prop('checked', false);
                    wrapper_eta.addClass('d-none');
                    eta.val('');
                }
            } else {
                wrapper_post_payment.removeClass('d-none');
                wrapper_order_no.addClass('d-none');
                order_no.val('');
                wrapper_model.addClass('d-none');
                model.val('');
                wrapper_how_many.addClass('d-none');
                how_many.prop('checked', false);
                wrapper_eta.addClass('d-none');
                eta.val('');

                if (post_payment.length) {
                    if (post_payment.val() === 'No') {
                        Swal.fire({
                            title: 'Error',
                            text: 'You may not proceed with this special order. All special orders must be paid in full. With leasing/Financing, you must enter the full payment on the portal and verify it\'s funded and not pending.',
                            icon: 'error',
                            confirmButtonText: 'When you are ready, click here to start over',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload();
                            }
                        });
                    } else {
                        App.specialOrders();
                    }
                }
            }
        }
    },
    uncheckRadio: function(selector) {
        if ($(selector).prop('checked')) {
            $(selector).parent().siblings().children('input').prop('checked', false);
        }
    },
    autoFormDropzone: function() {
        $('.dropzone.auto-form-upload').each(function() {
            App.formDropzone(this);
        });

        $('.dropzone.auto-form-upload-document').each(function() {
            App.formDropzone(this, 'document');
        });

        $('.dropzone.auto-form-upload-picture').each(function() {
            App.formDropzone(this, 'image');
        });
    },
    formDropzone: function(selector, type) {
        let filename = $(selector).data('filename');
        let accepted = '.jpg,.jpeg,.png,.gif,.webp,.avif,.pdf,.doc,.docx,.odt,.xls,.xlsx,.ods';

        if (type == 'image') {
            accepted = '.jpg,.jpeg,.png,.gif,.webp,.avif';
        } else if (type == 'document') {
            accepted = '.pdf,.doc,.docx,.odt,.xls,.xlsx,.ods';
        }

        $(selector).dropzone({
            url: serverUrl + "/xhr/form_upload",
            maxFiles: 100,
            paramName: 'file',
            acceptedFiles: accepted,
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop file here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }

                    if (response.success) {
                        $(file.previewElement).append($('<input/>', {
                            type: 'hidden',
                            name: filename + '[]',
                            value: response.success
                        }));
                    }
                });
            }
        });
    },
    hideEmptyElement: function(selector) {
        $(selector).each(function() {
            if ($.trim($(this).text()).length === 0) {
                $(this).addClass('d-none');
            }
        });
    },
    toggleByXValue: function(selector, target) {
        if ($(selector).val().indexOf('X') !== -1) {
            $(target).removeClass('d-none');
        } else {
            $(target).addClass('d-none');
        }
    },
    toggleMoveSheetDestination: function(selector) {
        let siblings = $('input[name="' + $(selector).attr('name') + '"]');

        for (const sibling of siblings) {
            $('.wrapper-field-' + $(sibling).attr('value')).addClass('d-none');
        }

        if ($(selector).prop('checked')) {
            $('.wrapper-field-' + $(selector).attr('value')).removeClass('d-none');
        } else {
            $('.wrapper-field-' + $(selector).attr('value')).addClass('d-none');
        }
    },
    movesheetInstruction: function(selector, id) {
        $.post(
            serverUrl + '/xhr/movesheet-instruction',
            {
                id: id,
                instruction: $(selector).val()
            },
            function(response) {
                if (response) {
                    if (response.error !== undefined) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else if (response.reload) {
                        window.location.reload();
                    }
                }
            },
            'json'
        );
    },
    movesheetStatus: function(selector, id) {
        $.post(
            serverUrl + '/xhr/movesheet-status',
            {
                id: id,
                status: $(selector).prop('checked') ? 1 : 0
            },
            function(response) {
                if (response) {
                    if (response.error !== undefined) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else if (response.reload) {
                        window.location.reload();
                    }
                }
            },
            'json'
        );
    },
    imageDropzone: function(selector) {
        let params = $(selector).data('params');

        if ((params === undefined) || (params === null)) {
            params = {};
        }

        $(selector).dropzone({
            url: serverUrl + "/xhr/image",
            maxFiles: 1,
            paramName: 'file',
            acceptedFiles: '.jpg,.jpeg,.png,.gif,.webp,.avif',
            addRemoveLinks: true,
            dictDefaultMessage: 'Drop file here<br>or<br>click to upload.',
            dictRemoveFile: 'Remove',
            params: params,
            init: function() {
                let myDropzone = this;

                myDropzone.on('success', function(file, response) {
                    response = $.parseJSON(response);
                    myDropzone.removeFile(file);

                    if (response.error) {
                        myDropzone.removeFile(file);
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    }

                    if (response.success) {
                        if ((params.preview !== undefined) && (response.content !== undefined)) {
                            $(params.preview).prepend(response.content);
                        }
                    }
                });
            }
        });
    },
    chooseOpponent: function(id, name) {
        $('#battleModalLabel').text('Choose a Battle Category');
        $('#battleModalFooter').removeClass('d-none');
        $('#battleOpponents').addClass('d-none');
        $('#battleCategory').removeClass('d-none');
        $('#opponent').val(id);
        $('#opponentName').text(name);
    },
    resetOpponent: function() {
        $('#battleModalLabel').text('Choose an Opponent');
        $('#battleModalFooter').addClass('d-none');
        $('#battleOpponents').removeClass('d-none');
        $('#battleCategory').addClass('d-none');
        $('#opponent').val('');
        $('#opponentName').text('');
        $('input[name="category[]"]').prop('checked', false);
    },
    chooseTransferSales: function(id, name) {
        $('#battleModalFooter').removeClass('d-none');
        $('#battleOpponents').addClass('d-none');
        $('#battleCategory').removeClass('d-none');
        $('#opponent').val(id);
        $('#opponentName').text('to: ' + name);
    },
    resetTransfer: function() {
        $('#battleModalFooter').addClass('d-none');
        $('#battleOpponents').removeClass('d-none');
        $('#battleCategory').addClass('d-none');
        $('#opponent').val('');
        $('#opponentName').text('');
    },
    toggleComplaintNote: function(selector, id) {
        if ($(selector).val() == '') {
            $('#date-' + id).addClass('d-none');
            $('#notes-' + id).addClass('d-none');
            $('#submit-' + id).addClass('d-none');
        } else {
            $('#submit-' + id).removeClass('d-none');

            if ($(selector).val() == '1') {
                $('#date-' + id).removeClass('d-none');
                $('#notes-' + id).addClass('d-none');
                $('#notes-' + id +'-date').prop('required', true);
                $('#notes-' + id +'-details').prop('required', false).val('');
            } else {
                $('#date-' + id).addClass('d-none');
                $('#notes-' + id).removeClass('d-none');
                $('#notes-' + id +'-date').prop('required', false).val('');
                $('#notes-' + id +'-details').prop('required', true);
            }
        }
    },
    submitComplaintNote: function(selector, id) {
        $.post(
            serverUrl + '/xhr/complaint-note',
            $(selector).serialize(),
            function(response) {
                if (response) {
                    if (response.error !== undefined) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else {
                        $('#button-' + id).removeClass('d-none');
                        let form = new Collapse('#collapse' + id);
                        form.hide();
                        $(selector).eq(0)[0].reset();
                        $('#date-' + id).addClass('d-none');
                        $('#notes-' + id).addClass('d-none');
                        $('#submit-' + id).addClass('d-none');

                        if (response.success !== undefined) {
                            $('.notes', $(selector).parents('.parent').eq(0)).html(response.success);
                        }
                    }
                }
            },
            'json'
        );

        return false;
    },
    deleteComplaint: function(selector, id, message) {
        Swal.fire({
            title: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            denyButtonColor: '#dc3545',
            cancelButtonColor: '#adb5bd',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                $.post(serverUrl + '/xhr/complaint-delete', {'id': id}, function (response) {
                    if (response) {
                        if (response.error !== undefined) {
                            Swal.fire({
                                title: 'Error',
                                text: response.error,
                                icon: 'error',
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#0d6efd',
                                denyButtonColor: '#dc3545',
                                cancelButtonColor: '#adb5bd'
                            });
                        } else {
                            $(selector).parents('.card').eq(0).remove();

                            if (response.success !== undefined) {
                                Swal.fire({
                                    title: 'Success',
                                    text: response.success,
                                    icon: 'success',
                                    confirmButtonText: 'Close',
                                    confirmButtonColor: '#0d6efd',
                                    denyButtonColor: '#dc3545',
                                    cancelButtonColor: '#adb5bd'
                                });
                            }
                        }
                    }
                }, 'json');
            }
        });
    },
    resolveComplaint: function(selector, id) {
        $.post(
            serverUrl + '/xhr/complaint-resolve',
            $(selector).serialize(),
            function(response) {
                if (response) {
                    if (response.error !== undefined) {
                        Swal.fire({
                            title: 'Error',
                            text: response.error,
                            icon: 'error',
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#0d6efd',
                            denyButtonColor: '#dc3545',
                            cancelButtonColor: '#adb5bd'
                        });
                    } else {
                        let form = new Collapse('#resolve' + id);
                        form.hide();
                        $(selector).eq(0)[0].reset();

                        if (response.success !== undefined) {
                            $('.notes', $(selector).parents('.parent').eq(0)).html(response.success);
                        }
                    }
                }
            },
            'json'
        );

        return false;
    }
};

$(function() {
    App.init();
});
